import React, { useState, useEffect } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import BarcodeReaderIcon from "@mui/icons-material/BarcodeReader";
import GridViewIcon from "@mui/icons-material/GridView";
import MailIcon from "@mui/icons-material/Mail";
import CachedIcon from "@mui/icons-material/Cached";
import PacientesService from "../services/PacientesService";
import PreciosSucursalService from "../services/PreciosSucursalService";
import DoctoresService from "../services/DoctoresService";
import ConveniosService from "../services/ConveniosService";
import SolicitudesService from "../services/SolicitudesService"
import SucursalesService from "../services/SucursalesService"
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { generarDataUrlQR } from "../utils/qrUtils";
import HorariosAtencionService from "../services/HorariosAtencionService";
import TelefonosService from "../services/TelefonosService";
import ParametrosEstudioService from "../services/ParametrosEstudioService";
import logoLaboratorio from "../img/logo-laboratorio.jpg";
import SolicitudesEstudiosService from "../services/SolicitudesEstudiosService"
import PreciosEstudioService from "../services/PreciosEstudioService";
import EstudiosService from "../services/EstudiosService";
import socketService from "../services/socketService";
import { ejecutarConCargandoPDF } from "../utils/pdfLoadingUtils";
import { filterAndRankEstudios } from "../utils/estudioFilterUtils";

import CotizacionesService from "../services/CotizacionesService";
import CotizacionesEstudiosService from "../services/CotizacionesEstudiosService";
import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/EditSquare";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MuestrasService from "../services/MuestrasService";
import CajaService from "../services/CajaService";
import EstudiosIntService from "../services/EstudiosIntService";
import HistorialEstudiosService from "../services/HistorialEstudiosService";
import HistorialService from "../services/HistorialService";
import CajaPagosService from "../services/CajaPagosService";
import HistoryIcon from "@mui/icons-material/History";
import { abrirModalSeleccionHistorial as abrirModalSeleccionHistorialSwal } from "../utils/HistorialSwal";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DoDisturbAltIcon from '@mui/icons-material/DoDisturbAlt';
import Chip from '@mui/material/Chip';
import {
  CircularProgress,
  Autocomplete,
  Grid,
  TextField,
  FormControl,
  Snackbar,
  Alert,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  Paper,
  Typography,
  OutlinedInput,
  Stack,
  Box,
  IconButton,
  Button,
  Tooltip,
  tooltipClasses,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  InputAdornment,
  Checkbox,
  SvgIcon,
} from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { tieneMasDe10Digitos } from "../utils/telefonoUtils";

const BarcodeIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M2 4h2v16H2V4zm3 0h1v16H5V4zm3 0h2v16H8V4zm4 0h1v16h-1V4zm2 0h3v16h-3V4zm4 0h1v16h-1V4zm2 0h2v16h-2V4z" />
  </SvgIcon>
);

const calcularEdadDesdeFechaNacimiento = (fechaNacStr) => {
  if (!fechaNacStr) return "";
  const dateStr = String(fechaNacStr).trim().split("T")[0];
  if (!dateStr) return "";

  let birthDate;
  if (dateStr.includes("-")) {
    const parts = dateStr.split("-");
    if (parts.length === 3) {
      const [y, m, d] = parts.map(Number);
      if (y && m && d) birthDate = new Date(y, m - 1, d);
    }
  } else if (dateStr.includes("/")) {
    const parts = dateStr.split("/");
    if (parts.length === 3) {
      if (parts[0].length === 4) {
        birthDate = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      } else {
        birthDate = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
      }
    }
  }

  if (!birthDate || isNaN(birthDate.getTime())) return "";

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  birthDate.setHours(0, 0, 0, 0);

  if (birthDate > today) return "";

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  let days = today.getDate() - birthDate.getDate();

  if (days < 0) {
    months--;
    const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += prevMonth.getDate();
  }
  if (months < 0) {
    years--;
    months += 12;
  }

  if (years >= 1) {
    return `${years} AÑOS`;
  } else if (months >= 1) {
    return `${months} MESES`;
  } else if (days >= 0) {
    return `${days} DIAS`;
  }
  return "";
};

const normalizarEdad = (val) => {
  if (!val) return "";
  const str = String(val).trim();
  if (str === "") return "";
  if (/^\d+$/.test(str)) {
    return `${str} AÑOS`;
  }
  return str.toUpperCase().replace(/DÍAS/g, "DIAS");
};

const Solicitudes = () => {

  useEffect(() => {
    document.title = "Solicitudes";
    getPacientes();
    getDoctores();
    getConvenios();
    getSucursales();

    //WebSockets: Escuchar cambios en solicitudes en tiempo real
    const handleSolicitudActualizada = (data) => {
      getPacientes();
    };

    socketService.on("solicitud_actualizada", handleSolicitudActualizada);

    return () => {
      socketService.off("solicitud_actualizada", handleSolicitudActualizada);
    };
  }, []);


  useEffect(() => {
    fetchEstudiosOptions();
    fetchPrecios();
  }, []);

  const parseHora = (value) => {
    if (value === null || value === undefined || value === "" || value === "seleccione") {
      return null;
    }

    const texto = `${value}`.trim();
    if (!texto.includes(":")) return null;

    const [hora, minuto] = texto.split(":");
    const horas = Number(hora);
    const minutos = Number(minuto || 0);

    if (Number.isNaN(horas) || Number.isNaN(minutos)) return null;
    return horas * 60 + minutos;
  };

  const calcularFechaEntrega = (dias) => {
    if (dias === null || dias === undefined || dias === "") return "";

    const texto = `${dias}`.trim();
    const match = texto.match(/-?\d+(?:\.\d+)?/);
    const num = match ? Number(match[0]) : Number(texto);

    if (Number.isNaN(num) || num < 0) return "";

    const fecha = new Date();
    fecha.setDate(fecha.getDate() + num);
    const yyyy = fecha.getFullYear();
    const mm = String(fecha.getMonth() + 1).padStart(2, "0");
    const dd = String(fecha.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const normalizarBooleano = (value) => {
    if (value === true || value === 1 || value === "true" || value === "1" || value === "si" || value === "SI") {
      return true;
    }
    return false;
  };

  const getDiaActual = () => {
    const dia = new Date().getDay();
    const dias = {
      0: "Domingo",
      1: "Lunes",
      2: "Martes",
      3: "Miercoles",
      4: "Jueves",
      5: "Viernes",
      6: "Sabados",
    };
    return dias[dia] || "";
  };

  const normalizarTexto = (value) => {
    if (value === null || value === undefined) return "";
    return `${value}`.trim().toLowerCase();
  };

  const normalizarDia = (value) => {
    const texto = normalizarTexto(value)
      .replace(/\s+/g, "")
      .replace(/[áàäâ]/g, "a")
      .replace(/[éèëê]/g, "e")
      .replace(/[íìïî]/g, "i")
      .replace(/[óòöô]/g, "o")
      .replace(/[úùüû]/g, "u");

    if (["lunesaviernes", "lunesaviernes"].includes(texto)) {
      return "LunesAviernes";
    }

    if (["sabadodomingo", "sabadoydomingo", "sabadosydomingo"].includes(texto)) {
      return "SabadoDomingo";
    }

    const diasMap = {
      lunes: "Lunes",
      martes: "Martes",
      miercoles: "Miercoles",
      jueves: "Jueves",
      viernes: "Viernes",
      sabados: "Sabados",
      domingo: "Domingo",
    };

    return diasMap[texto] || `${value}`.trim();
  };

  const cumpleDia = (diasConfig, diaActual) => {
    if (!diasConfig || diasConfig === "seleccione") return false;

    const valor = normalizarDia(diasConfig);
    const dia = normalizarDia(diaActual);

    if (valor === "LunesAviernes") {
      return ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes"].includes(dia);
    }

    if (valor === "SabadoDomingo") {
      return ["Sabados", "Domingo"].includes(dia);
    }

    return valor === dia;
  };

  async function getPacientes() {
    const resultado = await PacientesService.getPacientes();
    setPacientes(resultado.data.pacientes);
  }
  async function getDoctores() {
    const resultado = await DoctoresService.getDoctores();
    setDoctores(resultado.data.doctores);
  }
  async function getConvenios() {
    const resultado = await ConveniosService.getConvenios();
    setEmpresas(resultado.data.convenios);
  }

  async function getSucursales() {
    const resultado = await SucursalesService.getSucursales();
    setSucursales(resultado.data.sucursales);
  }
  async function fetchEstudiosOptions() {
    try {
      const res = await EstudiosService.getEstudios();
      const data = res.data.estudios || [];
      setEstudiosOptions(data);
    } catch (err) {
      console.error(err);
    }
  }

  async function fetchPrecios() {
    try {
      const resultado = await PreciosEstudioService.getPrecios();
      const data = resultado.data.precios;
      const map = {};
      (data || []).forEach((p) => {
        if (!map[p.idListaPrecio]) {
          map[p.idListaPrecio] = {
            nombre: p.nombreLista, // suponiendo que venga en el resultado
            precios: {}
          };
        }
        map[p.idListaPrecio].precios[p.idEstudio] = p.precio;
      });
      setPreciosByLista(map);
    } catch (err) {
      console.error(err);
    }
  }

  function mostrarMensaje(mensaje) {
    Swal.fire({
      title: "",
      text: mensaje,
      icon: "success",
      confirmButtonText: "Aceptar",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  }
  function mostrarMensajeSolicitud(mensaje) {
    Swal.fire({
      title: "",
      text: mensaje,
      icon: "success",
      confirmButtonText: "Aceptar",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.close();
      }
    });
  }
  function mostrarError(mensaje) {
    Swal.fire({
      title: "¡Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }

  function reloadPage() {
    window.location.reload();
  }

  const [hoverImprimirMenu, setHoverImprimirMenu] = useState(false);

  const formatFechaImpresion = (fechaInput) => {
    const dateObj = fechaInput ? new Date(fechaInput) : new Date();
    if (isNaN(dateObj.getTime())) return new Date().toLocaleString();
    const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const dia = String(dateObj.getDate()).padStart(2, "0");
    const mes = meses[dateObj.getMonth()];
    const anio = dateObj.getFullYear();
    const horas = String(dateObj.getHours()).padStart(2, "0");
    const minutos = String(dateObj.getMinutes()).padStart(2, "0");
    return `${dia} ${mes}, ${anio} ${horas}:${minutos} h`;
  };

  const generarBarcode128Canvas = (texto) => {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = 300;
      canvas.height = 70;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      const patterns = [
        "212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213",
        "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132",
        "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211",
        "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313",
        "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331",
        "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111",
        "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214",
        "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111",
        "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141",
        "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141",
        "114131", "311141", "411131", "211412", "211214", "211232", "2331112"
      ];

      const valText = String(texto || "SOLICITUD").trim();
      let codeSeq = [104];
      let checksum = 104;

      for (let i = 0; i < valText.length; i++) {
        const code = valText.charCodeAt(i) - 32;
        if (code >= 0 && code <= 94) {
          codeSeq.push(code);
          checksum += code * (i + 1);
        }
      }

      const checkCode = checksum % 103;
      codeSeq.push(checkCode);
      codeSeq.push(106);

      let x = 10;
      ctx.fillStyle = "#000000";

      for (let idx = 0; idx < codeSeq.length; idx++) {
        const pattern = patterns[codeSeq[idx]];
        if (!pattern) continue;
        for (let p = 0; p < pattern.length; p++) {
          const width = parseInt(pattern[p], 10) * 2;
          if (p % 2 === 0) {
            ctx.fillRect(x, 5, width, 55);
          }
          x += width;
        }
      }
      return canvas.toDataURL("image/png");
    } catch (e) {
      console.error("Error generando código de barras:", e);
      return null;
    }
  };

  const generarPDFSolicitud = async () => {
    const doc = new jsPDF();

    let sucursalActual = (sucursales || []).find(
      (s) => String(s.nombre).toLowerCase() === String(sucursalNombre).toLowerCase()
    ) || (sucursales || [])[0] || {};

    let sucursalTelefonosStr = "";
    let horariosFormateados = [];

    if (sucursalActual.idSucursal) {
      try {
        const resTels = await TelefonosService.getTelefonosPorSucursal(sucursalActual.idSucursal);
        const listaTels = Array.isArray(resTels) ? resTels : resTels?.telefonos || [];
        sucursalTelefonosStr = listaTels.map((t) => t.telefono || t).join(", ");
      } catch (e) {
        console.error("Error obteniendo teléfonos de la sucursal:", e);
      }

      try {
        const resHorarios = await HorariosAtencionService.getHorariosAtencionPorSucursal(sucursalActual.idSucursal);
        const listaHorarios = Array.isArray(resHorarios) ? resHorarios : resHorarios?.horarios || [];

        const porConcepto = {};
        listaHorarios.forEach((h) => {
          const conc = h.concepto || "Laboratorio";
          if (!porConcepto[conc]) porConcepto[conc] = [];
          porConcepto[conc].push(`${h.dias || ""}: ${h.horario || ""}`);
        });

        Object.keys(porConcepto).forEach((conc) => {
          horariosFormateados.push(`Horario de Atención de ${conc} : ${porConcepto[conc].join(", ")}`);
        });
      } catch (e) {
        console.error("Error obteniendo horarios de la sucursal:", e);
      }
    }

    if (horariosFormateados.length === 0) {
      horariosFormateados.push("Horario de Atención de Laboratorio : Lunes a Viernes: 8:00 a 14:00 y 17:00 a 19:00 hrs, Sábado: 8:00 a 14:00 hrs");
    }

    const sucursalNomText = (sucursalActual.nombre || sucursalNombre || "GUERRERO").toUpperCase();
    const calleText = [sucursalActual.calle, sucursalActual.numExterior, sucursalActual.numInterior].filter(Boolean).join(" ");
    const colCpText = `Col. ${sucursalActual.colonia || ""} C.P. ${sucursalActual.cPostal || ""} ${sucursalActual.ciudad || ""}, ${sucursalActual.estado || ""}`;
    const telText = `Tel. ${sucursalTelefonosStr || sucursalActual.telefono || ""}`;

    const nombrePacienteComp = [nombre, apPaterno, apMaterno].filter(Boolean).join(" ") || "PACIENTE";
    const doctoresNombresArr = [];
    const doc1Name = [nombreDoctor, apPaternoDoctor, apMaternoDoctor].filter(Boolean).join(" ");
    if (doc1Name) {
      const isCom1 = Boolean(esComisionD || selectedDoctor?.esComision || selectedDoctor?.conComision);
      doctoresNombresArr.push(doc1Name + (isCom1 ? " *" : ""));
    }
    if (cantidadDoctores >= 2) {
      const doc2Name = [nombreDoctor2, apPaternoDoctor2, apMaternoDoctor2].filter(Boolean).join(" ");
      if (doc2Name) {
        const isCom2 = Boolean(esComisionD2 || selectedDoctor2?.esComision || selectedDoctor2?.conComision);
        doctoresNombresArr.push(doc2Name + (isCom2 ? " *" : ""));
      }
    }
    if (cantidadDoctores === 3) {
      const doc3Name = [nombreDoctor3, apPaternoDoctor3, apMaternoDoctor3].filter(Boolean).join(" ");
      if (doc3Name) {
        const isCom3 = Boolean(esComisionD3 || selectedDoctor3?.esComision || selectedDoctor3?.conComision);
        doctoresNombresArr.push(doc3Name + (isCom3 ? " *" : ""));
      }
    }

    const codigoOrdenStr = solicitudCodigo || cotizacionNumero || "00000000";
    const fechaHoraStr = formatFechaImpresion(solicitudFecha || fecha);
    const barcodeImg = generarBarcode128Canvas(codigoOrdenStr);

    const subtotalVal = subtotalResumen || 0;
    const descuentoVal = descuentoResumen || 0;
    const ivaVal = ivaResumen || 0;
    const totalVal = totalResumen || 0;
    const aCuentaVal = aCuentaMonto || 0;
    const restanteVal = Math.max(0, totalVal - aCuentaVal);
    const estaPagadoCompletamente = (aCuentaVal >= totalVal && totalVal > 0) || esSolicitudPagada;

    const dibujarTicketBlock = async (startY) => {
      try {
        doc.addImage(logoLaboratorio, "JPEG", 14, startY, 45, 30);
      } catch (e) {
        console.error("Error al cargar logo:", e);
      }

      doc.setFillColor(24, 35, 79);
      doc.rect(115, startY, 81, 7, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("Solicitud de Exámenes", 155.5, startY + 5, { align: "center" });

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(8);
      doc.setFont("helvetica", "bold");
      doc.text(sucursalNomText, 196, startY + 11, { align: "right" });

      let currY = startY + 15;
      if (calleText.trim()) {
        const labelDir = "Direcci\u00f3n: ";
        const labelDirWidth = doc.getStringUnitWidth(labelDir) * 8 / doc.internal.scaleFactor;
        const fullDirText = `${labelDir}${calleText}`;
        const fullDirWidth = doc.getStringUnitWidth(fullDirText) * 8 / doc.internal.scaleFactor;
        const dirStartX = 196 - fullDirWidth;
        doc.setFont("helvetica", "bold");
        doc.text(labelDir, dirStartX, currY);
        doc.setFont("helvetica", "normal");
        doc.text(calleText, dirStartX + labelDirWidth, currY);
        currY += 4;
      }
      doc.setFont("helvetica", "normal");
      doc.text(colCpText, 196, currY, { align: "right" });
      currY += 4;
      if (telText.trim() !== "Tel.") {
        doc.text(telText, 196, currY, { align: "right" });
        currY += 4;
      }

      const tieneEmpresa = empresa && String(empresa).trim() !== "" && String(empresa).trim() !== "-";
      const extraEmpresaH = tieneEmpresa ? 4.5 : 0;
      const extraDocH = Math.max(0, doctoresNombresArr.length - 1) * 4.5;
      const boxY = Math.max(startY + 32, currY + 1);
      doc.setDrawColor(200, 220, 240);
      doc.setFillColor(245, 248, 252);
      doc.roundedRect(14, boxY, 125, 23 + extraDocH + extraEmpresaH, 2, 2, "FD");

      let pacY = boxY + 7;
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("Paciente:", 17, pacY);
      doc.setFont("helvetica", "normal");
      doc.text(nombrePacienteComp.toUpperCase(), 37, pacY);

      if (tieneEmpresa) {
        doc.setFontSize(8.5);
        doc.setFont("helvetica", "normal");
        doc.text(`(${String(empresa).trim().toUpperCase()})`, 37, pacY + 4.5);
        pacY += 4.5;
      }

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("Edad:", 17, pacY + 6);
      doc.setFont("helvetica", "normal");
      doc.text(String(edad || "").toUpperCase(), 30, pacY + 6);

      doc.setFont("helvetica", "bold");
      doc.text("Fecha Nacimiento:", 58, pacY + 6);
      doc.setFont("helvetica", "normal");
      doc.text(fechaNac ? fechaNac : "//", 90, pacY + 6);

      doc.setFont("helvetica", "bold");
      doc.text("Dr(a):", 17, pacY + 13);
      doc.setFont("helvetica", "normal");
      if (doctoresNombresArr.length > 0) {
        doctoresNombresArr.forEach((docNom, dIdx) => {
          doc.text(docNom.toUpperCase(), 30, pacY + 13 + dIdx * 4.5);
        });
      } else {
        doc.text("DOCTOR", 30, pacY + 13);
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text(codigoOrdenStr, 169, boxY + 5, { align: "center" });

      if (barcodeImg) {
        doc.addImage(barcodeImg, "PNG", 140, boxY + 7, 56, 9);
      }

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7.5);
      doc.text(fechaHoraStr, 169, boxY + 21, { align: "center" });

      const rowsTable = [];
      (estudios || []).forEach((est) => {
        if (!est.nombre && !est.codigo) return;
        const codEst = est.codigo || est.idEstudio || "";
        const nomEst = (est.nombre || "").toUpperCase();
        const entregaEst = est.fechaEntrega ? `Entrega: ${est.fechaEntrega}` : "";
        const impVal = Number(est.costo || 0);

        rowsTable.push([
          codEst,
          {
            content: nomEst + (entregaEst ? `  ${entregaEst}` : ""),
            _entregaLabel: entregaEst,
            _nomEst: nomEst,
          },
          { content: `$ ${impVal.toFixed(2)}`, styles: { halign: "right" } },
        ]);
      });

      const boxH = 23 + extraDocH;
      autoTable(doc, {
        startY: boxY + boxH + 4,
        tableWidth: 182,
        margin: { left: 14 },
        head: [
          [
            { content: "CÓDIGO", styles: { halign: "left", cellWidth: 35 } },
            { content: "ESTUDIO", styles: { halign: "left", cellWidth: 115 } },
            { content: "IMPORTE", styles: { halign: "right", cellWidth: 32 } },
          ],
        ],
        body: rowsTable,
        styles: {
          fontSize: 9,
          cellPadding: 1.5,
          valign: "middle",
        },
        headStyles: {
          fillColor: [210, 228, 243],
          textColor: [24, 35, 79],
          fontStyle: "bold",
          fontSize: 9.5,
        },
        alternateRowStyles: { fillColor: [255, 255, 255] },
        didParseCell: (data) => {
          if (data.section === "body" && data.column.index === 1) {
            const raw = data.row.raw;
            const entregaLabel = raw[1]?._entregaLabel || "";
            const nomEstudio = raw[1]?._nomEst || "";
            if (entregaLabel) {
              data.cell.text = [];
              // jspdf-autotable renderiza text[] como texto plano;
              // usamos willDrawCell para renderizar manual
              data.cell._customRender = true;
              data.cell._nomEst = nomEstudio;
              data.cell._entregaLabel = entregaLabel;
            }
          }
        },
        willDrawCell: (data) => {
          if (data.section === "body" && data.column.index === 1 && data.cell._customRender) {
            const x = data.cell.x + data.cell.padding("left");
            const y = data.cell.y + data.cell.height / 2 + 1.5;
            doc.setFontSize(9);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);
            doc.text(data.cell._nomEst + "  ", x, y);
            const nomWidth = doc.getTextWidth(data.cell._nomEst + "  ");
            doc.setFont("helvetica", "bold");
            doc.text(data.cell._entregaLabel, x + nomWidth, y);
            return false;
          }
        },
      });

      const endY = doc.lastAutoTable.finalY + 4;

      doc.setFontSize(9);
      doc.setTextColor(0, 0, 0);

      let horY = endY + 6;
      horariosFormateados.forEach((horLine) => {
        // Separar el título ("Horario de Atención de X :") del resto
        const separador = horLine.indexOf(" : ");
        const titulo = separador !== -1 ? horLine.substring(0, separador + 3) : horLine;
        const resto = separador !== -1 ? horLine.substring(separador + 3) : "";

        // Imprimir título en negritas
        doc.setFont("helvetica", "bold");
        doc.text(titulo, 20, horY);
        const tituloWidth = doc.getTextWidth(titulo);

        if (resto) {
          // Imprimir el resto en normal, en la misma línea si cabe, sino siguiente
          doc.setFont("helvetica", "normal");
          const maxWidth = 105;
          const restoLines = doc.splitTextToSize(resto, maxWidth - tituloWidth);
          doc.text(restoLines[0], 20 + tituloWidth, horY);
          if (restoLines.length > 1) {
            horY += 3.8;
            const restantes = restoLines.slice(1).join(" ");
            const splitRest = doc.splitTextToSize(restantes, 105);
            doc.text(splitRest, 20, horY);
            horY += splitRest.length * 3.8;
          } else {
            horY += 3.8;
          }
        } else {
          horY += 3.8;
        }
      });

      // Código QR de consulta al lado izquierdo al nivel de horarios
      try {
        const qrUrlSol = await generarDataUrlQR(codigoOrdenStr);
        if (qrUrlSol) {
          doc.addImage(qrUrlSol, "PNG", 14, horY + 1, 18, 18);
          doc.setFontSize(5.5);
          doc.setFont("helvetica", "bold");
          doc.setTextColor(24, 35, 79);
          doc.text("Consultar resultados", 14, horY + 21);
        }
      } catch (eQr) {
        console.warn("Error agregando QR a solicitud de exámenes:", eQr);
      }

      let totY = endY;
      doc.setFontSize(9.5);

      const baseVal = Math.max(0, subtotalVal - descuentoVal);
      const ivaVal = requiereFactura ? baseVal * 0.16 : 0;
      const totalValCalculado = baseVal + ivaVal;

      if (subtotalVal > 0) {
        doc.setFont("helvetica", "normal");
        doc.text("Subtotal", 165, totY, { align: "right" });
        doc.text(`$${subtotalVal.toFixed(2)}`, 196, totY, { align: "right" });
        totY += 4;
      }

      if (descuentoVal > 0) {
        doc.setFont("helvetica", "normal");
        doc.text("Descuento", 165, totY, { align: "right" });
        doc.text(`$${descuentoVal.toFixed(2)}`, 196, totY, { align: "right" });
        totY += 4;
      }

      if (requiereFactura && ivaVal > 0) {
        doc.setFont("helvetica", "normal");
        doc.text("IVA (16%)", 165, totY, { align: "right" });
        doc.text(`$${ivaVal.toFixed(2)}`, 196, totY, { align: "right" });
        totY += 4;
      }

      doc.setFont("helvetica", "bold");
      doc.text("Total", 165, totY, { align: "right" });
      doc.text(`$${totalValCalculado.toFixed(2)}`, 196, totY, { align: "right" });
      totY += 4;

      if (aCuentaVal > 0) {
        doc.setFont("helvetica", "normal");
        doc.text("A cuenta", 165, totY, { align: "right" });
        doc.text(`$${aCuentaVal.toFixed(2)}`, 196, totY, { align: "right" });
        totY += 4;
      }

      if (!estaPagadoCompletamente && restanteVal > 0) {
        doc.setFont("helvetica", "bold");
        doc.text("Restante", 165, totY, { align: "right" });
        doc.text(`$${restanteVal.toFixed(2)}`, 196, totY, { align: "right" });
        totY += 5;
      }

      if (estaPagadoCompletamente) {
        totY += 1;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text("P A G A D O", 196, totY, { align: "right" });
        totY += 6;
      }

      return Math.max(horY, totY);
    };

    await dibujarTicketBlock(8);

    doc.setDrawColor(180, 180, 180);
    doc.setLineDashPattern([2, 2], 0);
    doc.line(14, 133, 196, 133);
    doc.setLineDashPattern([], 0);

    await dibujarTicketBlock(137);

    const totalPages = doc.internal.getNumberOfPages();
    const avisoPrivacidad = "Dando cumplimiento a lo established por la LEY FEDERAL DE PROTECCIÓN DE DATOS PERSONALES, otorgo mi consentimiento para la recolección y almacenamiento de mis datos personales tales que como nombre, sexo, fecha de nacimiento, dirección, email y teléfono y de ser necesario,se envíe esta información a un laboratorio de referencia con los que tienen convenio el laboratorio, así mismo estoy de acuerdo y autorizo que se me realice la toma de muestra y estoy consciente que constituye un procedimiento invasivo que puede tener efectos no deseables, (la probabilidad de este tipo de complicaciones es muy baja y en caso de presentarse suelen ser no graves como: hematomas, ardor, dolor leve, etc.)";

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(50, 50, 50);

      const splitAviso = doc.splitTextToSize(avisoPrivacidad, 182);
      doc.text(splitAviso, 14, 267);

      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.text("Firma de Conformidad del paciente ________________________________________", 14, 290);
    }

    const nombreArchivo = `ordenImpresion-${codigoOrdenStr}.pdf`;
    doc.setProperties({ title: nombreArchivo });
    return doc.output("blob", { filename: nombreArchivo });
  };


  const generarOrdenTrabajo = async () => {
    const doc = new jsPDF();
    const pW = 210;
    const mX = 14;
    const cW = pW - mX * 2; // 182mm

    let sucursalActual = (sucursales || []).find(
      (s) => String(s.nombre).toLowerCase() === String(sucursalNombre).toLowerCase()
    ) || (sucursales || [])[0] || {};

    let sucursalTelefonosStr = "";
    if (sucursalActual.idSucursal) {
      try {
        const resTels = await TelefonosService.getTelefonosPorSucursal(sucursalActual.idSucursal);
        const listaTels = Array.isArray(resTels) ? resTels : resTels?.telefonos || [];
        sucursalTelefonosStr = listaTels.map((t) => t.telefono || t).join(", ");
      } catch (e) { console.error("Error teléfonos OT:", e); }
    }

    const sucursalNomText = (sucursalActual.nombre || sucursalNombre || "").toUpperCase();
    const calleText = [sucursalActual.calle, sucursalActual.numExterior, sucursalActual.numInterior].filter(Boolean).join(" ");
    const colCpText = `Col. ${sucursalActual.colonia || ""} C.P. ${sucursalActual.cPostal || ""} ${sucursalActual.ciudad || ""}, ${sucursalActual.estado || ""}`;
    const telText = `Tel. ${sucursalTelefonosStr || sucursalActual.telefono || ""}`;

    const nombrePacienteComp = [nombre, apPaterno, apMaterno].filter(Boolean).join(" ") || "PACIENTE";
    const doctoresNombresArr = [];
    const doc1Name = [nombreDoctor, apPaternoDoctor, apMaternoDoctor].filter(Boolean).join(" ");
    if (doc1Name) {
      const isCom1 = Boolean(esComisionD || selectedDoctor?.esComision || selectedDoctor?.conComision);
      doctoresNombresArr.push(doc1Name + (isCom1 ? " *" : ""));
    }
    if (cantidadDoctores >= 2) {
      const doc2Name = [nombreDoctor2, apPaternoDoctor2, apMaternoDoctor2].filter(Boolean).join(" ");
      if (doc2Name) {
        const isCom2 = Boolean(esComisionD2 || selectedDoctor2?.esComision || selectedDoctor2?.conComision);
        doctoresNombresArr.push(doc2Name + (isCom2 ? " *" : ""));
      }
    }
    if (cantidadDoctores === 3) {
      const doc3Name = [nombreDoctor3, apPaternoDoctor3, apMaternoDoctor3].filter(Boolean).join(" ");
      if (doc3Name) {
        const isCom3 = Boolean(esComisionD3 || selectedDoctor3?.esComision || selectedDoctor3?.conComision);
        doctoresNombresArr.push(doc3Name + (isCom3 ? " *" : ""));
      }
    }

    const codigoOrdenStr = solicitudCodigo || cotizacionNumero || "00000000";
    const fechaHoraStr = formatFechaImpresion(solicitudFecha || fecha);
    const barcodeImg = generarBarcode128Canvas(codigoOrdenStr);

    const normStr = (s) => String(s || "").trim().toUpperCase();

    const formatNombreConMuestra = (nombre, tipoMuestra) => {
      const nom = String(nombre || "").trim();
      const tm = String(tipoMuestra || "").trim();
      if (tm) {
        return `${nom} (${tm})`;
      }
      return nom;
    };

    const cargarRecursivoInt = async (idPadre) => {
      if (!idPadre) return [];
      try {
        const rawInt = await EstudiosIntService.getEstudiosPorEstudio(idPadre);
        const listaInt = Array.isArray(rawInt) ? rawInt : [];
        return await Promise.all(
          listaInt.map(async (sub) => {
            const idSec = sub.idEstudioSec || sub.idEstudio || sub.id_estudio_sec;
            let subDetalle = null;
            let subTipoMuestra = sub.tipoMuestra || "";
            let params = [];
            let subInts = [];
            let registroExamenSub = false;

            if (idSec) {
              try {
                subDetalle = await EstudiosService.getEstudioPorId(idSec);
                if (subDetalle) {
                  registroExamenSub =
                    subDetalle.registroExamenSub === true ||
                    subDetalle.registroExamenSub === 1 ||
                    String(subDetalle.registroExamenSub).toLowerCase() === "si" ||
                    String(subDetalle.registroExamenSub).toLowerCase() === "s";
                }
              } catch (e) { console.error("Error subDetalle OT:", e); }

              try {
                const resMuestras = await MuestrasService.getMuestrasPorEstudio(idSec);
                if (Array.isArray(resMuestras) && resMuestras.length > 0) {
                  subTipoMuestra =
                    resMuestras[0].tipoMuestra ||
                    resMuestras[0].nombreMaterial ||
                    resMuestras[0].material ||
                    subTipoMuestra;
                }
              } catch (e) { console.error("Error muestras sub OT:", e); }

              try {
                const rawSub = await ParametrosEstudioService.getParametrosPorEstudio(idSec);
                params = Array.isArray(rawSub) ? rawSub : rawSub ? [rawSub] : [];
              } catch (e) { console.error("Params sub OT:", e); }

              try {
                subInts = await cargarRecursivoInt(idSec);
              } catch (e) { console.error("Nested estudiosInt OT:", e); }
            }
            return {
              idEstudio: idSec,
              nombre: subDetalle?.nombre || sub.nombre || sub.estudio || sub.nombreEstudio || "",
              tipoMuestra: subTipoMuestra,
              registroExamenSub: registroExamenSub,
              parametros: params,
              estudiosInt: subInts,
            };
          })
        );
      } catch (e) {
        console.error("EstudiosInt OT:", e);
        return [];
      }
    };

    // Fetch parametros y estudiosInt para cada estudio
    const cargarEstudioConDatos = async (est) => {
      if (!est.nombre && !est.codigo) return null;

      const idEst = est.idEstudio;
      let registroExamenSub = false;
      let tipoMuestra = (est.muestras || [])[0]?.tipoMuestra || (est.muestras || [])[0]?.nombreMaterial || "";
      let parametros = [];
      let estudiosIntConParams = [];

      if (idEst) {
        try {
          const estDetalle = await EstudiosService.getEstudioPorId(idEst);
          if (estDetalle) {
            registroExamenSub =
              estDetalle.registroExamenSub === true ||
              estDetalle.registroExamenSub === 1 ||
              String(estDetalle.registroExamenSub).toLowerCase() === "si" ||
              String(estDetalle.registroExamenSub).toLowerCase() === "s";
          }
        } catch (e) { console.error("Error estDetalle main OT:", e); }

        try {
          const resMuestras = await MuestrasService.getMuestrasPorEstudio(idEst);
          if (Array.isArray(resMuestras) && resMuestras.length > 0) {
            tipoMuestra =
              resMuestras[0].tipoMuestra ||
              resMuestras[0].nombreMaterial ||
              resMuestras[0].material ||
              tipoMuestra;
          }
        } catch (e) { console.error("Muestras main OT:", e); }

        try {
          const rawP = await ParametrosEstudioService.getParametrosPorEstudio(idEst);
          parametros = Array.isArray(rawP) ? rawP : rawP ? [rawP] : [];
        } catch (e) { console.error("Params main OT:", e); }

        estudiosIntConParams = await cargarRecursivoInt(idEst);
      }

      return {
        ...est,
        tipoMuestra,
        registroExamenSub,
        parametros,
        estudiosInt: estudiosIntConParams,
      };
    };

    const estudiosConDatos = (await Promise.all((estudios || []).map(cargarEstudioConDatos))).filter(Boolean);

    // === Constantes de layout ===
    const HDR_Y = 8;
    const HDR_H = 40; // hasta donde llega el header
    const PAC_Y = HDR_H;
    const PAC_TAB_H = 6;
    const tieneEmpresaOrden = empresa && String(empresa).trim() !== "" && String(empresa).trim() !== "-";
    const empresaH = tieneEmpresaOrden ? 5 : 0;
    const numDocs = Math.max(1, doctoresNombresArr.length);
    const pacLines = doc.splitTextToSize(nombrePacienteComp.toUpperCase(), 110);
    const pacHeight = pacLines.length * 4.5;
    const docHeight = numDocs * 4.5;
    const PAC_BOX_H = Math.max(34, 7 + empresaH + pacHeight + 5 + docHeight + 7);
    const CONTENT_START = PAC_Y + PAC_TAB_H + PAC_BOX_H + 5;
    const PAGE_BOTTOM = 282;
    const UNDERSCORES = "____________";
    const N_COLS = 3;
    const COL_W = cW / N_COLS; // ~60.7mm

    // === Dibujar encabezado "Orden de Trabajo" ===
    const dibujarHeader = () => {
      try { doc.addImage(logoLaboratorio, "JPEG", mX, HDR_Y, 45, 30); } catch (e) { }

      doc.setFillColor(24, 35, 79);
      doc.rect(115, HDR_Y, 81, 7, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("Orden de Trabajo", 155.5, HDR_Y + 5, { align: "center" });

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(8);
      doc.setFont("helvetica", "bold");
      doc.text(sucursalNomText, 196, HDR_Y + 11, { align: "right" });

      doc.setFont("helvetica", "normal");
      let cY = HDR_Y + 15;
      if (calleText.trim()) {
        const lbDir = "Dirección: ";
        const lbW = doc.getStringUnitWidth(lbDir) * 8 / doc.internal.scaleFactor;
        const fullW = doc.getStringUnitWidth(`${lbDir}${calleText}`) * 8 / doc.internal.scaleFactor;
        const dX = 196 - fullW;
        doc.setFont("helvetica", "bold");
        doc.text(lbDir, dX, cY);
        doc.setFont("helvetica", "normal");
        doc.text(calleText, dX + lbW, cY);
        cY += 4;
      }
      doc.text(colCpText, 196, cY, { align: "right" });
      cY += 4;
      if (telText.trim() !== "Tel.") doc.text(telText, 196, cY, { align: "right" });
    };

    // === Dibujar recuadro paciente ===
    const dibujarPaciente = () => {
      // Tab RECEPCIÓN
      doc.setFillColor(173, 216, 235);
      doc.rect(mX, PAC_Y, 80, PAC_TAB_H, "F");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8.5);
      doc.setTextColor(0, 60, 130);
      doc.text(`RECEPCIÓN: ${fechaHoraStr}`, mX + 2, PAC_Y + 4.2);

      // Box paciente
      const bY = PAC_Y + PAC_TAB_H;
      doc.setDrawColor(100, 149, 220);
      doc.setLineWidth(0.3);
      doc.setFillColor(255, 255, 255);
      doc.rect(mX, bY, cW, PAC_BOX_H, "FD");
      doc.setLineWidth(0.2);
      doc.setTextColor(0, 0, 0);

      let currPacY = bY + 7;
      if (tieneEmpresaOrden) {
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.text("Empresa: ", mX + 2, currPacY);
        doc.setFont("helvetica", "normal");
        doc.text(String(empresa).trim().toUpperCase(), mX + 20, currPacY);
        currPacY += 5;
      }

      // Fila 1: Paciente + No. de Orden
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.text("Paciente: ", mX + 2, currPacY);
      doc.setFont("helvetica", "normal");
      doc.text(pacLines, mX + 20, currPacY);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8.5);
      doc.text("No. de Orden: ", 140, bY + 7);
      doc.setFont("helvetica", "normal");
      doc.text(codigoOrdenStr, 162, bY + 7);

      // Fila 2: Sexo + Edad + Fecha Nac. (debajo del paciente)
      const row2Y = currPacY + pacHeight;
      const sexoTextoFormat = (() => {
        const s = String(sexo || "").trim().toUpperCase();
        if (s === "M" || s === "MASCULINO") return "MASCULINO";
        if (s === "F" || s === "FEMENINO") return "FEMENINO";
        return s;
      })();

      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.text("Sexo: ", mX + 2, row2Y);
      doc.setFont("helvetica", "normal");
      doc.text(sexoTextoFormat, mX + 15, row2Y);

      doc.setFont("helvetica", "bold");
      doc.text("Edad: ", mX + 55, row2Y);
      doc.setFont("helvetica", "normal");
      doc.text(String(edad || ""), mX + 67, row2Y);

      doc.setFont("helvetica", "bold");
      doc.text("Fecha Nac.: ", mX + 95, row2Y);
      doc.setFont("helvetica", "normal");
      doc.text(fechaNac ? fechaNac : "//", mX + 117, row2Y);

      // Fila 3: Dr(a) (uno por renglón)
      const docYBase = row2Y + 6;
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.text("Dr(a): ", mX + 2, docYBase);
      doc.setFont("helvetica", "normal");

      if (doctoresNombresArr.length > 0) {
        doctoresNombresArr.forEach((docNom, dIdx) => {
          doc.text(docNom.toUpperCase(), mX + 17, docYBase + dIdx * 4.5);
        });
      } else {
        doc.text("DOCTOR", mX + 17, docYBase);
      }

      if (barcodeImg) {
        doc.addImage(barcodeImg, "PNG", 140, docYBase - 4, 54, 10);
      }

      // Fila 4: Imprimió (debajo de la lista de doctores)
      const impYBase = docYBase + docHeight + 1;
      doc.setFont("helvetica", "bold");
      doc.text("Imprimió: ", mX + 2, impYBase);
      doc.setFont("helvetica", "normal");
      const userNombreComp = [currentU?.nombre, currentU?.apPaterno, currentU?.apMaterno]
        .filter(Boolean)
        .join(" ");
      const empNombreComp = userNombreComp || currentU?.nombreCompleto || usuario || solicitudInserto || "";
      doc.text(empNombreComp.toUpperCase(), mX + 22, impYBase);
    };

    // === Nueva página con header+paciente ===
    let currentY = CONTENT_START;
    let isFirst = true;

    const nuevaPaginaSiNecesario = (neededH) => {
      if (currentY + neededH > PAGE_BOTTOM) {
        doc.addPage();
        dibujarHeader();
        dibujarPaciente();
        currentY = CONTENT_START;
      }
    };

    // Dibujar primera página
    dibujarHeader();
    dibujarPaciente();

    // === Lógica de generación de cajas para la Orden de Trabajo ===
    const generarCajasParaEstudio = (estudio) => {
      const cajas = [];
      const tieneParamsMain = (estudio.parametros || []).length > 0;
      const tieneInt = (estudio.estudiosInt || []).length > 0;
      const esSub = estudio.registroExamenSub === true;

      if (esSub) {
        // === CASO SUB-EXÁMENES (registroExamenSub = true) ===
        if (tieneParamsMain) {
          // El estudio principal tiene parámetros -> Caja propia para el estudio principal
          cajas.push({
            urgente: estudio.urgente || false,
            fechaEntrega: estudio.fechaEntrega || "",
            elementos: [
              { type: "mainTitle", text: formatNombreConMuestra(estudio.nombre, estudio.tipoMuestra) },
              { type: "paramGrid", params: estudio.parametros },
            ],
          });

          // Cada estudioInt va en sección aparte (recursivo)
          for (const child of estudio.estudiosInt || []) {
            const childCajas = generarCajasParaEstudio(child);
            cajas.push(...childCajas);
          }
        } else {
          // El estudio principal NO tiene parámetros
          if (tieneInt) {
            // El primer estudioInt comparte caja con el título del estudio principal
            const primerChild = estudio.estudiosInt[0];
            const cajasPrimerChild = generarCajasParaEstudio(primerChild);

            if (cajasPrimerChild.length > 0) {
              const primeraCaja = cajasPrimerChild[0];
              primeraCaja.elementos.unshift({
                type: "mainTitle",
                text: formatNombreConMuestra(estudio.nombre, estudio.tipoMuestra),
              });
              primeraCaja.urgente = estudio.urgente || primeraCaja.urgente;
              primeraCaja.fechaEntrega = estudio.fechaEntrega || primeraCaja.fechaEntrega;
              cajas.push(...cajasPrimerChild);
            } else {
              cajas.push({
                urgente: estudio.urgente || false,
                fechaEntrega: estudio.fechaEntrega || "",
                elementos: [
                  { type: "mainTitle", text: formatNombreConMuestra(estudio.nombre, estudio.tipoMuestra) },
                ],
              });
            }

            // El resto de los estudiosInt (2do en adelante) van en secciones aparte
            for (let i = 1; i < estudio.estudiosInt.length; i++) {
              const childCajas = generarCajasParaEstudio(estudio.estudiosInt[i]);
              cajas.push(...childCajas);
            }
          } else {
            // Sin parámetros ni estudiosInt
            cajas.push({
              urgente: estudio.urgente || false,
              fechaEntrega: estudio.fechaEntrega || "",
              elementos: [
                { type: "mainTitle", text: formatNombreConMuestra(estudio.nombre, estudio.tipoMuestra) },
              ],
            });
          }
        }
      } else {
        // === CASO NO SUB-EXÁMENES (registroExamenSub = false) ===
        // Todos se agrupan en una ÚNICA caja
        const elementosBox = [
          { type: "mainTitle", text: formatNombreConMuestra(estudio.nombre, estudio.tipoMuestra) },
        ];

        if (tieneParamsMain) {
          elementosBox.push({ type: "paramGrid", params: estudio.parametros });
        }

        const agregarSubEstudiosMismaCaja = (node) => {
          for (const child of node.estudiosInt || []) {
            const childParams = child.parametros || [];
            const esMismoNombreUnicoParam =
              child.registroExamenSub !== true &&
              childParams.length === 1 &&
              normStr(child.nombre) === normStr(childParams[0]?.parametro || childParams[0]?.nombre);

            if (!esMismoNombreUnicoParam) {
              elementosBox.push({
                type: "subTitle",
                text: formatNombreConMuestra(child.nombre, child.tipoMuestra),
              });
            }

            if (childParams.length > 0) {
              elementosBox.push({ type: "paramGrid", params: childParams });
            }

            if ((child.estudiosInt || []).length > 0) {
              if (child.registroExamenSub !== true) {
                agregarSubEstudiosMismaCaja(child);
              }
            }
          }
        };

        agregarSubEstudiosMismaCaja(estudio);

        cajas.push({
          urgente: estudio.urgente || false,
          fechaEntrega: estudio.fechaEntrega || "",
          elementos: elementosBox,
        });

        // Procesar cualquier hijo anidado que TENGA registroExamenSub = true en cajas separadas
        const agregarSubCajasAparte = (node) => {
          for (const child of node.estudiosInt || []) {
            if (child.registroExamenSub === true) {
              const childCajas = generarCajasParaEstudio(child);
              cajas.push(...childCajas);
            } else if ((child.estudiosInt || []).length > 0) {
              agregarSubCajasAparte(child);
            }
          }
        };
        agregarSubCajasAparte(estudio);
      }

      return cajas;
    };

    const formatParametroSingleLine = (pNom, maxWidth) => {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);

      const getWidth = (str) =>
        (doc.getStringUnitWidth(str) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;

      const nom = String(pNom || "").trim().toUpperCase();
      const defaultText = `${nom} ***____________`;

      if (getWidth(defaultText) <= maxWidth) {
        return defaultText;
      }

      // Probar reduciendo guiones de 11 a 3 para mantener todo en 1 línea
      for (let count = 11; count >= 3; count--) {
        const testText = `${nom} ***${"_".repeat(count)}`;
        if (getWidth(testText) <= maxWidth) {
          return testText;
        }
      }

      // Si el nombre es extraordinariamente largo, recortarlo ligeramente para garantizar ***___ en 1 línea
      let trimmedNom = nom;
      while (trimmedNom.length > 3 && getWidth(`${trimmedNom} ***___`) > maxWidth) {
        trimmedNom = trimmedNom.substring(0, trimmedNom.length - 1);
      }
      return `${trimmedNom} ***___`;
    };

    const calcularBoxH = (caja) => {
      let h = 4; // top padding
      if (caja.urgente && caja.fechaEntrega) h += 5.5;

      for (const el of caja.elementos) {
        if (el.type === "mainTitle") {
          h += 6;
        } else if (el.type === "subTitle") {
          h += 5.5;
        } else if (el.type === "paramGrid") {
          const numP = (el.params || []).length;
          if (numP > 0) {
            const rows = Math.ceil(numP / 3);
            h += rows * 6.5;
          }
        }
      }

      h += 3; // bottom padding
      return Math.max(h, 12);
    };

    const dibujarCajaEstudio = (caja) => {
      const boxH = calcularBoxH(caja);
      nuevaPaginaSiNecesario(boxH + 3);

      // Caja gris
      doc.setDrawColor(180, 180, 180);
      doc.setFillColor(238, 238, 238);
      doc.roundedRect(mX, currentY, cW, boxH, 2, 2, "FD");

      let iY = currentY + 4;

      if (caja.urgente && caja.fechaEntrega) {
        doc.setFont("helvetica", "bolditalic");
        doc.setFontSize(8);
        doc.setTextColor(30, 100, 200);
        doc.text(`Fecha Solicitada: ${caja.fechaEntrega}`, mX + 3, iY);
        iY += 5.5;
      }

      for (const el of caja.elementos) {
        if (el.type === "mainTitle") {
          doc.setFont("helvetica", "bold");
          doc.setFontSize(9);
          doc.setTextColor(0, 70, 160);
          const txt = doc.splitTextToSize(String(el.text || "").toUpperCase(), cW - 6)[0];
          doc.text(txt, mX + 3, iY);
          iY += 6;
        } else if (el.type === "subTitle") {
          doc.setFont("helvetica", "bold");
          doc.setFontSize(8.5);
          doc.setTextColor(24, 35, 79);
          const txt = doc.splitTextToSize(String(el.text || "").toUpperCase(), cW - 6)[0];
          doc.text(txt, mX + 3, iY);
          iY += 5.5;
        } else if (el.type === "paramGrid") {
          const params = el.params || [];
          const numP = params.length;
          if (numP > 0) {
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(8);
            doc.setFont("helvetica", "normal");
            const numCols = 3;
            const colW = cW / numCols;
            let col = 0;
            let row = 0;

            params.forEach((param) => {
              const pNom = param.parametro || param.nombre || "";
              const pText = formatParametroSingleLine(pNom, colW - 2);
              const px = mX + 2 + col * colW;
              const py = iY + row * 6.5;
              doc.text(pText, px, py);
              col++;
              if (col >= numCols) {
                col = 0;
                row++;
              }
            });
            iY += Math.ceil(numP / numCols) * 6.5;
          }
        }
      }

      currentY += boxH + 3;
    };

    // === Iterar estudios principales ===
    for (const estudio of estudiosConDatos) {
      const cajas = generarCajasParaEstudio(estudio);
      for (const caja of cajas) {
        dibujarCajaEstudio(caja);
      }
    }

    const nombreArchivo = `ordenTrabajo-${codigoOrdenStr}.pdf`;
    doc.setProperties({ title: nombreArchivo });
    return { blob: doc.output("blob", { filename: nombreArchivo }), nombre: nombreArchivo };
  };

  const mostrarPDFSolicitud = async () => {
    try {
      await ejecutarConCargandoPDF(
        async () => {
          const [blobSolicitud, resultTicket, resultOrden] = await Promise.all([
            generarPDFSolicitud(),
            generarTicketSolicitud(),
            generarOrdenTrabajo(),
          ]);
          const urlSolicitud = URL.createObjectURL(new Blob([blobSolicitud], { type: "application/pdf" }));
          const urlTicket = URL.createObjectURL(new Blob([resultTicket.blob], { type: "application/pdf" }));
          const urlOrden = URL.createObjectURL(new Blob([resultOrden.blob], { type: "application/pdf" }));

          const codigoStr = solicitudCodigo || cotizacionNumero || "00000000";

          const pdfIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px;"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>`;

          Swal.fire({
            title: "Imprimir Solicitud",
            html: `
              <div style="display:flex;align-items:center;justify-content:flex-end;margin-bottom:8px;">
                <button id="btn-descargar-pdfs" style="
                  display:inline-flex;align-items:center;
                  background:#28a745;color:#fff;border:none;border-radius:6px;
                  padding:8px 18px;font-size:14px;font-weight:600;
                  cursor:pointer;box-shadow:0 2px 6px rgba(40,167,69,0.3);
                  transition:background 0.2s;
                " onmouseover="this.style.background='#218838'" onmouseout="this.style.background='#28a745'">
                  ${pdfIconSvg} Descargar
                </button>
              </div>
              <div style="display:flex;gap:10px;height:560px;">
                <div style="flex:1;display:flex;flex-direction:column;min-width:0;">
                  <p style="margin:0 0 3px;font-weight:600;font-size:12px;">Solicitud de Exámenes (A4)</p>
                  <iframe src="${urlSolicitud}" style="flex:1;border:none;border-radius:6px;width:100%;"></iframe>
                </div>
                <div style="flex:1;display:flex;flex-direction:column;min-width:0;">
                  <p style="margin:0 0 3px;font-weight:600;font-size:12px;">Ticket</p>
                  <iframe src="${urlTicket}" style="flex:1;border:none;border-radius:6px;width:100%;"></iframe>
                </div>
                <div style="flex:1;display:flex;flex-direction:column;min-width:0;">
                  <p style="margin:0 0 3px;font-weight:600;font-size:12px;">Orden de Trabajo</p>
                  <iframe src="${urlOrden}" style="flex:1;border:none;border-radius:6px;width:100%;"></iframe>
                </div>
              </div>`,
            width: "97%",
            showCloseButton: true,
            showConfirmButton: false,
            customClass: { popup: "swal-triple-pdf" },
            didOpen: () => {
              const btnDescargar = document.getElementById("btn-descargar-pdfs");
              if (btnDescargar) {
                btnDescargar.addEventListener("click", () => {
                  const descargar = (blob, nombre) => {
                    const url = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = nombre;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                  };
                  descargar(blobSolicitud, `ordenImpresion-${codigoStr}.pdf`);
                  setTimeout(() => descargar(resultTicket.blob, resultTicket.nombre), 300);
                  setTimeout(() => descargar(resultOrden.blob, resultOrden.nombre), 600);
                });
              }
            },
          });
        },
        "Generando solicitud, ticket y orden de trabajo...",
        "Procesando documentos"
      );
    } catch (error) {
      console.error("Error al generar vista previa del PDF de solicitud:", error);
      mostrarError("No se pudo generar la vista previa del PDF.");
    }
  };

  const handleImprimirSolicitud = () => {
    mostrarPDFSolicitud();
    registrarMovimientoSolicitud("IMP", "Se imprimió la solicitud y el ticket");
  };

  const generarTicketSolicitud = async () => {
    const doc = new jsPDF({ unit: "mm", format: [75, 284], orientation: "portrait" });

    const pageWidth = 75;
    const mX = 4;
    const cW = pageWidth - mX * 2;
    const cx = pageWidth / 2;

    let sucursalActual = (sucursales || []).find(
      (s) => String(s.nombre).toLowerCase() === String(sucursalNombre).toLowerCase()
    ) || (sucursales || [])[0] || {};

    let sucursalTelefonosStr = "";
    let horariosFormateados = [];

    if (sucursalActual.idSucursal) {
      try {
        const resTels = await TelefonosService.getTelefonosPorSucursal(sucursalActual.idSucursal);
        const listaTels = Array.isArray(resTels) ? resTels : resTels?.telefonos || [];
        sucursalTelefonosStr = listaTels.map((t) => t.telefono || t).join(", ");
      } catch (e) { console.error("Error teléfonos:", e); }

      try {
        const resHorarios = await HorariosAtencionService.getHorariosAtencionPorSucursal(sucursalActual.idSucursal);
        const listaHorarios = Array.isArray(resHorarios) ? resHorarios : resHorarios?.horarios || [];
        const porConcepto = {};
        listaHorarios.forEach((h) => {
          const conc = h.concepto || "Laboratorio";
          if (!porConcepto[conc]) porConcepto[conc] = [];
          porConcepto[conc].push(`${h.dias || ""}: ${h.horario || ""}`);
        });
        Object.keys(porConcepto).forEach((conc) => {
          horariosFormateados.push({ titulo: `Horario de Atención de ${conc}:`, horarios: porConcepto[conc].join(", ") });
        });
      } catch (e) { console.error("Error horarios:", e); }
    }

    if (horariosFormateados.length === 0) {
      horariosFormateados.push({ titulo: "Horario de Atención de Laboratorio:", horarios: "Lunes a Viernes: 8:00 a 14:00 y 17:00 a 19:00 hrs, Sábado: 8:00 a 14:00 hrs" });
    }

    const sucursalNomText = (sucursalActual.nombre || sucursalNombre || "").toUpperCase();
    const nombreLab = (sucursalActual.nombreLaboratorio || "LABORATORIO").toUpperCase();
    const leyendaText = sucursalActual.leyenda || "";
    const calleText = [sucursalActual.calle, sucursalActual.numExterior, sucursalActual.numInterior].filter(Boolean).join(" ");
    const colCpText = `Col. ${sucursalActual.colonia || ""} C.P. ${sucursalActual.cPostal || ""} ${sucursalActual.ciudad || ""}, ${sucursalActual.estado || ""}`;
    const telText = `Tel. ${sucursalTelefonosStr || sucursalActual.telefono || ""}`;

    const nombrePacienteComp = [nombre, apPaterno, apMaterno].filter(Boolean).join(" ") || "PACIENTE";
    const doctoresNombresArr = [];
    const doc1Name = [nombreDoctor, apPaternoDoctor, apMaternoDoctor].filter(Boolean).join(" ");
    if (doc1Name) {
      const isCom1 = Boolean(esComisionD || selectedDoctor?.esComision || selectedDoctor?.conComision);
      doctoresNombresArr.push(doc1Name + (isCom1 ? " *" : ""));
    }
    if (cantidadDoctores >= 2) {
      const doc2Name = [nombreDoctor2, apPaternoDoctor2, apMaternoDoctor2].filter(Boolean).join(" ");
      if (doc2Name) {
        const isCom2 = Boolean(esComisionD2 || selectedDoctor2?.esComision || selectedDoctor2?.conComision);
        doctoresNombresArr.push(doc2Name + (isCom2 ? " *" : ""));
      }
    }
    if (cantidadDoctores === 3) {
      const doc3Name = [nombreDoctor3, apPaternoDoctor3, apMaternoDoctor3].filter(Boolean).join(" ");
      if (doc3Name) {
        const isCom3 = Boolean(esComisionD3 || selectedDoctor3?.esComision || selectedDoctor3?.conComision);
        doctoresNombresArr.push(doc3Name + (isCom3 ? " *" : ""));
      }
    }

    const codigoOrdenStr = solicitudCodigo || cotizacionNumero || "00000000";
    const fechaHoraStr = formatFechaImpresion(solicitudFecha || fecha);
    const barcodeImg = generarBarcode128Canvas(codigoOrdenStr);

    const subtotalVal = subtotalResumen || 0;
    const descuentoVal = descuentoResumen || 0;
    const ivaVal = ivaResumen || 0;
    const totalVal = totalResumen || 0;
    const aCuentaVal = aCuentaMonto || 0;
    const restanteVal = Math.max(0, totalVal - aCuentaVal);
    const estaPagado = (aCuentaVal >= totalVal && totalVal > 0) || esSolicitudPagada;

    let y = 4;

    // 1. Logo centrado
    try {
      const lw = 30; const lh = 18;
      doc.addImage(logoLaboratorio, "JPEG", cx - lw / 2, y, lw, lh);
      y += lh + 5;
    } catch (e) { y += 23; }

    // 2. Nombre laboratorio
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8.5);
    doc.setTextColor(0, 0, 0);
    doc.text(nombreLab, cx, y, { align: "center" });
    y += 4;

    // 3. Nombre sucursal
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7.5);
    doc.text(sucursalNomText, cx, y, { align: "center" });
    y += 4;

    // 4. Leyenda
    if (leyendaText) {
      doc.setFontSize(6.5);
      const leyLines = doc.splitTextToSize(leyendaText, cW);
      doc.text(leyLines, cx, y, { align: "center" });
      y += leyLines.length * 3 + 1;
    }

    // 5. Cuadro "Solicitud de Exámenes"
    y += 1;
    doc.setFillColor(24, 35, 79);
    doc.rect(mX, y, cW, 6.5, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.text("Solicitud de Exámenes", cx, y + 4.3, { align: "center" });
    doc.setTextColor(0, 0, 0);
    y += 10;

    // 6. Dirección
    doc.setFontSize(7);
    if (calleText.trim()) {
      doc.setFont("helvetica", "bold");
      doc.text("Dirección: ", mX, y);
      const lbW = doc.getTextWidth("Dirección: ");
      doc.setFont("helvetica", "normal");
      const calleLines = doc.splitTextToSize(calleText, cW - lbW);
      doc.text(calleLines[0], mX + lbW, y);
      if (calleLines.length > 1) {
        y += 3.5;
        doc.text(doc.splitTextToSize(calleLines.slice(1).join(" "), cW), mX, y);
      }
      y += 3.5;
    }
    const colLines = doc.splitTextToSize(colCpText, cW);
    doc.setFont("helvetica", "normal");
    doc.text(colLines, mX, y);
    y += colLines.length * 3.5;
    if (telText.trim() !== "Tel.") {
      doc.text(telText, mX, y);
      y += 3.5;
    }
    y += 2;

    // 7. Recuadro + Tabla info paciente
    const docRows = doctoresNombresArr.length > 0
      ? doctoresNombresArr.map((dName, dIdx) => [dIdx === 0 ? "Dr(a):" : "", dName])
      : [["Dr(a):", "DOCTOR"]];

    const sexoTextoTicket = (() => {
      const s = String(sexo || "").trim().toUpperCase();
      if (s === "M" || s === "MASCULINO") return "MASCULINO";
      if (s === "F" || s === "FEMENINO") return "FEMENINO";
      return s;
    })();

    const userNombreCompTicket = [currentU?.nombre, currentU?.apPaterno, currentU?.apMaterno]
      .filter(Boolean)
      .join(" ");
    const empNombreCompTicket = (userNombreCompTicket || currentU?.nombreCompleto || usuario || solicitudInserto || "").toUpperCase();

    const tieneEmpresaTicket = empresa && String(empresa).trim() !== "" && String(empresa).trim() !== "-";
    const pacNombreTicket = tieneEmpresaTicket
      ? `${nombrePacienteComp} (${String(empresa).trim().toUpperCase()})`
      : nombrePacienteComp;

    const infoRows = [
      ["Paciente:", pacNombreTicket],
      ["Sexo / Edad:", `${sexoTextoTicket} / ${edad || ""}`.trim()],
      ["Fecha Nac.:", fechaNac ? fechaNac : "//"],
      ...docRows,
      ["Fecha solicitud:", fechaHoraStr],
      ["Solicitud:", codigoOrdenStr],
      ["Le atendió:", empNombreCompTicket],
    ];

    const tableStartY = y;
    autoTable(doc, {
      startY: tableStartY + 1,
      margin: { left: mX + 1.5, right: mX + 1.5 },
      tableWidth: cW - 3,
      body: infoRows,
      styles: { fontSize: 7, cellPadding: 0.9, valign: "middle", textColor: [0, 0, 0] },
      columnStyles: {
        0: { fontStyle: "bold", cellWidth: 27 },
        1: { cellWidth: cW - 3 - 27 },
      },
      theme: "plain",
    });

    const boxPacH = doc.lastAutoTable.finalY - tableStartY + 1;
    doc.setDrawColor(200, 220, 240);
    doc.setFillColor(245, 248, 252);
    doc.roundedRect(mX, tableStartY, cW, boxPacH, 2, 2, "FD");

    autoTable(doc, {
      startY: tableStartY + 1,
      margin: { left: mX + 1.5, right: mX + 1.5 },
      tableWidth: cW - 3,
      body: infoRows,
      styles: { fontSize: 7, cellPadding: 0.9, valign: "middle", textColor: [0, 0, 0] },
      columnStyles: {
        0: { fontStyle: "bold", cellWidth: 27 },
        1: { cellWidth: cW - 3 - 27 },
      },
      theme: "plain",
    });
    y = doc.lastAutoTable.finalY + 2;

    // 8. Código de barras
    if (barcodeImg) {
      doc.addImage(barcodeImg, "PNG", mX, y + 3, cW, 14);
      y += 19;
    }

    // 9. Tabla estudios: Estudio | Importe (con Entrega debajo del importe)
    const rowsTicket = [];
    (estudios || []).forEach((est) => {
      if (!est.nombre && !est.codigo) return;
      const nomEst = (est.nombre || "").toUpperCase();
      const impVal = Number(est.costo || 0);
      const entregaStr = est.fechaEntrega ? `Entrega: ${est.fechaEntrega}` : "";
      rowsTicket.push([
        nomEst,
        {
          content: `$ ${impVal.toFixed(2)}${entregaStr ? `\n${entregaStr}` : ""}`,
          styles: { halign: "right", fontStyle: entregaStr ? "normal" : "normal" },
          _entrega: entregaStr,
          _importe: `$ ${impVal.toFixed(2)}`,
        },
      ]);
    });

    autoTable(doc, {
      startY: y,
      margin: { left: mX, right: mX },
      tableWidth: cW,
      head: [
        [
          { content: "ESTUDIO", styles: { halign: "left" } },
          { content: "IMPORTE", styles: { halign: "right" } },
        ],
      ],
      body: rowsTicket,
      styles: { fontSize: 7.5, cellPadding: 1, valign: "top", textColor: [0, 0, 0] },
      headStyles: { fillColor: [210, 228, 243], textColor: [24, 35, 79], fontStyle: "bold", fontSize: 7.5 },
      columnStyles: {
        0: { cellWidth: cW * 0.6 },
        1: { cellWidth: cW * 0.4, halign: "right" },
      },
      didParseCell: (data) => {
        if (data.section === "body" && data.column.index === 1) {
          const raw = data.row.raw;
          if (raw[1]?._entrega) {
            data.cell._customImporte = true;
            data.cell._importe = raw[1]._importe;
            data.cell._entrega = raw[1]._entrega;
            data.cell.text = [raw[1]._importe, raw[1]._entrega];
          }
        }
      },
      willDrawCell: (data) => {
        if (data.section === "body" && data.column.index === 1 && data.cell._customImporte) {
          const x = data.cell.x + data.cell.width - data.cell.padding("right");
          const y0 = data.cell.y + data.cell.padding("top") + 3;
          doc.setFontSize(7.5);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(0, 0, 0);
          doc.text(data.cell._importe, x, y0, { align: "right" });
          doc.setFont("helvetica", "bold");
          doc.setFontSize(6.5);
          doc.text(data.cell._entrega, x, y0 + 3.5, { align: "right" });
          return false;
        }
      },
    });
    y = doc.lastAutoTable.finalY + 3;

    // 10. Totales
    doc.setFontSize(8);
    const totX = mX + cW;

    if (subtotalVal > 0) {
      doc.setFont("helvetica", "normal");
      doc.text("Subtotal", mX + cW * 0.4, y);
      doc.text(`$ ${subtotalVal.toFixed(2)}`, totX, y, { align: "right" });
      y += 4;
    }
    if (descuentoVal > 0) {
      doc.setFont("helvetica", "normal");
      doc.text("Descuento", mX + cW * 0.4, y);
      doc.text(`$ ${descuentoVal.toFixed(2)}`, totX, y, { align: "right" });
      y += 4;
    }
    if (requiereFactura && ivaVal > 0) {
      doc.setFont("helvetica", "normal");
      doc.text("IVA (16%)", mX + cW * 0.4, y);
      doc.text(`$ ${ivaVal.toFixed(2)}`, totX, y, { align: "right" });
      y += 4;
    }
    doc.setFont("helvetica", "bold");
    doc.text("Total", mX + cW * 0.4, y);
    doc.text(`$ ${totalVal.toFixed(2)}`, totX, y, { align: "right" });
    y += 4;
    if (aCuentaVal > 0) {
      doc.setFont("helvetica", "normal");
      doc.text("A cuenta", mX + cW * 0.4, y);
      doc.text(`$ ${aCuentaVal.toFixed(2)}`, totX, y, { align: "right" });
      y += 4;
    }
    if (!estaPagado && restanteVal > 0) {
      doc.setFont("helvetica", "bold");
      doc.text("Restante", mX + cW * 0.4, y);
      doc.text(`$ ${restanteVal.toFixed(2)}`, totX, y, { align: "right" });
      y += 4;
    }

    // 11. PAGADO
    if (estaPagado) {
      y += 6;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.text("P A G A D O", cx, y, { align: "center" });
      y += 8;
    }

    // 12. Horarios
    y += 2;
    doc.setFontSize(7);
    horariosFormateados.forEach(({ titulo, horarios }) => {
      doc.setFont("helvetica", "bold");
      const titLines = doc.splitTextToSize(titulo, cW);
      doc.text(titLines, mX, y);
      y += titLines.length * 3.5;
      doc.setFont("helvetica", "normal");
      const horLines = doc.splitTextToSize(horarios, cW);
      doc.text(horLines, mX, y);
      y += horLines.length * 3.5 + 1;
    });

    // 13. Código QR de consulta en línea al final del ticket
    try {
      const qrUrlTicket = await generarDataUrlQR(codigoOrdenStr);
      if (qrUrlTicket) {
        y += 2;
        doc.addImage(qrUrlTicket, "PNG", cx - 14, y, 28, 28);
        y += 30;
        doc.setFontSize(6.5);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(24, 35, 79);
        doc.text("Escanee para consultar sus resultados en línea", cx, y, { align: "center" });
        y += 4;
      }
    } catch (eQrTicket) {
      console.warn("Error agregando QR al ticket:", eQrTicket);
    }

    const nombreArchivo = `ordenTicket-${codigoOrdenStr}.pdf`;
    doc.setProperties({ title: nombreArchivo });
    return { blob: doc.output("blob", { filename: nombreArchivo }), nombre: nombreArchivo };
  };

  const mostrarTicketSolicitud = async () => {
    try {
      const { blob } = await generarTicketSolicitud();
      const tipedBlob = new Blob([blob], { type: "application/pdf" });
      const url = URL.createObjectURL(tipedBlob);
      Swal.fire({
        title: "Ticket de Solicitud",
        html: `<iframe src="${url}" width="100%" height="520px" style="border:none;"></iframe>`,
        width: "55%",
        showCloseButton: true,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al generar ticket:", error);
      mostrarError("No se pudo generar el ticket.");
    }
  };

  const handleEnviarTicketWhatsApp = async () => {
    const idSol = selectedSolicitudId || solicitudCodigo;
    if (!idSol) {
      mostrarError("Selecciona primero una solicitud para enviar su ticket.");
      return;
    }

    const telefonoInicial = telefonoCelular || selectedPaciente?.telefonoCelular || "";

    const { value: telefono } = await Swal.fire({
      title: "Enviar Ticket por WhatsApp",
      text: "Ingresa el número telefónico al cual deseas enviar el ticket:",
      input: "text",
      inputValue: telefonoInicial,
      inputPlaceholder: "Ej. 5512345678",
      showCancelButton: true,
      confirmButtonText: "Enviar a WhatsApp",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#25D366",
      cancelButtonColor: "#d33",
      inputValidator: (value) => {
        if (!value || value.trim() === "") {
          return "Debes ingresar un número telefónico";
        }
        const numLimpio = value.replace(/\D/g, "");
        if (numLimpio.length > 10) {
          return "El número de teléfono no puede tener más de 10 dígitos";
        }
        if (numLimpio.length < 10) {
          return "Ingresa un número válido de 10 dígitos";
        }
      },
    });

    if (!telefono) return;

    try {
      // 1. Generar el PDF del ticket en el Frontend
      const { blob } = await generarTicketSolicitud();

      // 2. Subir el PDF generado al backend para obtener el token/link de descarga seguro
      const formData = new FormData();
      formData.append("ticketPdf", blob, `ticket_${idSol}.pdf`);
      formData.append("idSolicitud", idSol);

      let linkTicket = "";
      const publicDomain = (process.env.REACT_APP_PUBLIC_DOMAIN || process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || window.location.origin).replace(/\/$/, "");
      try {
        const resp = await SolicitudesService.uploadTicketWhatsApp(formData, idSol);
        const tokenFinal = resp?.data?.token || idSol;
        linkTicket = `${publicDomain}/consultaweb/ticket/${tokenFinal}`;
      } catch (errUpload) {
        console.warn("Backend ticket upload not implemented yet, using default route format:", errUpload);
        linkTicket = `${publicDomain}/consultaweb/ticket/${idSol}`;
      }

      // 3. Formatear teléfono a 10+ dígitos (agregando lada México 521 si es de 10 dígitos)
      let numLimpio = telefono.replace(/\D/g, "");
      if (numLimpio.length === 10) {
        numLimpio = `521${numLimpio}`;
      }

      // 4. Construir el mensaje exacto solicitado
      const mensaje = `Laboratorios García ha enviado su ticket de compra para visualizarlo de clic en el siguiente link : ${linkTicket}`;

      // 5. Redirigir al chat de WhatsApp
      const whatsappUrl = `https://api.whatsapp.com/send?phone=${numLimpio}&text=${encodeURIComponent(mensaje)}`;
      window.open(whatsappUrl, "_blank");

      registrarMovimientoSolicitud("WHA", `Se envió ticket por WhatsApp al número ${numLimpio}`);
    } catch (error) {
      console.error("Error al generar o enviar ticket por WhatsApp:", error);
      mostrarError("No se pudo generar o enviar el enlace del ticket por WhatsApp.");
    }
  };

  const formatSexoEtiqueta = (sexoVal) => {
    if (!sexoVal) return "";
    const s = String(sexoVal).trim().toUpperCase();
    if (s === "M" || s === "MASCULINO" || s.startsWith("MASC")) {
      return "(Masculino)";
    } else if (s === "F" || s === "FEMENINO" || s.startsWith("FEM")) {
      return "(Femenino)";
    }
    return `(${sexoVal})`;
  };

  const formatEdadYFechaEtiqueta = (edadVal, fechaNacVal) => {
    let edadText = String(edadVal || "").trim();
    if (
      edadText &&
      !isNaN(edadText) &&
      !edadText.toLowerCase().includes("año") &&
      !edadText.toLowerCase().includes("mes") &&
      !edadText.toLowerCase().includes("dia")
    ) {
      edadText = `${edadText} años`;
    }

    let fechaNacText = "";
    if (fechaNacVal) {
      const rawDate = String(fechaNacVal).trim().split("T")[0];
      if (rawDate) {
        fechaNacText = rawDate;
      }
    }

    if (edadText && fechaNacText) {
      return `${edadText} (${fechaNacText})`;
    } else if (edadText) {
      return edadText;
    } else if (fechaNacText) {
      return `(${fechaNacText})`;
    }
    return "";
  };

  const handleGenerarEtiquetas = async () => {
    try {
      // Filtrar estudios principales (los que tienen idEstudio)
      const estudiosPrincipales = (estudios || []).filter(
        (e) => e && e.idEstudio && String(e.idEstudio).trim() !== ""
      );

      let filasIniciales = [];

      for (const est of estudiosPrincipales) {
        let muestrasEstudio = est.muestras;

        if (!muestrasEstudio || muestrasEstudio.length === 0) {
          try {
            const res = await MuestrasService.getMuestrasPorEstudio(est.idEstudio);
            if (Array.isArray(res) && res.length > 0) {
              muestrasEstudio = res;
            }
          } catch (err) {
            console.error("Error al obtener muestras para el estudio:", est.idEstudio, err);
          }
        }

        if (muestrasEstudio && muestrasEstudio.length > 0) {
          muestrasEstudio.forEach((m) => {
            filasIniciales.push({
              cantidad: m.numEtiquetas != null && m.numEtiquetas !== "" ? String(m.numEtiquetas) : "1",
              estudio: m.abreviatura || est.nombre || est.codigo || "",
              colorTubo: m.nombreMaterial || "",
            });
          });
        }
      }

      // Si ningún estudio tiene muestras, se agrega una fila con textfield vacíos
      if (filasIniciales.length === 0) {
        filasIniciales.push({
          cantidad: "",
          estudio: "",
          colorTubo: "",
        });
      }

      // Al final siempre debe ir una fila con textfield vacíos
      filasIniciales.push({
        cantidad: "",
        estudio: "",
        colorTubo: "",
      });

      const onGenerarEtiquetasPDF = async (filasParaImprimir) => {
        try {
          await ejecutarConCargandoPDF(
            async () => {
              const doc = new jsPDF({
                orientation: "landscape",
                unit: "mm",
                format: [54, 20],
              });

              const codigoOrdenStr = solicitudCodigo || cotizacionNumero || "00000000";
              const nombrePacienteComp = [nombre, apPaterno, apMaterno].filter(Boolean).join(" ").toUpperCase() || "PACIENTE";
              const sexoFormateado = formatSexoEtiqueta(sexo);
              const edadYFecha = formatEdadYFechaEtiqueta(edad, fechaNac);
              const barcodeImg = generarBarcode128Canvas(codigoOrdenStr);

              const printCenteredText = (pdfDoc, text, y, baseFontSize = 7.5, maxW = 50) => {
                if (!text) return;
                let fontSize = baseFontSize;
                pdfDoc.setFontSize(fontSize);
                while (pdfDoc.getTextWidth(text) > maxW && fontSize > 3.5) {
                  fontSize -= 0.3;
                  pdfDoc.setFontSize(fontSize);
                }
                pdfDoc.text(text, 27, y, { align: "center" });
              };

              let isFirstPage = true;

              filasParaImprimir.forEach((fila) => {
                const cantNum = Math.max(1, parseInt(fila.cantidad, 10) || 1);
                const estudioTxt = String(fila.estudio || "").trim();
                const colorTuboTxt = String(fila.colorTubo || "").trim();

                for (let c = 0; c < cantNum; c++) {
                  if (!isFirstPage) {
                    doc.addPage([54, 20], "landscape");
                  } else {
                    isFirstPage = false;
                  }

                  const pdfWidth = doc.internal.pageSize.getWidth(); // 54
                  const pdfHeight = doc.internal.pageSize.getHeight(); // 20

                  // Línea 1: Código de solicitud + Estudio
                  const line1Text = `${codigoOrdenStr} ${estudioTxt}`.trim();
                  doc.setFont("helvetica", "bold");
                  printCenteredText(doc, line1Text, 2.8, 7.5, 50);

                  // Línea 2: Código de barras
                  if (barcodeImg) {
                    const bcWidth = 44;
                    const bcHeight = 5.8;
                    const bcX = (pdfWidth - bcWidth) / 2;
                    const bcY = 3.5;
                    doc.addImage(barcodeImg, "PNG", bcX, bcY, bcWidth, bcHeight);
                  }

                  // Línea 3: Nombre del Paciente
                  doc.setFont("helvetica", "bold");
                  printCenteredText(doc, nombrePacienteComp, 11.2, 7.0, 50);

                  // Línea 4: Sexo
                  if (sexoFormateado) {
                    doc.setFont("helvetica", "bold");
                    printCenteredText(doc, sexoFormateado, 13.5, 6.5, 50);
                  }

                  // Línea 5: Edad y Fecha de Nacimiento
                  if (edadYFecha) {
                    doc.setFont("helvetica", "bold");
                    printCenteredText(doc, edadYFecha, 15.8, 6.5, 50);
                  }

                  // Línea 6: Color Tubo / Nombre de Material
                  if (colorTuboTxt) {
                    doc.setFont("helvetica", "bold");
                    printCenteredText(doc, colorTuboTxt, 18.2, 6.5, 50);
                  }
                }
              });

              const blobUrl = doc.output("bloburl");
              const empNombre = [currentU?.nombre, currentU?.apPaterno].filter(Boolean).join(" ") || "EMPLEADO";
              registrarMovimientoSolicitud("ETI", `Se imprimieron las etiquetas por el usuario ${empNombre}`);

              Swal.fire({
                title: "Visor de Etiquetas",
                html: `<iframe src="${blobUrl}" width="100%" height="520px" style="border:none;"></iframe>`,
                width: "55%",
                showCloseButton: true,
                showConfirmButton: false,
              });
            },
            "Generando etiquetas para impresión...",
            "Procesando etiquetas"
          );
        } catch (errPDF) {
          console.error("Error al generar PDF de etiquetas:", errPDF);
          mostrarError("Ocurrió un error al generar el PDF de etiquetas.");
        }
      };

      const ComponenteModal = () => {
        const [filas, setFilas] = useState(filasIniciales);

        const handleChange = (index, field, value) => {
          setFilas((prev) => {
            const next = prev.map((item, idx) => {
              if (idx === index) {
                return { ...item, [field]: value };
              }
              return item;
            });

            if (index === prev.length - 1) {
              next.push({ cantidad: "", estudio: "", colorTubo: "" });
            }

            return next;
          });
        };

        const handleRemove = (index) => {
          setFilas((prev) => {
            let next = prev.filter((_, idx) => idx !== index);
            if (next.length === 0) {
              next = [{ cantidad: "", estudio: "", colorTubo: "" }];
            }
            const ultimaFila = next[next.length - 1];
            if (
              ultimaFila.cantidad !== "" ||
              ultimaFila.estudio !== "" ||
              ultimaFila.colorTubo !== ""
            ) {
              next.push({ cantidad: "", estudio: "", colorTubo: "" });
            }
            return next;
          });
        };

        const handleGenerarClick = () => {
          const filasValidas = filas.filter((f) => {
            const tieneEstudio = String(f.estudio || "").trim() !== "";
            const tieneColor = String(f.colorTubo || "").trim() !== "";
            return tieneEstudio || tieneColor;
          });

          if (filasValidas.length === 0) {
            Swal.fire({
              icon: "warning",
              title: "Atención",
              text: "Debe haber al menos una etiqueta con información de estudio o color de tubo.",
            });
            return;
          }

          onGenerarEtiquetasPDF(filasValidas);
        };

        return (
          <div style={{ fontFamily: "Roboto, sans-serif", margin: "-1.25em" }}>
            <div
              style={{
                backgroundColor: "#3aa0bc",
                color: "#ffffff",
                padding: "12px 16px",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "1.1rem",
                letterSpacing: "0.5px",
                borderRadius: "4px 4px 0 0",
                textTransform: "uppercase",
              }}
            >
              IMPRESIÓN DE ETIQUETAS
            </div>

            <div style={{ padding: "16px", backgroundColor: "#ffffff" }}>
              <div style={{ overflowX: "auto", maxHeight: "55vh" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "separate",
                    borderSpacing: "0 6px",
                    fontSize: "0.9rem",
                    tableLayout: "fixed",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        backgroundColor: "#10547f",
                        color: "#ffffff",
                        textAlign: "left",
                      }}
                    >
                      <th
                        style={{
                          padding: "10px 8px",
                          borderRadius: "4px 0 0 4px",
                          width: "14%",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                          boxSizing: "border-box",
                        }}
                      >
                        Cantidad
                      </th>
                      <th
                        style={{
                          padding: "10px 8px",
                          width: "38%",
                          whiteSpace: "nowrap",
                          boxSizing: "border-box",
                        }}
                      >
                        Estudio
                      </th>
                      <th
                        style={{
                          padding: "10px 8px",
                          width: "34%",
                          whiteSpace: "nowrap",
                          boxSizing: "border-box",
                        }}
                      >
                        Color Tubo
                      </th>
                      <th
                        style={{
                          padding: "10px 8px",
                          borderRadius: "0 4px 4px 0",
                          width: "14%",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                          boxSizing: "border-box",
                        }}
                      >
                        Eliminar
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filas.map((fila, idx) => (
                      <tr key={idx}>
                        <td style={{ padding: "4px 6px", textAlign: "center", boxSizing: "border-box" }}>
                          <input
                            type="text"
                            value={fila.cantidad}
                            onChange={(e) =>
                              handleChange(idx, "cantidad", e.target.value)
                            }
                            style={{
                              width: "100%",
                              boxSizing: "border-box",
                              padding: "6px 8px",
                              textAlign: "center",
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                              backgroundColor: "#e9ecef",
                              outline: "none",
                              fontSize: "0.9rem",
                            }}
                          />
                        </td>
                        <td style={{ padding: "4px 6px", boxSizing: "border-box" }}>
                          <input
                            type="text"
                            value={fila.estudio}
                            onChange={(e) =>
                              handleChange(idx, "estudio", e.target.value)
                            }
                            style={{
                              width: "100%",
                              boxSizing: "border-box",
                              padding: "6px 8px",
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                              backgroundColor: "#e9ecef",
                              outline: "none",
                              fontSize: "0.9rem",
                            }}
                          />
                        </td>
                        <td style={{ padding: "4px 6px", boxSizing: "border-box" }}>
                          <input
                            type="text"
                            value={fila.colorTubo}
                            onChange={(e) =>
                              handleChange(idx, "colorTubo", e.target.value)
                            }
                            style={{
                              width: "100%",
                              boxSizing: "border-box",
                              padding: "6px 8px",
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                              backgroundColor: "#e9ecef",
                              outline: "none",
                              fontSize: "0.9rem",
                            }}
                          />
                        </td>
                        <td style={{ padding: "4px 6px", textAlign: "center", whiteSpace: "nowrap", boxSizing: "border-box" }}>
                          <button
                            type="button"
                            onClick={() => handleRemove(idx)}
                            style={{
                              backgroundColor: "#d9534f",
                              color: "#ffffff",
                              border: "none",
                              borderRadius: "4px",
                              padding: "6px 12px",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxSizing: "border-box",
                            }}
                            title="Eliminar fila"
                          >
                            <i
                              className="fas fa-trash-alt"
                              style={{ fontSize: "0.9rem" }}
                            ></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div style={{ marginTop: "16px", textAlign: "center" }}>
                <button
                  type="button"
                  onClick={handleGenerarClick}
                  style={{
                    backgroundColor: "#4CAF50",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "4px",
                    padding: "10px 22px",
                    fontSize: "1rem",
                    fontWeight: "bold",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                    boxSizing: "border-box",
                  }}
                >
                  <i className="fas fa-file-pdf" style={{ fontSize: "1.1rem" }}></i>
                  Generar etiquetas
                </button>
              </div>
            </div>
          </div>
        );
      };

      MySwal.fire({
        html: <ComponenteModal />,
        width: "750px",
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
          popup: "swalMaxHeight",
        },
      });
    } catch (error) {
      console.error("Error al preparar modal de etiquetas:", error);
      mostrarError("No se pudieron cargar las muestras para las etiquetas.");
    }
  };


  const [selectedPaciente, setSelectedPaciente] = useState(null);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [nombreDoctor, setNombreDoctor] = useState("");
  const [apPaternoDoctor, setApPaternoDoctor] = useState("");
  const [apMaternoDoctor, setApMaternoDoctor] = useState("");
  const [emailDoctor, setEmailDoctor] = useState("");
  const [telefonoDoctor, setTelefonoDoctor] = useState("");
  const [esComisionD, setEsComisionD] = useState(false);

  const [cantidadDoctores, setCantidadDoctores] = useState(1);

  // Doctor 2
  const [selectedDoctor2, setSelectedDoctor2] = useState(null);
  const [nombreDoctor2, setNombreDoctor2] = useState("");
  const [apPaternoDoctor2, setApPaternoDoctor2] = useState("");
  const [apMaternoDoctor2, setApMaternoDoctor2] = useState("");
  const [emailDoctor2, setEmailDoctor2] = useState("");
  const [telefonoDoctor2, setTelefonoDoctor2] = useState("");
  const [esComisionD2, setEsComisionD2] = useState(false);
  const [enviarWhatsappD2, setEnviarWhatsappD2] = useState("no");
  const [errorNombreDoctor2, setErrorNombreDoctor2] = useState(false);
  const [errorApPaternoDoctor2, setErrorApPaternoDoctor2] = useState(false);
  const [editModeM2, setEditModeM2] = useState(false);
  const [viewOnlyM2, setViewOnlyM2] = useState(false);

  // Doctor 3
  const [selectedDoctor3, setSelectedDoctor3] = useState(null);
  const [nombreDoctor3, setNombreDoctor3] = useState("");
  const [apPaternoDoctor3, setApPaternoDoctor3] = useState("");
  const [apMaternoDoctor3, setApMaternoDoctor3] = useState("");
  const [emailDoctor3, setEmailDoctor3] = useState("");
  const [telefonoDoctor3, setTelefonoDoctor3] = useState("");
  const [esComisionD3, setEsComisionD3] = useState(false);
  const [errorNombreDoctor3, setErrorNombreDoctor3] = useState(false);
  const [errorApPaternoDoctor3, setErrorApPaternoDoctor3] = useState(false);
  const [editModeM3, setEditModeM3] = useState(false);
  const [viewOnlyM3, setViewOnlyM3] = useState(false);
  const [pacientes, setPacientes] = useState([]);
  const [nombre, setNombre] = useState("");
  const [apPaterno, setApPaterno] = useState("");
  const [apMaterno, setApMaterno] = useState("");
  const [fechaNac, setFechaNac] = useState("");
  const [edad, setEdad] = useState("");
  const [email, setEmail] = useState("");
  const [sexo, setSexo] = useState("");
  const [telefonoCelular, setTelefonoCelular] = useState("");
  const [numCuarto, setNumCuarto] = useState("");
  const [motivoDescuento, setMotivoDescuento] = useState("");
  const [errorNombre, setErrorNombre] = useState(false);
  const [errorApPaterno, setErrorApPaterno] = useState(false);
  const [errorNombreDoctor, setErrorNombreDoctor] = useState(false);
  const [errorApPaternoDoctor, setErrorApPaternoDoctor] = useState(false);
  const [errorEdad, setErrorEdad] = useState(false);
  const [errorSexo, setErrorSexo] = useState(false);
  const [direccion, setDireccion] = useState("");
  const [colonia, setColonia] = useState("");
  const [cPostal, setCPostal] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [estado, setEstado] = useState("seleccione");
  const [ine, setIne] = useState("");
  const [conversion, setConversion] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [empresa, setEmpresa] = useState("");
  const [doctores, setDoctores] = useState([]);
  const [fecha, setFecha] = useState("");
  const [sucursalNombre, setSucursalNombre] = useState("");
  const [selectedEmpresa, setSelectedEmpresa] = useState(null);
  const [asignarFecha, setAsignarFecha] = useState(false);
  const [modoEntrega, setModoEntrega] = useState("normal");
  const [fechaGlobal, setFechaGlobal] = useState("");
  const [viewOnlyE, setViewOnlyE] = useState(false);
  const [viewOnlyP, setViewOnlyP] = useState(false);
  const [viewOnlyM, setViewOnlyM] = useState(false);
  const [viewOnly, setViewOnly] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editModeG, setEditModeG] = useState(false);
  const [editModeM, setEditModeM] = useState(false);
  const [cancelMode, setCancelMode] = useState(false);
  const [showCotizacionPacienteHeader, setShowCotizacionPacienteHeader] =
    useState(false);
  const [cotizacionNumero, setCotizacionNumero] = useState("");
  const [solicitudCodigo, setSolicitudCodigo] = useState("");
  const [solicitudSucursalNombre, setSolicitudSucursalNombre] = useState("");
  const [solicitudFecha, setSolicitudFecha] = useState("");
  const [solicitudInserto, setSolicitudInserto] = useState("");
  const [cotizacionHeader, setCotizacionHeader] = useState(null);
  const [usuario, setUsuario] = useState("");
  const [estudios, setEstudios] = useState([
    {
      cantidad: "1",
      codigo: "",
      nombre: "",
      costo: "",
      tiempoEntrega: "",
      idEstudio: "",
      descuento: "",
      fechaEntrega: "",
      fechaMuestra: getFechaHoy(),
      muestraPendiente: false,
      urgente: false,
    },
  ]);
  const [sucursales, setSucursales] = useState([]);
  const [opcionDescuento, setOpcionDescuento] = useState("ninguno");
  const [opcionDescuentoOriginal, setOpcionDescuentoOriginal] = useState("ninguno");
  const [valorGeneralOriginal, setValorGeneralOriginal] = useState("");
  const [motivoDescuentoOriginal, setMotivoDescuentoOriginal] = useState("");
  const [requiereFactura, setRequiereFactura] = useState(false);
  const [estudiosOriginales, setEstudiosOriginales] = useState([]);
  const [valorGeneral, setValorGeneral] = useState("");
  const [errorDescuentoGeneral, setErrorDescuentoGeneral] = useState("");
  const [erroresDescuentoEstudios, setErroresDescuentoEstudios] = useState([]);
  const [estudiosOptions, setEstudiosOptions] = useState([]);
  const [preciosByLista, setPreciosByLista] = useState({});
  const [preciosSucursal, setPreciosSucursal] = useState([]);
  const [notas, setNotas] = useState("");
  const [selectedLista, setSelectedLista] = useState("");
  const [selectedSolicitudId, setSelectedSolicitudId] = useState(null);
  const [solicitudEstatus, setSolicitudEstatus] = useState("S");
  const [solicitudACuenta, setSolicitudACuenta] = useState(0);
  const [solicitudRestante, setSolicitudRestante] = useState(0);
  const [solicitudSaldoPendiente, setSolicitudSaldoPendiente] = useState(0);
  const [totalesCaja, setTotalesCaja] = useState({
    subtotal: 0,
    descuento: 0,
    adeudo: 0,
    total: 0,
    aCuenta: 0,
    restante: 0,
  });
  const [enviarWhatsapp, setEnviarWhatsapp] = useState("seleccione");
  const [enviarEmail, setEnviarEmail] = useState("seleccione");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const esEstatusSoloLectura = (estatus) => {
    const estatusNormalizado = `${estatus ?? ""}`.trim().toUpperCase();
    return estatusNormalizado === "EN" || estatusNormalizado === "C";
  };

  const aplicarBloqueoPorEstatus = (estatus) => {
    const esSoloLectura = esEstatusSoloLectura(estatus);

    setEditMode(false);
    setEditModeG(false);
    setEditModeM(false);
    setEditModeM2(false);
    setEditModeM3(false);
    setViewOnly(esSoloLectura);
    setViewOnlyE(esSoloLectura);
    setViewOnlyP(esSoloLectura);
    setViewOnlyM(esSoloLectura);
    setViewOnlyM2(esSoloLectura);
    setViewOnlyM3(esSoloLectura);

    return esSoloLectura;
  };
  const [saving, setSaving] = useState({
    nombre: false,
    apPaterno: false,
    apMaterno: false,
    sexo: false,
    fechaNacimiento: false,
    email: false,
    telefono: false,
  });
  const [savingM, setSavingM] = useState({
    nombre: false,
    apPaterno: false,
    apMaterno: false,
    sexo: false,
    fechaNacimiento: false,
    email: false,
    telefono: false,
  });
  const MySwal = withReactContent(Swal);

  const addEstudio = () => {
    setEstudios((prev) => [
      ...prev,
      {
        cantidad: "1",
        codigo: "",
        nombre: "",
        costo: "",
        tiempoEntrega: "",
        idEstudio: "",
        descuento: "",
        fechaEntrega: "",
        fechaMuestra: getFechaHoy(),
        muestraPendiente: false,
      },
    ]);
  };
  const handleRemoveEstudio = async (index) => {
    if (viewOnly) return;
    const isEditMode = Boolean(editMode || editModeG || selectedSolicitudId);

    if (isEditMode && !esUsuarioAdmin(currentU)) {
      mostrarError("Solo los usuarios administradores pueden eliminar estudios en modo edición.");
      return;
    }

    const estudioEliminado = estudios[index];
    if (!estudioEliminado) return;

    const nombreEstudio = estudioEliminado.nombre || estudioEliminado.codigo || "Estudio";
    const idEstudioEliminado = estudioEliminado.idEstudio;
    const estudiosRestantes = estudios.filter((_, i) => i !== index);

    // Si la solicitud ya está guardada en backend (modo edición con ID)
    if (isEditMode && selectedSolicitudId) {
      // Precio base del estudio a eliminar (sin descuentos, promociones ni ajustes)
      const precioBase = Number(estudioEliminado.costo || estudioEliminado.precio || 0);

      // Recalcular el nuevo total remanente de los estudios que se conservan
      const subtotalRemanente = calcularSubtotal(estudiosRestantes);
      const descTotalRemanente = calcularDescuentoTotalLocal(estudiosRestantes);
      const baseRemanente = Math.max(0, subtotalRemanente - descTotalRemanente);
      const ivaRemanente = requiereFactura ? baseRemanente * 0.16 : 0;
      const nuevoTotalRemanente = baseRemanente + ivaRemanente;

      // Pagado neto actual abonado en la orden (desde base de datos)
      const montoPagadoNeto = Number(totalesCaja?.aCuenta) || parseNumero(solicitudACuenta) || 0;

      // Solo se solicita reembolso si lo abonado supera el nuevo total remanente de la solicitud
      const excesoPagado = Math.max(0, montoPagadoNeto - nuevoTotalRemanente);
      const montoReembolsoCalculado = Math.min(precioBase, excesoPagado);

      if (montoReembolsoCalculado > 0) {
        // Mostrar en SweetAlert el monto exacto que se reembolsará (exceso abonado sobre el nuevo total)
        const { value: respForma } = await MySwal.fire({
          title: "REEMBOLSO POR ELIMINACIÓN DE ESTUDIO",
          width: "520px",
          icon: "warning",
          html: `
            <div style="text-align:left;font-size:0.95rem;">
              <p style="margin-bottom:6px;">Se eliminará el estudio <b>${nombreEstudio}</b>.</p>
              <p style="margin-bottom:4px;">Precio base del estudio: <b>$${precioBase.toFixed(2)}</b></p>
              <p style="margin-bottom:4px;">Total neto pagado previamente: <b>$${montoPagadoNeto.toFixed(2)}</b></p>
              <p style="margin-bottom:6px;">Nuevo total de la solicitud: <b>$${nuevoTotalRemanente.toFixed(2)}</b></p>
              <p style="color:#c62828;font-weight:bold;font-size:1.05rem;background:#ffebee;padding:8px;border-radius:6px;margin-top:6px;">
                Monto a reembolsar: $${montoReembolsoCalculado.toFixed(2)}
              </p>
              <div style="margin-top:12px;">
                <label style="font-weight:bold;display:block;margin-bottom:4px;">Forma de Reembolso:</label>
                <select id="swal-forma-reembolso-parcial" class="swal2-select" style="width:100%;margin:0;padding:6px;">
                  <option value="efectivo">Efectivo</option>
                  <option value="debito">Tarjeta de débito</option>
                  <option value="credito">Tarjeta de crédito</option>
                  <option value="cheque">Cheque</option>
                  <option value="transferencia">Transferencia</option>
                </select>
              </div>
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: "Procesar Reembolso y Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#c62828",
          preConfirm: () => {
            return document.getElementById("swal-forma-reembolso-parcial")?.value || "efectivo";
          },
        });

        if (!respForma) return;

        try {
          const payloadDelete = {
            idSolicitud: selectedSolicitudId,
            idEstudio: idEstudioEliminado,
            precio: montoReembolsoCalculado,
            motivoCancelacion: `Eliminación de estudio: ${nombreEstudio}`,
            formaReembolso: respForma,
            requiereReembolso: 1,
            fecha: getFormattedNow(),
            reembolso: currentU.id,
          };

          const resDel = await SolicitudesEstudiosService.deleteEstudio(payloadDelete);
          if (resDel?.data?.estatus === "OK" || resDel?.status === 200) {
            setEstudios(estudiosRestantes);

            // 1. Registrar el movimiento de pago (reembolso) en la BD primero
            await HistorialService.registrarPago({
              idSolicitud: selectedSolicitudId,
              nombreEmpleado: [currentU?.nombre, currentU?.apPaterno].filter(Boolean).join(" ") || "EMPLEADO",
              nombreSucursal: sucursalNombre || "",
              formaPago: respForma,
              cantidad: montoReembolsoCalculado,
              operacion: "Eliminación de estudio con reembolso",
            });

            await HistorialService.registrarEvento({
              idSolicitud: selectedSolicitudId,
              nombreEmpleado: [currentU?.nombre, currentU?.apPaterno].filter(Boolean).join(" ") || "EMPLEADO",
              operacion: `Eliminación de estudio con reembolso: ${nombreEstudio} ($${montoReembolsoCalculado.toFixed(2)})`,
            });

            // 2. AHORA recargar los totales desde la BD (ya incluye el reembolso guardado)
            await actualizarTotalesCaja(selectedSolicitudId);

            // 3. Recargar la solicitud del backend para actualizar la UI por completo
            try {
              const fullResp = await SolicitudesService.getSolicitudIndividual(selectedSolicitudId);
              const solActualizada = fullResp?.solicitud?.[0] || fullResp?.solicitud || fullResp;
              if (solActualizada && typeof solActualizada === "object") {
                if (viewOnly) {
                  await verSolicitud(solActualizada);
                } else if (editMode || editModeG) {
                  await editarSolicitud(solActualizada);
                }
              }
            } catch (errRec) {
              console.error("Error al recargar la solicitud tras reembolso:", errRec);
            }

            mostrarMensajeSolicitud("Estudio eliminado y reembolso procesado correctamente");
          } else {
            mostrarError("No se pudo eliminar el estudio: " + (resDel?.data?.mensaje || "Error en backend"));
          }
        } catch (errDel) {
          console.error("Error al eliminar estudio con reembolso:", errDel);
          mostrarError("No se pudo procesar la eliminación del estudio.");
        }
      } else {
        // No excede lo abonado / $0 abonado -> Eliminación sin reembolso
        const { isConfirmed } = await MySwal.fire({
          title: "ELIMINAR ESTUDIO",
          text: `¿Estás seguro de eliminar el estudio ${nombreEstudio}?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#c62828",
        });

        if (!isConfirmed) return;

        try {
          const payloadDelete = {
            idSolicitud: selectedSolicitudId,
            idEstudio: idEstudioEliminado,
            precio: 0,
            motivoCancelacion: `Eliminación de estudio: ${nombreEstudio}`,
            formaReembolso: "",
            requiereReembolso: 0,
            fecha: getFormattedNow(),
            reembolso: currentU.id,
          };

          const resDel = await SolicitudesEstudiosService.deleteEstudio(payloadDelete);
          if (resDel?.data?.estatus === "OK" || resDel?.status === 200) {
            setEstudios(estudiosRestantes);
            await actualizarTotalesCaja(selectedSolicitudId);

            await HistorialService.registrarEvento({
              idSolicitud: selectedSolicitudId,
              nombreEmpleado: [currentU?.nombre, currentU?.apPaterno].filter(Boolean).join(" ") || "EMPLEADO",
              operacion: `Eliminación de estudio: ${nombreEstudio}`,
            });

            mostrarMensajeSolicitud("Estudio eliminado correctamente");
          } else {
            mostrarError("No se pudo eliminar el estudio: " + (resDel?.data?.mensaje || "Error en backend"));
          }
        } catch (errDel) {
          console.error("Error al eliminar estudio:", errDel);
          mostrarError("No se pudo procesar la eliminación del estudio.");
        }
      }
    } else {
      // Orden nueva aún no guardada en backend
      setEstudios(estudiosRestantes);
    }
  };

  useEffect(() => {
    if (selectedPaciente) {
      setNombre(selectedPaciente.nombre || "");
      setApPaterno(selectedPaciente.apPaterno || "");
      setApMaterno(selectedPaciente.apMaterno || "");
      setSexo(selectedPaciente.sexo || "");
      setFechaNac(selectedPaciente.fechaNacimiento || "");
      setEdad(selectedPaciente.edad || "");
      setTelefonoCelular(selectedPaciente.telefonoCelular || "");
      setDireccion(selectedPaciente.direccion || "");
      setColonia(selectedPaciente.colonia || "");
      setCPostal(selectedPaciente.cPostal || "");
      setEstado(selectedPaciente.estado || "");
      setCiudad(selectedPaciente.ciudad);
      setIne(selectedPaciente.ine || "");
      setEmail(selectedPaciente.email || "");
      if (!editMode) {
        setViewOnlyP(true);
      }
    } else {
      setNombre("");
      setApPaterno("");
      setApMaterno("");
      setSexo("");
      setFechaNac("");
      setEdad("");
      setTelefonoCelular("");
      setDireccion("");
      setColonia("");
      setCPostal("");
      setEstado("seleccione");
      setCiudad("");
      setIne("");
      setEmail("");
      setViewOnly(false);
      setViewOnlyP(false);
    }
  }, [selectedPaciente]);

  useEffect(() => {
    if (selectedDoctor) {
      setNombreDoctor(selectedDoctor.nombre || "");
      setApPaternoDoctor(selectedDoctor.apPaterno || "");
      setApMaternoDoctor(selectedDoctor.apMaterno || "");
      setEmailDoctor(selectedDoctor.email || "");
      setTelefonoDoctor(selectedDoctor.telefono || selectedDoctor.telefonoCelular || "");
      setEsComisionD(Boolean(selectedDoctor.esComision || selectedDoctor.conComision || selectedDoctor.comision));
      if (!editModeM) {
        setViewOnlyM(true);
      }
    } else {
      setNombreDoctor("");
      setApPaternoDoctor("");
      setApMaternoDoctor("");
      setEmailDoctor("");
      setTelefonoDoctor("");
      setEsComisionD(false);
    }
  }, [selectedDoctor]);

  useEffect(() => {
    if (selectedDoctor2) {
      setNombreDoctor2(selectedDoctor2.nombre || "");
      setApPaternoDoctor2(selectedDoctor2.apPaterno || "");
      setApMaternoDoctor2(selectedDoctor2.apMaterno || "");
      setEmailDoctor2(selectedDoctor2.email || "");
      setTelefonoDoctor2(selectedDoctor2.telefono || selectedDoctor2.telefonoCelular || "");
      setEsComisionD2(Boolean(selectedDoctor2.esComision || selectedDoctor2.conComision || selectedDoctor2.comision));
      if (!editModeM2) {
        setViewOnlyM2(true);
      }
    } else {
      setNombreDoctor2("");
      setApPaternoDoctor2("");
      setApMaternoDoctor2("");
      setEmailDoctor2("");
      setTelefonoDoctor2("");
      setEsComisionD2(false);
    }
  }, [selectedDoctor2]);

  useEffect(() => {
    if (selectedDoctor3) {
      setNombreDoctor3(selectedDoctor3.nombre || "");
      setApPaternoDoctor3(selectedDoctor3.apPaterno || "");
      setApMaternoDoctor3(selectedDoctor3.apMaterno || "");
      setEmailDoctor3(selectedDoctor3.email || "");
      setTelefonoDoctor3(selectedDoctor3.telefono || selectedDoctor3.telefonoCelular || "");
      setEsComisionD3(Boolean(selectedDoctor3.esComision || selectedDoctor3.conComision || selectedDoctor3.comision));
      if (!editModeM3) {
        setViewOnlyM3(true);
      }
    } else {
      setNombreDoctor3("");
      setApPaternoDoctor3("");
      setApMaternoDoctor3("");
      setEmailDoctor3("");
      setTelefonoDoctor3("");
      setEsComisionD3(false);
    }
  }, [selectedDoctor3]);



  const cancelarSolicitud = async (solicitud) => {
    try {
      const resultado = await SolicitudesService.deleteSolicitud(solicitud);
      if (resultado.data.estatus === "OK") {
        mostrarMensaje("Solicitud cancelada con éxito!");
      } else {
        mostrarError("Error al cancelar solicitud");
      }
    } catch (error) {
      console.error("Error al cancelar solicitud:", error);
      mostrarError("Error al cancelar solicitud");
    }
  };

  const usuarioString = sessionStorage.getItem("usuario");
  const currentU = JSON.parse(usuarioString);

  const esUsuarioAdmin = (u) => {
    if (!u) return false;
    const r = String(u.rol || u.tipo || u.rolNombre || u.perfil || u.role || "").trim().toUpperCase();
    if (r === "A" || r === "ADMIN" || r === "ADMINISTRADOR" || r.includes("ADMIN")) {
      return true;
    }
    if (u.isAdmin === true || u.isAdmin === "1" || u.isAdmin === 1) {
      return true;
    }
    return false;
  };

  // ── Historial helpers ──
  const formatFechaHist = (fechaInput) => {
    if (!fechaInput) return "";
    let dateObj;
    if (typeof fechaInput === "string") {
      const formatted = fechaInput.includes(" ") ? fechaInput.replace(" ", "T") : fechaInput;
      dateObj = new Date(formatted);
    } else {
      dateObj = new Date(fechaInput);
    }
    if (isNaN(dateObj.getTime())) return String(fechaInput);
    const dia = String(dateObj.getDate()).padStart(2, "0");
    const meses = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    const mes = meses[dateObj.getMonth()];
    const anio = dateObj.getFullYear();
    const horas = String(dateObj.getHours()).padStart(2, "0");
    const minutos = String(dateObj.getMinutes()).padStart(2, "0");
    return `${dia} ${mes} ${anio}  ${horas}:${minutos} h`;
  };

  const registrarMovimientoSolicitud = async (tipoAccion, descripcion = "", targetId = null) => {
    const idSol = targetId || selectedSolicitudId;
    if (!idSol) return;
    const empNombre = [currentU?.nombre, currentU?.apPaterno, currentU?.apMaterno]
      .filter(Boolean).join(" ") || "EMPLEADO";
    const opTexto = descripcion || tipoAccion;
    try {
      await HistorialService.registrarEvento({
        idSolicitud: idSol,
        nombreEmpleado: empNombre,
        operacion: opTexto,
      });
      await HistorialEstudiosService.registrarMovimiento({
        idSolicitud: idSol,
        idEstudio: 0,
        nombreEstudio: opTexto,
        nombreEmpleado: empNombre,
        tipoAccion: tipoAccion,
      });
    } catch (e) {
      console.warn("Error registrando historial evento:", e);
    }
  };

  const registrarMovimientoPago = async (pagoData) => {
    const idSol = selectedSolicitudId || solicitudCodigo || pagoData?.idSolicitud;
    if (!idSol) return;
    const empNombre = [currentU?.nombre, currentU?.apPaterno, currentU?.apMaterno]
      .filter(Boolean).join(" ") || "EMPLEADO";
    const sucNombre = sucursalNombre || pagoData?.nombreSucursal || "";
    try {
      await HistorialService.registrarPago({
        idSolicitud: idSol,
        nombreEmpleado: empNombre,
        nombreSucursal: sucNombre,
        formaPago: pagoData?.formaPago || "Efectivo",
        cantidad: Number(pagoData?.cantidad || 0),
        operacion: pagoData?.operacion || "Recepción de pago",
      });
    } catch (e) {
      console.warn("Error registrando historial pago:", e);
    }
  };



  const abrirModalSeleccionHistorial = () => {
    const idSol = selectedSolicitudId || solicitudCodigo;
    if (!idSol) return;
    abrirModalSeleccionHistorialSwal(idSol);
  };

  const estatusMapHTML = {
    C: { label: "Cancelada", color: "red" },
    S: { label: "Sin pagos", color: "gray" },
    E: { label: "Entregada", color: "green" },
    P: { label: "Pagada", color: "blue" },
    PC: { label: "Pagada parcialmente", color: "gold" }
  };
  async function mostrarBuscarSolicitudes() {
    let solicitudesOriginal = [];
    let solicitudesActivas = [];

    const resultado = await SolicitudesService.getSolicitudes();

    const rawList = Array.isArray(resultado?.data?.solicitudes) ? resultado.data.solicitudes : [];
    solicitudesOriginal = [...rawList].sort((a, b) => (Number(b.idSolicitud) || 0) - (Number(a.idSolicitud) || 0));
    solicitudesActivas = [...solicitudesOriginal];

    const porPagina = 8;
    let paginaActual = 1;

    const construirFilas = (solicitudes) => {
      return solicitudes
        .map((sol, idx) => {
          const estatus = estatusMapHTML[sol.estatus] || { label: "", color: "transparent" };
          const esSoloLectura = esEstatusSoloLectura(sol?.estatus);
          return `
        <tr style="background-color: ${idx % 2 === 0 ? "#ffffff" : "#f8fafc"}; border-bottom: 1px solid #e2e8f0; font-size: 0.80rem; transition: background 0.15s;">
          <td style="padding: 6px 10px; text-align: center; font-weight: 600; color: #1e293b; border-right: 1px solid #f1f5f9;">${sol.codigo}</td>
          <td style="padding: 6px 12px; text-align: left; font-weight: 500; color: #1e293b; border-right: 1px solid #f1f5f9;">${sol.nombrePaciente} ${sol.apPaternoPaciente} ${sol.apMaternoPaciente}</td>
          <td style="padding: 6px 10px; text-align: center; border-right: 1px solid #f1f5f9;">
            <span style="
              background:${estatus.color};
              color:white;
              padding:2px 8px;
              border-radius:10px;
              font-size:0.72rem;
              font-weight:600;
              display:inline-block;
            ">
              ${estatus.label}
            </span>
          </td>
          <td style="padding: 4px 6px; text-align: center; border-right: 1px solid #f1f5f9;">
            <button data-action="mostrar" data-idsolicitud="${sol.idSolicitud}" title="Mostrar" style="background: #e0f2fe; color: #0284c7; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
              <i class="fas fa-eye"></i>
            </button>
          </td>
          <td style="padding: 4px 6px; text-align: center; border-right: 1px solid #f1f5f9;">
            ${esSoloLectura ? "" : `
              <button data-action="editar" data-idsolicitud="${sol.idSolicitud}" title="Editar" style="background: #fef3c7; color: #d97706; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
                <i class="fas fa-edit"></i>
              </button>
            `}
          </td>
          <td style="padding: 4px 6px; text-align: center;">
            ${esSoloLectura ? "" : `
              <button data-action="cancelar" data-idsolicitud="${sol.idSolicitud}" title="Cancelar" style="background: #fee2e2; color: #dc2626; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
                <i class="fas fa-ban"></i>
              </button>
            `}
          </td>
        </tr>
      `;
        })
        .join("");
    };

    const renderPagina = (pagina) => {
      const inicio = (pagina - 1) * porPagina;
      const fin = inicio + porPagina;
      const paginaSolicitudes = solicitudesActivas.slice(inicio, fin);
      const tabla = document.getElementById("tablaSolicitudes");
      if (tabla) {
        if (!paginaSolicitudes || paginaSolicitudes.length === 0) {
          tabla.innerHTML = `<tr><td colspan="6" style="padding: 24px; text-align: center; color: #64748b; font-style: italic;">No hay registros</td></tr>`;
        } else {
          tabla.innerHTML = construirFilas(paginaSolicitudes);
        }
        tabla
          .querySelectorAll("button[data-action='mostrar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idsolicitud;
              const solicitud = solicitudesActivas.find(
                (item) => String(item.idSolicitud) === String(id),
              );
              if (solicitud) {
                verSolicitud(solicitud);
                Swal.close();
              }
            });
          });
        tabla
          .querySelectorAll("button[data-action='editar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idsolicitud;
              const solicitud = solicitudesActivas.find(
                (item) => String(item.idSolicitud) === String(id),
              );
              if (solicitud) {
                editarSolicitud(solicitud);
                Swal.close();
              }
            });
          });
        tabla
          .querySelectorAll("button[data-action='cancelar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idsolicitud;
              const solicitud = solicitudesActivas.find(
                (item) => String(item.idSolicitud) === String(id),
              );
              if (solicitud) {
                setCancelMode(true);
                verSolicitud(solicitud);
                Swal.close();
              }
            });
          });

      }

      const totalPaginas = Math.max(
        1,
        Math.ceil(solicitudesActivas.length / porPagina),
      );
      const spanPagina = document.getElementById("paginaActual");
      if (spanPagina) {
        spanPagina.textContent = `Página ${pagina} de ${totalPaginas} (${solicitudesActivas.length} registros)`;
      }
      const btnAnterior = document.getElementById("btnAnterior");
      const btnSiguiente = document.getElementById("btnSiguiente");
      if (btnAnterior) {
        btnAnterior.disabled = pagina <= 1;
        btnAnterior.style.opacity = pagina <= 1 ? "0.45" : "1";
        btnAnterior.style.cursor = pagina <= 1 ? "not-allowed" : "pointer";
      }
      if (btnSiguiente) {
        btnSiguiente.disabled = pagina >= totalPaginas;
        btnSiguiente.style.opacity = pagina >= totalPaginas ? "0.45" : "1";
        btnSiguiente.style.cursor = pagina >= totalPaginas ? "not-allowed" : "pointer";
      }
    };
    Swal.fire({
      title: "BUSCAR SOLICITUD",
      width: "65%",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
      },
      html: `
        <div style="font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; text-align: left;">
          <div style="display: flex; gap: 10px; align-items: flex-end; justify-content: space-between; flex-wrap: wrap; margin-bottom: 8px;">
            <div style="display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 220px;">
              <label for="swal-nombre" style="font-size: 0.80rem; font-weight: 600; color: #334155;">Código de la solicitud o nombre del paciente:</label>
              <input id="swal-nombre" type="text" style="padding: 5px 10px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.82rem; outline: none; height: 32px; box-sizing: border-box;" placeholder="Escribe aquí..." />
            </div>            
            <div>
              <button id="btnMostrarTodos" style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; border: none; border-radius: 6px; font-weight: 600; font-size: 0.80rem; padding: 6px 14px; cursor: pointer; box-shadow: 0 2px 4px rgba(0,0,0,0.1); height: 32px; white-space: nowrap; transition: opacity 0.2s;">
                Mostrar todas las solicitudes
              </button>
            </div>
          </div>
  
          <div style="width: 100%; overflow: auto; max-height: 52vh; border: 1px solid #cbd5e1; border-radius: 8px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.08); background: white;">
            <table class="tablaSolicitudes" style="width: 100%; border-collapse: collapse; text-align: center;">
              <thead>
                <tr style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; font-size: 0.80rem; position: sticky; top: 0; z-index: 2;">
                  <th style="padding: 7px 10px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Código</th>
                  <th style="padding: 7px 12px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Nombre del paciente</th>
                  <th style="padding: 7px 10px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Estado</th>
                  <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600; width: 45px;">Mostrar</th>
                  <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600; width: 45px;">Editar</th>
                  <th style="padding: 7px 8px; text-align: center; font-weight: 600; width: 45px;">Cancelar</th>
                </tr>
              </thead>
              <tbody id="tablaSolicitudes">
              </tbody>
            </table>
          </div>

          <div style="margin-top: 8px; display: flex; justify-content: space-between; align-items: center;">
            <span id="paginaActual" style="font-size: 0.80rem; color: #64748b; font-weight: 500;"></span>
            <div style="display: flex; gap: 6px;">
              <button id="btnAnterior" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Anterior</button>
              <button id="btnSiguiente" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Siguiente</button>
            </div>
          </div>
        </div>
      `,
      showConfirmButton: false,
      didOpen: () => {
        renderPagina(paginaActual);

        document.getElementById("btnAnterior").addEventListener("click", () => {
          if (paginaActual > 1) {
            paginaActual--;
            renderPagina(paginaActual);
          }
        });

        document
          .getElementById("btnSiguiente")
          .addEventListener("click", () => {
            if (
              paginaActual < Math.ceil(solicitudesActivas.length / porPagina)
            ) {
              paginaActual++;
              renderPagina(paginaActual);
            }
          });

        document
          .getElementById("btnMostrarTodos")
          .addEventListener("click", async () => {
            try {
              const resultado = await SolicitudesService.getSolicitudes();
              solicitudesOriginal = resultado.data.solicitudes;
              solicitudesActivas = [...solicitudesOriginal];
              paginaActual = 1;
              renderPagina(paginaActual);
            } catch (error) {
              console.error("Error al recargar solicitudes:", error);
            }
            document.getElementById("swal-nombre").value = "";
          });
        document
          .getElementById("swal-nombre")
          .addEventListener("input", async (e) => {
            const valor = e.target.value.trim();
            paginaActual = 1;
            if (valor === "") {
              solicitudesActivas = [...solicitudesOriginal];
              renderPagina(paginaActual);
              return;
            }

            const valLower = valor.toLowerCase();
            const filtradasLocal = solicitudesOriginal.filter((sol) => {
              const cod = String(sol.codigo || sol.orden || "").toLowerCase();
              const nombrePac = `${sol.nombrePaciente || ""} ${sol.apPaternoPaciente || ""} ${sol.apMaternoPaciente || ""}`.toLowerCase();
              return cod.includes(valLower) || nombrePac.includes(valLower);
            });

            try {
              const resultado = await SolicitudesService.buscarSolicitudesCN(valor);
              const serverList = Array.isArray(resultado?.solicitudes)
                ? resultado.solicitudes
                : (Array.isArray(resultado?.data?.solicitudes)
                  ? resultado.data.solicitudes
                  : (Array.isArray(resultado) ? resultado : []));

              if (serverList && serverList.length > 0) {
                solicitudesActivas = serverList;
              } else {
                solicitudesActivas = filtradasLocal;
              }
            } catch (error) {
              console.error("Error en búsqueda backend, usando filtro local:", error);
              solicitudesActivas = filtradasLocal;
            }
            renderPagina(paginaActual);
          });
      },
    });
  }


  async function handlePagarSolicitud() {
    const { value: pagoNuevo } = await MySwal.fire({
      title: "PAGAR SOLICITUD",
      width: "60%",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
        confirmButton: "btnConfirmBlue",
      },
      html: `
          <div style="display:flex;flex-direction:column;gap:1vw;text-align:left;">
            <div class="tituloDegradado" style="font-size:1rem;padding:0.55vw 0.7vw;border-radius:8px;display:block;width:100%;text-align:center;font-weight:700;">TOTAL A PAGAR</div>
            <div style="font-size:1.7rem;padding:0.3vw 0.5vw;border-radius:8px;display:block;text-align:center;font-weight:800;color:#18234f;">$${restanteMonto.toFixed(2)}</div>
            <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:1rem;margin-bottom:0.5vw;">
              <div style="display:flex;flex-direction:column;gap:0.35rem;">
                <label for="swal-formaPago" style="font-weight:700;font-size:0.95vw;">Forma de Pago:</label>
                <select class="swal-formaPago" id="swal-formaPago" style="width:100%;padding:0.7vw 0.8vw;font-size:0.95vw;border:1px solid #cfd8dc;border-radius:6px;">
                  <option value="efectivo">Efectivo</option>
                  <option value="debito">Tarjeta de debito</option>
                  <option value="credito">Tarjeta de credito</option>
                  <option value="cheque">Cheque</option>
                  <option value="transferencia">Transferencia</option>
                </select>
              </div>
              <div id="swal-ultimos4-group" style="display:none;flex-direction:column;gap:0.35rem;">
                <label for="swal-ultimos4" style="font-weight:700;font-size:0.95vw;">Últimos 4 dígitos:</label>
                <input id="swal-ultimos4" class="input-swal" placeholder="0000" maxlength="4" inputmode="numeric" style="width:100%;padding:0.7vw 0.8vw;font-size:0.95vw;border:1px solid #cfd8dc;border-radius:6px;" />
              </div>
              <div style="display:flex;flex-direction:column;gap:0.35rem;">
                <label for="swal-cantidad" style="font-weight:700;font-size:0.95vw;">Cantidad recibida:</label>
                <input id="swal-cantidad" class="input-swal" placeholder="0.00" type="number" step="0.01" style="width:100%;padding:0.7vw 0.8vw;font-size:0.95vw;border:1px solid #cfd8dc;border-radius:6px;" />
              </div>
              
            </div>
            <div style="display:flex;flex-direction:column;align-items:center;gap:0.25rem;justify-content:center;max-width:220px;margin:0 auto;">
              <label for="swal-cambio" style="font-weight:700;font-size:0.8vw;">Cambio:</label>
              <div id="swal-cambio" style="min-height:2rem;display:flex;align-items:center;justify-content:center;padding:0.45vw 0.6vw;font-size:0.85vw;border:1px solid #cfd8dc;border-radius:6px;background:#f7f9fc;font-weight:700;color:#18234f;width:100%;"> </div>
            </div>
          </div>
        `,
      focusConfirm: false,
      showCancelButton: false,
      confirmButtonText: (
        <span style={{ display: "flex", alignItems: "center", gap: "0.5vw" }}>
          <AttachMoneyIcon sx={{ color: "white" }} />
          Pagar solicitud
        </span>
      ),
      cancelButtonText: "Cancelar",
      didOpen: () => {
        const select = document.getElementById("swal-formaPago");
        const ultimos4Group = document.getElementById("swal-ultimos4-group");
        const cantidadInput = document.getElementById("swal-cantidad");
        const cambioLabel = document.getElementById("swal-cambio");

        const actualizarCambio = () => {
          const recibido = parseFloat(cantidadInput.value) || 0;
          const cambio = recibido - restanteMonto;
          cambioLabel.textContent = cambio > 0 ? `$${cambio.toFixed(2)}` : "";
        };

        const actualizarUltimos4 = () => {
          const value = select.value;
          ultimos4Group.style.display = ["debito", "credito", "cheque", "transferencia"].includes(value) ? "flex" : "none";
        };

        select.addEventListener("change", () => {
          actualizarUltimos4();
          actualizarCambio();
        });

        cantidadInput.addEventListener("input", actualizarCambio);
        actualizarUltimos4();
        actualizarCambio();
      },
      preConfirm: () => {
        const formaPago = document.getElementById("swal-formaPago")?.value?.trim();
        const ultimos4 = document.getElementById("swal-ultimos4")?.value?.trim();
        const cantidad = document.getElementById("swal-cantidad")?.value?.trim();


        if (!formaPago || !cantidad) {
          Swal.showValidationMessage(
            "La forma de pago y la cantidad son obligatorias",
          );
          return false;
        }
        return { formaPago, ultimos4, cantidad };
      },
    });

    if (pagoNuevo) {
      try {
        let formaPagoN = pagoNuevo.formaPago;
        if (pagoNuevo.formaPago === "debito" || pagoNuevo.formaPago === "credito") {
          formaPagoN = "tarjeta";
        }
        const pagoBody = {
          formaPago: formaPagoN,
          ultimos4: pagoNuevo.ultimos4 || "",
          cantidad: Math.min(parseFloat(pagoNuevo.cantidad) || 0, restanteMonto),
          idSolicitud: selectedSolicitudId,
          cobro: currentU.id,
          fechaCobro: getFormattedNow(),
        };
        const resultado = await CajaService.pagarSolicitud(pagoBody);

        if (resultado?.data?.estatus === "OK") {
          // 1. Registrar primero el movimiento de pago en la BD
          await registrarMovimientoPago({
            cantidad: pagoBody.cantidad,
            formaPago: pagoBody.formaPago,
            operacion: "Recepción de pago",
          });
          registrarMovimientoSolicitud("PAG", `Recepción de pago: $${Number(pagoBody.cantidad).toFixed(2)} (${pagoBody.formaPago})`);

          // 2. AHORA recargar los totales neto desde la BD (incluye el pago guardado)
          await actualizarTotalesCaja(selectedSolicitudId);

          try {
            const printHist = await HistorialEstudiosService.getHistorialSolicitudImpresionEnvio(selectedSolicitudId);
            const totalStudiesRes = await SolicitudesEstudiosService.getEstudiosPorSolicitud(selectedSolicitudId);
            const totalEstudiosList = totalStudiesRes?.estudios || [];
            const printedEstudioIds = new Set((printHist || []).map(h => String(h.idEstudio)));
            const todosImpresos = totalEstudiosList.length > 0 && totalEstudiosList.every(st => printedEstudioIds.has(String(st.idEstudio)));

            if (todosImpresos || (printHist && printHist.length > 0)) {
              await SolicitudesService.updateSolicitud({
                estatusResultados: "E",
                estatus: "E"
              }, selectedSolicitudId);
              await HistorialService.registrarEvento({
                idSolicitud: selectedSolicitudId,
                nombreEmpleado: currentU?.nombre || "EMPLEADO",
                operacion: "Solicitud marcada como Entregada (E) tras saldar pago"
              });
            }
          } catch (ePaidSol) {
            console.error("Error al verificar entrega tras pago en Solicitudes:", ePaidSol);
          }

          // 3. Recargar la solicitud desde el backend para refrescar la UI por completo
          if (selectedSolicitudId) {
            try {
              const fullResp = await SolicitudesService.getSolicitudIndividual(selectedSolicitudId);
              const solPagada = fullResp?.solicitud?.[0] || fullResp?.solicitud || fullResp;
              if (solPagada && typeof solPagada === "object") {
                if (viewOnly) {
                  await verSolicitud(solPagada);
                } else if (editMode || editModeG) {
                  await editarSolicitud(solPagada);
                }
              }
            } catch (error) {
              console.error("Error al recargar la solicitud pagada:", error);
            }
          }
          mostrarMensajeSolicitud("Pago realizado correctamente");
        } else {
          mostrarError(resultado?.data?.mensaje || "No se pudo realizar el pago");
        }
      } catch (err) {
        console.error(err);
        mostrarError("No se pudo realizar el pago");
      }
    }
  }


  async function handleCancelarSolicitud() {
    const requiereReembolso = Number(pagadoResumen || 0) > 0;
    const { value: cancelacion } = await MySwal.fire({
      title: "CANCELAR SOLICITUD",
      width: "60%",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
        confirmButton: "btnConfirmRed",
      },
      html: `
          <div style="display:flex;flex-direction:column;gap:1vw;text-align:left;">
            <div class="tituloDegradado" style="font-size:1rem;padding:0.55vw 0.7vw;border-radius:8px;display:block;width:100%;text-align:center;font-weight:700;">${solicitudCodigo} <br /> ${nombre} ${apPaterno} ${apMaterno}</div>
            ${requiereReembolso
          ? `<div style="font-size:1.7rem;padding:0.3vw 0.5vw;border-radius:8px;display:block;text-align:center;font-weight:800;color:#18234f;">Cantidad a reembolsar: $${Number(pagadoResumen || 0).toFixed(2)}</div>`
          : `<div style="font-size:1rem;padding:0.3vw 0.5vw;border-radius:8px;display:block;text-align:center;font-weight:700;color:#666;">No hay ningún pago registrado, por lo tanto no es necesario reembolsar</div>`}
            <div style="display:grid;grid-template-columns:${requiereReembolso ? "repeat(auto-fit,minmax(180px,1fr))" : "1fr"};gap:1rem;margin-bottom:0.5vw;">
              <div style="display:flex;flex-direction:column;gap:0.35rem;">
                <label for="swal-motivoCancelacion" style="font-weight:700;font-size:0.95vw;">Motivo de cancelación:</label>
                <input id="swal-motivoCancelacion" class="input-swal" placeholder="" style="width:100%;padding:0.7vw 0.8vw;font-size:0.95vw;border:1px solid #cfd8dc;border-radius:6px;" />
              </div>
              ${requiereReembolso
          ? `<div style="display:flex;flex-direction:column;gap:0.35rem;">
                    <label for="swal-formaReembolso" style="font-weight:700;font-size:0.95vw;">Forma de Reembolso:</label>
                    <select class="swal-formaReembolso" id="swal-formaReembolso" style="width:100%;padding:0.7vw 0.8vw;font-size:0.95vw;border:1px solid #cfd8dc;border-radius:6px;">
                      <option value="efectivo">Efectivo</option>
                      <option value="debito">Tarjeta de debito</option>
                      <option value="credito">Tarjeta de credito</option>
                      <option value="cheque">Cheque</option>
                      <option value="transferencia">Transferencia</option>
                    </select>
                  </div>`
          : ""}
            </div>
          </div>
        `,
      focusConfirm: false,
      showCancelButton: false,
      confirmButtonText: (
        <span style={{ display: "flex", alignItems: "center", gap: "0.5vw" }}>
          <DoDisturbAltIcon sx={{ color: "white" }} />
          {requiereReembolso ? "Cancelar y reembolsar" : "Cancelar"}
        </span>
      ),
      cancelButtonText: "Cancelar",
      didOpen: () => { },
      preConfirm: () => {
        const motivoCancelacion = document.getElementById("swal-motivoCancelacion")?.value?.trim() || "";
        const formaReembolso = document.getElementById("swal-formaReembolso")?.value?.trim() || "";
        return { motivoCancelacion, formaReembolso, requiereReembolso };
      },
    });

    if (cancelacion) {
      try {
        let solcitudC = {
          idSolicitud: selectedSolicitudId,
          motivoCancelacion: cancelacion.motivoCancelacion,
          formaReembolso: cancelacion.formaReembolso,
          requiereReembolso: cancelacion.requiereReembolso,
          fecha: getFormattedNow(),
          reembolso: currentU.id,
        }
        await cancelarSolicitud(solcitudC);
        registrarMovimientoSolicitud("CAN", cancelacion.requiereReembolso ? `Cancelación con reembolso ($${Number(pagadoResumen || 0).toFixed(2)})` : "Cancelación de la solicitud");
        if (cancelacion.requiereReembolso) {
          await registrarMovimientoPago({ cantidad: pagadoResumen || 0, formaPago: cancelacion.formaReembolso || "Efectivo", operacion: "Cancelación con reembolso" });
        }
        await actualizarTotalesCaja(selectedSolicitudId);
      } catch (err) {
        console.error(err);
        mostrarError("No se pudo cancelar la solicitud");
      }
    }
  }


  async function enrichEstudioSelection(index, selectedValue) {
    if (!selectedValue) {
      setEstudios((prev) => {
        const next = [...prev];
        next[index] = {
          ...next[index],
          idEstudio: "",
          codigo: "",
          nombre: "",
          costo: "",
          tiempoEntrega: "",
          descuento: "",
          fechaEntrega: "",
          fechaMuestra: getFechaHoy(),
          muestraPendiente: false,
          muestras: [],
          estudiosInt: [],
        };
        return next;
      });
      return;
    }

    const id = selectedValue.idEstudio || "";
    const codigo = selectedValue.codigo || "";
    const nombre = selectedValue.nombre || "";

    let listaId = "";
    if (selectedEmpresa?.idListaPrecio) {
      listaId = selectedEmpresa.idListaPrecio;
    } else {
      listaId = await obtenerListaPrecioVigente();

    }

    if (!listaId) {
      mostrarError(
        "No existe una lista de precios vigente para la sucursal actual",
      );
      return;
    }


    const nombreL = preciosByLista?.[listaId]?.nombre ?? "Lista desconocida";
    setSelectedLista(nombreL);

    const costo =
      listaId &&
        preciosByLista[listaId] &&
        preciosByLista[listaId].precios[id] !== undefined
        ? preciosByLista[listaId].precios[id]
        : "";

    const getEstudioIntId = (estInt) =>
      String(estInt.idEstudioSec ?? estInt.idEstudio ?? estInt.idEstudioPrin ?? "");

    const existeEnOtraFila = estudios.some((e, idxItem) =>
      idxItem !== index &&
      (String(e.idEstudio) === String(id) ||
        (e.estudiosInt || []).some(
          (estInt) => getEstudioIntId(estInt) === String(id),
        )),
    );
    if (existeEnOtraFila) {
      mostrarError(
        "No se puede agregar porque este estudio ya está en la solicitud o ya forma parte de un estudio integrado.",
      );
      return;
    }

    try {
      const [estudioDetalle, muestras, estudiosInt] = await Promise.all([
        EstudiosService.getEstudioPorId(id),
        MuestrasService.getMuestrasPorEstudio(id),
        EstudiosIntService.getEstudiosPorEstudio(id),
      ]);

      const estudiosIntIds = new Set(
        (estudiosInt || []).map((intEstudio) => getEstudioIntId(intEstudio)),
      );

      const yaExiste = estudios.some((e, idxItem) =>
        idxItem !== index && String(e.idEstudio) === String(id),
      );
      if (yaExiste) {
        mostrarError("El estudio ya está agregado");
        return;
      }

      const yaIncluidoComoIntegrado = estudios.some((e) =>
        (e.estudiosInt || []).some((intEstudio) =>
          getEstudioIntId(intEstudio) === String(id),
        ),
      );
      if (yaIncluidoComoIntegrado) {
        mostrarError(
          "No se puede agregar este estudio porque ya forma parte de un estudio integrado ya agregado.",
        );
        return;
      }

      const algunoIntegradoYaAgregado = estudios.some((e) =>
        String(e.idEstudio) !== String(id) &&
        estudiosIntIds.has(String(e.idEstudio)),
      );
      if (algunoIntegradoYaAgregado) {
        mostrarError(
          "No se puede agregar este estudio porque uno de sus estudios integrados ya está en la solicitud.",
        );
        return;
      }

      const tiempoEntrega = estudioDetalle?.tiempoEntrega ?? "";
      const fechaEntrega = calcularFechaEntrega(tiempoEntrega);

      const muestrasConIndicaciones = (muestras || []).filter(
        (m) => m.indicacionesToma && m.indicacionesToma.trim() !== ""
      );

      if (muestrasConIndicaciones.length > 0) {
        const htmlContent = `
          <div style="text-align:left; font-size:1vw; font-family: Roboto-Regular; color: #333;">
            <p style="margin-bottom: 1.5vh; font-size: 1.1vw; font-weight: bold; color: #18234f;">
              El estudio <strong>"${nombre}"</strong> requiere las siguientes indicaciones de toma:
            </p>
            <div style="max-height: 40vh; overflow-y: auto; padding-right: 0.5vw;">
              ${muestrasConIndicaciones
            .map(
              (m) => `
                <div style="margin-bottom: 1.5vh; padding: 1vw; border-radius: 8px; border-left: 5px solid #e08505; background-color: #fcf8f2;">
                  <div style="font-weight: bold; color: #e08505; font-size: 0.95vw; margin-bottom: 0.5vh;">
                    Muestra: ${m.tipoMuestra || "No especificado"} (${m.nombreMaterial || "Material no especificado"})
                  </div>
                  <div style="font-size: 0.9vw; line-height: 1.4; color: #555;">
                    ${m.indicacionesToma}
                  </div>
                </div>
              `
            )
            .join("")}
            </div>
          </div>
        `;

        await Swal.fire({
          title: "INDICACIONES DE TOMA DE MUESTRA",
          html: htmlContent,
          icon: "warning",
          width: "50%",
          confirmButtonText: "He leído las indicaciones de toma",
          confirmButtonColor: "#2e7d32",
          allowOutsideClick: false,
          allowEscapeKey: false,
          customClass: {
            title: "tituloDegradado",
            popup: "swalMaxHeight",
          },
        });
      }

      setEstudios((prev) => {
        const next = [...prev];
        next[index] = {
          ...next[index],
          idEstudio: id,
          codigo,
          nombre,
          costo,
          descuento: "",
          tiempoEntrega,
          fechaEntrega,
          fechaMuestra: getFechaHoy(),
          muestraPendiente: false,
          muestras: muestras || [],
          estudiosInt: estudiosInt || [],
        };

        if (index === prev.length - 1) {
          next.push({
            cantidad: "1",
            codigo: "",
            nombre: "",
            costo: "",
            idEstudio: "",
            descuento: "",
            tiempoEntrega: "",
            fechaEntrega: "",
            fechaMuestra: getFechaHoy(),
            muestraPendiente: false,
            muestras: [],
            estudiosInt: [],
          });
        }

        return next;
      });
    } catch (err) {
      console.error(err);
    }
  }

  const parseNumero = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const tieneDescuentoPorEstudio = (items = estudios) =>
    items.some((estudio) => {
      const descuento = estudio?.descuento;
      return (
        descuento !== "" &&
        descuento !== null &&
        descuento !== undefined &&
        parseNumero(descuento) > 0
      );
    });

  const calcularSubtotal = (items = estudios) =>
    items.reduce((acc, estudio) => {
      const cantidad = parseNumero(estudio?.cantidad || 0);
      const costo = parseNumero(estudio?.costo || 0);
      return acc + cantidad * costo;
    }, 0);

  const calcularDescuentoTotalLocal = (items = estudios) => {
    const usaDescuentoPorEstudio = tieneDescuentoPorEstudio(items);

    if (opcionDescuento === "porcentaje") {
      if (!usaDescuentoPorEstudio && valorGeneral !== "" && valorGeneral !== null) {
        const porcentaje = parseNumero(valorGeneral);
        if (porcentaje > 100) {
          mostrarError("El porcentaje no puede ser mayor a 100%");
          setValorGeneral("");
          return 0;
        }

        if (porcentaje > 0) {
          return calcularSubtotal(items) * (porcentaje / 100);
        }
      }

      return items.reduce((acc, estudio) => {
        const porcentaje = parseNumero(estudio?.descuento || 0);
        const cantidad = parseNumero(estudio?.cantidad || 0);
        const costo = parseNumero(estudio?.costo || 0);
        return acc + cantidad * costo * (porcentaje / 100);
      }, 0);
    }

    if (opcionDescuento === "cantidad") {
      if (!usaDescuentoPorEstudio && valorGeneral !== "" && valorGeneral !== null) {
        const descuento = parseNumero(valorGeneral);
        if (descuento > 0) {
          return descuento;
        }
      }

      return items.reduce((acc, estudio) => acc + parseNumero(estudio?.descuento || 0), 0);
    }

    return 0;
  };

  const obtenerDatosCaja = (respuestaCaja) => {
    if (!respuestaCaja) return null;

    const payload = respuestaCaja?.data ?? respuestaCaja;
    const items = Array.isArray(payload?.caja)
      ? payload.caja
      : Array.isArray(payload)
        ? payload
        : [];

    const item = items[0] ?? payload?.caja?.[0] ?? payload?.[0] ?? payload;
    return item && typeof item === "object" ? item : null;
  };

  const normalizarTotalesCaja = (respuestaCaja) => {
    const datosCaja = obtenerDatosCaja(respuestaCaja);
    const subtotal = parseNumero(
      datosCaja?.subtotal ??
      datosCaja?.subtotalCaja ??
      datosCaja?.total ??
      datosCaja?.totalSolicitud ??
      datosCaja?.importe ??
      datosCaja?.monto ??
      0,
    );
    const descuento = parseNumero(
      datosCaja?.descuento ??
      datosCaja?.descuentoTotal ??
      datosCaja?.descuentoSolicitud ??
      0,
    );
    const iva = parseNumero(
      datosCaja?.iva ??
      datosCaja?.ivaTotal ??
      datosCaja?.montoIva ??
      0,
    );
    const adeudo = parseNumero(
      datosCaja?.adeudo ??
      datosCaja?.saldoPendiente ??
      datosCaja?.restante ??
      datosCaja?.saldo ??
      datosCaja?.pendiente ??
      datosCaja?.deuda ??
      0,
    );
    const aCuentaExplicito = parseNumero(
      datosCaja?.aCuenta ??
      datosCaja?.pagado ??
      datosCaja?.montoPagado ??
      datosCaja?.totalPagado ??
      datosCaja?.pagos ??
      datosCaja?.importePagado ??
      datosCaja?.pagadoSolicitud ??
      datosCaja?.abono ??
      datosCaja?.abonos ??
      0,
    );

    const total = Math.max(0, subtotal - descuento + iva);
    const aCuenta =
      aCuentaExplicito > 0
        ? aCuentaExplicito
        : (adeudo > 0 ? Math.max(0, total - adeudo) : Math.max(0, total));
    const restante = adeudo > 0 ? adeudo : Math.max(0, total - aCuenta);

    return {
      subtotal,
      descuento,
      iva,
      adeudo,
      total,
      aCuenta,
      restante,
    };
  };

  const actualizarTotalesCaja = async (solicitudId) => {
    if (!solicitudId) return;

    try {
      const cajaRespuesta = await CajaService.getCajaPorSolicitud(solicitudId);
      const cajaTotales = normalizarTotalesCaja(cajaRespuesta);

      let totalPagosSum = 0;
      let totalReembolsosSum = 0;

      try {
        const historialPagos = await HistorialService.getHistorialPagos(solicitudId);
        if (Array.isArray(historialPagos) && historialPagos.length > 0) {
          historialPagos.forEach((item) => {
            const cant = Number(item.cantidad || 0);
            const op = (item.operacion || "").toLowerCase();
            if (op.includes("reembolso") || op.includes("cancelación") || op.includes("eliminación")) {
              totalReembolsosSum += cant;
            } else {
              totalPagosSum += cant;
            }
          });
        } else {
          const datosCaja = obtenerDatosCaja(cajaRespuesta);
          const idCaja = datosCaja?.idCaja;
          if (idCaja) {
            const resPagos = await CajaPagosService.getPagosPorCaja(idCaja);
            const pagos = resPagos?.pagos || [];
            pagos.forEach((p) => { totalPagosSum += Number(p.monto || 0); });

            const resReemb = await CajaPagosService.getReembolsosPorCaja(idCaja);
            const reembolsos = resReemb?.reembolsos || [];
            reembolsos.forEach((r) => { totalReembolsosSum += Number(r.monto || 0); });
          }
        }
      } catch (errP) {
        console.warn("Error obteniendo pagos y reembolsos de BD:", errP);
      }

      const pagadoBruto = totalPagosSum > 0 ? totalPagosSum : cajaTotales.aCuenta;
      const pagadoNeto = Math.max(0, pagadoBruto - totalReembolsosSum);
      const restanteNeto = Math.max(0, cajaTotales.total - pagadoNeto);

      setTotalesCaja({
        ...cajaTotales,
        totalPagos: totalPagosSum,
        totalReembolsos: totalReembolsosSum,
        aCuenta: pagadoNeto,
        restante: restanteNeto,
      });

      setSolicitudACuenta(pagadoNeto);
      setSolicitudRestante(restanteNeto);
      setSolicitudSaldoPendiente(restanteNeto);
    } catch (error) {
      console.error("Error actualizando totales de caja:", error);
    }
  };

  const subtotalSolicitud = calcularSubtotal();
  const descuentoTotal = calcularDescuentoTotalLocal();
  const baseResumen = Math.max(0, subtotalSolicitud - descuentoTotal);
  const ivaResumen = requiereFactura ? baseResumen * 0.16 : 0;
  const totalResumen = baseResumen + ivaResumen;

  const subtotalResumen = subtotalSolicitud;
  const descuentoResumen = descuentoTotal;
  const totalSolicitud = totalResumen;
  const ivaSolicitud = ivaResumen;

  const showExtendedTotals = viewOnly || editModeG || editMode || editModeM;
  const showEstadoRow = showExtendedTotals;
  const esSolicitudPagada = ["P", "E"].includes(`${solicitudEstatus ?? ""}`.trim().toUpperCase());

  const pagadoResumen = Number(totalesCaja?.aCuenta) || parseNumero(solicitudACuenta) || 0;
  const adeudoResumen = showExtendedTotals
    ? Math.max(0, totalResumen - pagadoResumen)
    : 0;
  const porcentajeEquivalente =
    opcionDescuento === "porcentaje" && subtotalSolicitud > 0
      ? ((descuentoTotal / subtotalSolicitud) * 100).toFixed(2)
      : "";

  const solicitudEstatusLabel =
    estatusMapHTML[solicitudEstatus]?.label || solicitudEstatus || "";
  const aCuentaMonto = showExtendedTotals ? Math.max(pagadoResumen, parseNumero(solicitudACuenta)) : 0;
  const restanteMonto = showExtendedTotals ? Math.max(0, totalResumen - aCuentaMonto) : 0;
  const saldoPendienteMonto = restanteMonto;

  const valorGeneralMostrado =
    opcionDescuento === "ninguno"
      ? ""
      : tieneDescuentoPorEstudio()
        ? porcentajeEquivalente
        : valorGeneral;

  const showFechaMuestraColumn = viewOnly || editModeG || editMode || editModeM;

  const validarDescuentosFormulario = (
    opcionDesc = opcionDescuento,
    valGen = valorGeneral,
    listaEstudios = estudios,
    totPagado = pagadoResumen
  ) => {
    if (opcionDesc === "ninguno") {
      return { esValido: true, errorGeneral: "", erroresEstudios: new Array(listaEstudios.length).fill("") };
    }

    const subtotalBruto = calcularSubtotal(listaEstudios);
    const factorIva = requiereFactura ? 1.16 : 1.0;

    let errGeneral = "";
    const errEstudios = new Array(listaEstudios.length).fill("");

    if (opcionDesc === "porcentaje") {
      const usaDescPorEstudio = tieneDescuentoPorEstudio(listaEstudios);
      // 1. Validar descuento general en porcentaje si aplica
      if (!usaDescPorEstudio && valGen !== "" && valGen !== null && valGen !== undefined) {
        const pctVal = parseNumero(valGen);
        if (pctVal > 100) {
          errGeneral = "El descuento en porcentaje no puede ser mayor a 100%.";
        } else if (totPagado > 0 && pctVal > 0) {
          const totalBrutoSinDesc = subtotalBruto * factorIva;
          const deudaDisponibleGen = Math.max(0, totalBrutoSinDesc - totPagado);
          const maxDescBaseGen = Math.max(0, subtotalBruto - (totPagado / factorIva));
          const montoDescSubtotal = subtotalBruto * (pctVal / 100);

          if (montoDescSubtotal > maxDescBaseGen + 0.001) {
            errGeneral = `El descuento no puede superar la deuda restante.`;
          }
        }
      }

      // 2. Validar porcentaje por estudio (no > 100%)
      listaEstudios.forEach((est, idx) => {
        if (est?.descuento !== "" && est?.descuento !== null && est?.descuento !== undefined) {
          const pctEst = parseNumero(est.descuento);
          if (pctEst > 100) {
            errEstudios[idx] = "El descuento en porcentaje no puede ser mayor a 100%.";
          }
        }
      });

      // 3. Validar deuda restante disponible para cada estudio individual (excluyendo el estudio actual)
      if (totPagado > 0) {
        listaEstudios.forEach((est, idx) => {
          if (errEstudios[idx]) return;
          const descEst = parseNumero(est?.descuento);
          if (descEst <= 0) return;

          const otrosDescuentos = listaEstudios.reduce((acc, item, itemIdx) => {
            if (itemIdx === idx) return acc;
            const pct = parseNumero(item?.descuento || 0);
            const cant = parseNumero(item?.cantidad || 1);
            const cst = parseNumero(item?.costo || 0);
            return acc + (cant * cst * (pct / 100));
          }, 0);

          const subtotalBaseOtros = Math.max(0, subtotalBruto - otrosDescuentos);
          const totalConIvaOtros = subtotalBaseOtros * factorIva;
          const deudaDisponibleEsteEstudio = Math.max(0, totalConIvaOtros - totPagado);
          const maxDescBaseEsteEstudio = Math.max(0, subtotalBaseOtros - (totPagado / factorIva));

          const cantEst = parseNumero(est?.cantidad || 1);
          const cstEst = parseNumero(est?.costo || 0);
          const montoDescEsteEstudio = (cantEst * cstEst) * (descEst / 100);

          if (montoDescEsteEstudio > maxDescBaseEsteEstudio + 0.001) {
            errEstudios[idx] = `El descuento no puede superar la deuda restante.`;
          }
        });
      }
    } else if (opcionDesc === "cantidad") {
      const usaDescPorEstudio = tieneDescuentoPorEstudio(listaEstudios);
      // 1. Validar descuento general en monto
      if (!usaDescPorEstudio && valGen !== "" && valGen !== null && valGen !== undefined) {
        const montoVal = parseNumero(valGen);
        if (montoVal > subtotalBruto) {
          errGeneral = "El descuento no puede ser mayor al total de la solicitud.";
        } else if (totPagado > 0 && montoVal > 0) {
          const totalBrutoSinDesc = subtotalBruto * factorIva;
          const deudaDisponibleGen = Math.max(0, totalBrutoSinDesc - totPagado);
          const maxDescBaseGen = Math.max(0, subtotalBruto - (totPagado / factorIva));

          if (montoVal > maxDescBaseGen + 0.001) {
            errGeneral = `El descuento no puede superar la deuda restante.`;
          }
        }
      }

      // 2. Validar descuento por estudio no mayor al costo del estudio
      listaEstudios.forEach((est, idx) => {
        if (est?.descuento !== "" && est?.descuento !== null && est?.descuento !== undefined) {
          const montoEst = parseNumero(est.descuento);
          const costoEst = parseNumero(est.costo) * parseNumero(est.cantidad || 1);
          if (montoEst > costoEst) {
            errEstudios[idx] = "El descuento no puede ser mayor al total del estudio.";
          }
        }
      });

      // 3. Validar deuda restante disponible para cada estudio en monto (excluyendo el estudio actual)
      if (totPagado > 0) {
        listaEstudios.forEach((est, idx) => {
          if (errEstudios[idx]) return;
          const montoEst = parseNumero(est?.descuento);
          if (montoEst <= 0) return;

          const otrosDescuentos = listaEstudios.reduce((acc, item, itemIdx) => {
            if (itemIdx === idx) return acc;
            return acc + parseNumero(item?.descuento || 0);
          }, 0);

          const subtotalBaseOtros = Math.max(0, subtotalBruto - otrosDescuentos);
          const totalConIvaOtros = subtotalBaseOtros * factorIva;
          const deudaDisponibleEsteEstudio = Math.max(0, totalConIvaOtros - totPagado);
          const maxDescBaseEsteEstudio = Math.max(0, subtotalBaseOtros - (totPagado / factorIva));

          if (montoEst > maxDescBaseEsteEstudio + 0.001) {
            errEstudios[idx] = `El descuento no puede superar la deuda restante.`;
          }
        });
      }
    }

    return {
      esValido: !errGeneral && !errEstudios.some(Boolean),
      errorGeneral: errGeneral,
      erroresEstudios: errEstudios,
    };
  };

  useEffect(() => {
    const resVal = validarDescuentosFormulario(opcionDescuento, valorGeneral, estudios, pagadoResumen);
    setErrorDescuentoGeneral(resVal.errorGeneral);
    setErroresDescuentoEstudios(resVal.erroresEstudios);
  }, [opcionDescuento, valorGeneral, estudios, totalesCaja, solicitudACuenta, requiereFactura]);

  const handleChangeEstudio = (index, field, value) => {
    if (opcionDescuento === "porcentaje" && field === "descuento" && parseNumero(value) > 100) {
      mostrarError("El descuento en porcentaje no puede ser mayor a 100%.");
    }

    const valorNormalizado = ["fechaMuestra", "fechaEntrega"].includes(field)
      ? formatDateForBackend(value)
      : value;

    if (field === "fechaEntrega" && modoEntrega === "asignarFecha") {
      setFechaGlobal("");
      setEstudios((prev) =>
        prev.map((estudio, idx) =>
          idx === index
            ? {
              ...estudio,
              fechaEntrega: valorNormalizado,
              urgente: true,
            }
            : estudio,
        ),
      );
      return;
    }

    const nuevosEstudios = [...estudios];
    const estudioAnterior = estudios[index] || {};
    nuevosEstudios[index] = {
      ...estudioAnterior,
      [field]: valorNormalizado,
    };
    setEstudios(nuevosEstudios);

    // Si se cambió el descuento y hay un modo de descuento activo, actualizar valores relacionados
    if (field === "descuento" && opcionDescuento !== "ninguno") {
      if (opcionDescuento === "porcentaje") {
        const tieneDescuento = nuevosEstudios.some(
          (estudio) => estudio.descuento !== "" && estudio.descuento !== null,
        );
        if (tieneDescuento) {
          const subtotal = calcularSubtotal(nuevosEstudios);
          const totalDescuento = calcularDescuentoTotalLocal(nuevosEstudios);
          const porcentajeEquivalente =
            subtotal > 0 ? ((totalDescuento / subtotal) * 100).toFixed(2) : "";
          setValorGeneral(porcentajeEquivalente);
        } else {
          setValorGeneral("");
        }
      } else if (opcionDescuento === "cantidad") {
        // Para descuentos por cantidad no forzamos un valor general automático
        setValorGeneral("");
      }
    }
  };

  const getFechaEntregaNormal = (estudio) =>
    estudio?.idEstudio ? calcularFechaEntrega(estudio.tiempoEntrega) : "";

  const handleChangeValorGeneral = (value) => {
    setValorGeneral(value);

    if (opcionDescuento === "ninguno" || value === "" || value === null) {
      return;
    }

    setEstudios((prev) =>
      prev.map((estudio) => ({
        ...estudio,
        descuento: "",
      })),
    );
  };

  const handleChangeOpcionDescuento = (value) => {
    setOpcionDescuento(value);
    setValorGeneral("");
    setEstudios((prev) =>
      prev.map((estudio) => ({
        ...estudio,
        descuento: "",
      })),
    );
  };

  const cargarCotizacionEnFormulario = async (numeroCotizacion) => {
    const valor = `${numeroCotizacion ?? ""}`.trim();
    if (!valor) {
      return;
    }

    try {
      const respuesta = await CotizacionesService.getCotizacionIndividual(valor);
      const cotizacion = respuesta?.cotizacion?.[0] || respuesta?.cotizacion || null;

      if (!cotizacion) {
        mostrarError(`No existe una cotización con el número ${valor}.`);
        setCotizacionHeader(null);
        setCotizacionNumero(valor);
        return;
      }

      setCotizacionHeader(cotizacion);
      setCotizacionNumero(String(cotizacion.idCotizacion ?? valor));
      setFecha(cotizacion.fecha || getFechaHoy());
      setShowCotizacionPacienteHeader(false);
      setSelectedDoctor(null);
      setNombreDoctor("");
      setApPaternoDoctor("");
      setApMaternoDoctor("");
      setEmailDoctor("");
      setTelefonoDoctor("");

      let empresaCompleta = null;
      if (cotizacion.idConvenio) {
        const convenioResp = await ConveniosService.getConvenioPorId(
          cotizacion.idConvenio,
        );
        empresaCompleta = convenioResp?.convenio?.[0] || convenioResp?.convenio || null;
      }
      await actualizarListaPreciosParaConvenio(empresaCompleta);

      if (cotizacion.idPaciente) {
        const pacienteResp = await PacientesService.getPacientePorId(
          cotizacion.idPaciente,
        );
        const pacienteCompleto = pacienteResp?.paciente?.[0] || pacienteResp?.paciente || null;
        if (pacienteCompleto) {
          setSelectedPaciente(pacienteCompleto);
          setNombre(pacienteCompleto.nombre || "");
          setApPaterno(pacienteCompleto.apPaterno || "");
          setApMaterno(pacienteCompleto.apMaterno || "");
          setSexo(pacienteCompleto.sexo || "");
          setFechaNac(pacienteCompleto.fechaNacimiento || "");
          setEdad(pacienteCompleto.edad || "");
          setEmail(pacienteCompleto.email || "");
          setTelefonoCelular(pacienteCompleto.telefonoCelular || "");
          setDireccion(pacienteCompleto.direccion || "");
          setColonia(pacienteCompleto.colonia || "");
          setCPostal(pacienteCompleto.cPostal || "");
          setEstado(pacienteCompleto.estado || "seleccione");
          setCiudad(pacienteCompleto.ciudad || "");
          setIne(pacienteCompleto.ine || "");
        } else {
          setSelectedPaciente(null);
        }
      } else {
        setSelectedPaciente(null);
      }

      const respuestaEstudios = await CotizacionesEstudiosService.getEstudiosPorCotizacion(
        cotizacion.idCotizacion,
      );
      const estudiosCotizacion = respuestaEstudios?.estudios || [];
      const estudiosConDetalles = await Promise.all(
        estudiosCotizacion.map(async (estudio) => {
          const estudioPorId = await EstudiosService.getEstudioPorId(
            estudio.idEstudio,
          );
          const [muestras, estudiosInt] = await Promise.all([
            MuestrasService.getMuestrasPorEstudio(estudio.idEstudio),
            EstudiosIntService.getEstudiosPorEstudio(estudio.idEstudio),
          ]);

          return {
            ...estudio,
            codigo: estudioPorId?.codigo || "",
            nombre: estudioPorId?.nombre || "",
            costo: estudio.costo ?? estudioPorId?.costo ?? "",
            tiempoEntrega: estudioPorId?.tiempoEntrega || "",
            descuento: estudio.descuento ?? "",
            fechaEntrega: formatDateForBackend(estudio.fechaEntrega || calcularFechaEntrega(estudioPorId?.tiempoEntrega || "")),
            fechaMuestra:
              estudio.fechaMuestra === "PENDIENTE"
                ? "PENDIENTE"
                : formatDateForBackend(estudio.fechaMuestra || getFechaHoy()),
            muestraPendiente:
              normalizarBooleano(estudio.muestraPendiente) ||
              `${estudio.fechaMuestra || ""}`.trim().toUpperCase() === "PENDIENTE",
            urgente: estudio.urgente,
            muestras: muestras || [],
            estudiosInt: estudiosInt || [],
          };
        }),
      );

      setEstudios(
        estudiosConDetalles.length > 0
          ? estudiosConDetalles
          : [
            {
              cantidad: "1",
              codigo: "",
              nombre: "",
              costo: "",
              tiempoEntrega: "",
              idEstudio: "",
              descuento: "",
              fechaEntrega: "",
              fechaMuestra: getFechaHoy(),
              muestraPendiente: false,
            },
          ],
      );
      setNotas(cotizacion.observaciones || "");
      setValorGeneral(cotizacion.descuentoTotal ?? "");
      setOpcionDescuento(cotizacion.tipoDescuento || "ninguno");
      setMotivoDescuento(cotizacion.motivoDescuento || "");
    } catch (error) {
      console.error(error);
      mostrarError("No se pudo cargar la cotización. Intenta de nuevo.");
    }
  };

  const cargarDoctoresDeSolicitud = async (solData) => {
    let countDocs = 1;

    const d1Id = solData.idDoctor || solData.id_doctor || (Array.isArray(solData.idDoctores) ? solData.idDoctores[0] : null);
    const d1Obj = solData.doctor || (Array.isArray(solData.doctores) && typeof solData.doctores[0] === "object" ? solData.doctores[0] : null);

    if (d1Id) {
      try {
        const res1 = await DoctoresService.getDoctorPorId(d1Id);
        const d1 = res1.doctor?.[0] || res1.doctor || res1.data?.doctor?.[0] || res1.data?.doctor;
        if (d1) {
          setSelectedDoctor(d1);
          setNombreDoctor(d1.nombre || "");
          setApPaternoDoctor(d1.apPaterno || "");
          setApMaternoDoctor(d1.apMaterno || "");
          setTelefonoDoctor(d1.telefonoCelular || d1.telefono || "");
          setEmailDoctor(d1.email || "");
        }
      } catch (e) {
        console.error("Error al cargar Doctor 1:", e);
      }
    } else if (d1Obj) {
      setNombreDoctor(d1Obj.nombre || "");
      setApPaternoDoctor(d1Obj.apPaterno || "");
      setApMaternoDoctor(d1Obj.apMaterno || "");
      setTelefonoDoctor(d1Obj.telefonoCelular || d1Obj.telefono || "");
      setEmailDoctor(d1Obj.email || "");
    }

    const d2Id = solData.idDoctor2 || solData.id_doctor2 || solData.idDoctor_2 || (Array.isArray(solData.idDoctores) ? solData.idDoctores[1] : null);
    const d2Obj = solData.doctor2 || (Array.isArray(solData.doctores) && typeof solData.doctores[1] === "object" ? solData.doctores[1] : null);

    if (d2Id) {
      countDocs = 2;
      try {
        const res2 = await DoctoresService.getDoctorPorId(d2Id);
        const d2 = res2.doctor?.[0] || res2.doctor || res2.data?.doctor?.[0] || res2.data?.doctor;
        if (d2) {
          setSelectedDoctor2(d2);
          setNombreDoctor2(d2.nombre || "");
          setApPaternoDoctor2(d2.apPaterno || "");
          setApMaternoDoctor2(d2.apMaterno || "");
          setTelefonoDoctor2(d2.telefonoCelular || d2.telefono || "");
          setEmailDoctor2(d2.email || "");
        }
      } catch (e) {
        console.error("Error al cargar Doctor 2:", e);
      }
    } else if (d2Obj && (d2Obj.nombre || d2Obj.apPaterno)) {
      countDocs = 2;
      setNombreDoctor2(d2Obj.nombre || "");
      setApPaternoDoctor2(d2Obj.apPaterno || "");
      setApMaternoDoctor2(d2Obj.apMaterno || "");
      setTelefonoDoctor2(d2Obj.telefonoCelular || d2Obj.telefono || "");
      setEmailDoctor2(d2Obj.email || "");
    } else {
      setSelectedDoctor2(null);
      setNombreDoctor2("");
      setApPaternoDoctor2("");
      setApMaternoDoctor2("");
      setTelefonoDoctor2("");
      setEmailDoctor2("");
    }

    const d3Id = solData.idDoctor3 || solData.id_doctor3 || solData.idDoctor_3 || (Array.isArray(solData.idDoctores) ? solData.idDoctores[2] : null);
    const d3Obj = solData.doctor3 || (Array.isArray(solData.doctores) && typeof solData.doctores[2] === "object" ? solData.doctores[2] : null);

    if (d3Id) {
      countDocs = 3;
      try {
        const res3 = await DoctoresService.getDoctorPorId(d3Id);
        const d3 = res3.doctor?.[0] || res3.doctor || res3.data?.doctor?.[0] || res3.data?.doctor;
        if (d3) {
          setSelectedDoctor3(d3);
          setNombreDoctor3(d3.nombre || "");
          setApPaternoDoctor3(d3.apPaterno || "");
          setApMaternoDoctor3(d3.apMaterno || "");
          setTelefonoDoctor3(d3.telefonoCelular || d3.telefono || "");
          setEmailDoctor3(d3.email || "");
        }
      } catch (e) {
        console.error("Error al cargar Doctor 3:", e);
      }
    } else if (d3Obj && (d3Obj.nombre || d3Obj.apPaterno)) {
      countDocs = 3;
      setNombreDoctor3(d3Obj.nombre || "");
      setApPaternoDoctor3(d3Obj.apPaterno || "");
      setApMaternoDoctor3(d3Obj.apMaterno || "");
      setTelefonoDoctor3(d3Obj.telefonoCelular || d3Obj.telefono || "");
      setEmailDoctor3(d3Obj.email || "");
    } else {
      setSelectedDoctor3(null);
      setNombreDoctor3("");
      setApPaternoDoctor3("");
      setApMaternoDoctor3("");
      setTelefonoDoctor3("");
      setEmailDoctor3("");
    }

    setCantidadDoctores(countDocs);
  };

  const verSolicitud = async (solicitud) => {
    let solData = solicitud;
    if (solicitud?.idSolicitud) {
      try {
        const fullResp = await SolicitudesService.getSolicitudIndividual(solicitud.idSolicitud);
        if (fullResp) {
          const rawSol = fullResp.solicitud?.[0] || fullResp.solicitud || fullResp.data?.solicitud?.[0] || fullResp.data?.solicitud || fullResp;
          if (rawSol && typeof rawSol === "object") {
            solData = { ...solicitud, ...rawSol };
          }
        }
      } catch (err) {
        console.error("Error al obtener solicitud individual:", err);
      }
    }

    const datosHeader = {
      codigoSolicitud: solData?.codigo || null,
      fecha: solData?.fecha || "",
      nombreInserto: [
        solData?.nombreInserto || solicitud?.nombreInserto,
        solData?.apPaternoInserto || solicitud?.apPaternoInserto,
        solData?.apMaternoInserto || solicitud?.apMaternoInserto,
      ]
        .map((p) => (p || "").trim())
        .filter(Boolean)
        .join(" ") || solData?.inserto || solicitud?.inserto || "",
      nombreSucursal:
        solData?.nombreSucursal ||
        solData?.sucursalNombre ||
        solData?.sucursal ||
        "",
    };

    setSolicitudCodigo(datosHeader.codigoSolicitud || "");
    setSolicitudFecha(datosHeader.fecha);
    setSolicitudInserto(datosHeader.nombreInserto);
    setSucursalNombre(datosHeader.nombreSucursal);
    setFecha(datosHeader.fecha);
    setShowCotizacionPacienteHeader(true);

    try {
      let resultado;
      if (solData.idConvenio) {
        const convenioResultado = await ConveniosService.getConvenioPorId(
          solData.idConvenio,
        );
        await actualizarTotalesCaja(solData.idSolicitud);
        const estatusSolicitudInicio = `${solData.estatus ?? "S"}`.trim().toUpperCase();
        setSolicitudEstatus(estatusSolicitudInicio);
        let empresaCompleta = convenioResultado.convenio[0];
        setEmpresa(empresaCompleta.nombre);
        setSelectedEmpresa(empresaCompleta);
      }
      if (solData.idPaciente) {
        resultado = await PacientesService.getPacientePorId(
          solData.idPaciente,
        );
        let pacienteCompleto = resultado.paciente;
        setSelectedPaciente(pacienteCompleto[0]);
        setNombre(pacienteCompleto[0].nombre);
        setApPaterno(pacienteCompleto[0].apPaterno);
        setApMaterno(pacienteCompleto[0].apMaterno);
        setSexo(pacienteCompleto[0].sexo);
        setFechaNac(pacienteCompleto[0].fechaNacimiento);
        setEdad(pacienteCompleto[0].edad);
        setEmail(pacienteCompleto[0].email);
        setTelefonoCelular(pacienteCompleto[0].telefonoCelular);
        setDireccion(pacienteCompleto[0].direccion);
        setColonia(pacienteCompleto[0].colonia);
        setCPostal(pacienteCompleto[0].cPostal);
        setEstado(pacienteCompleto[0].estado);
        setCiudad(pacienteCompleto[0].ciudad);
        setIne(pacienteCompleto[0].ine);
      }

      await cargarDoctoresDeSolicitud(solData);
      resultado = await SolicitudesEstudiosService.getEstudiosPorSolicitud(
        solicitud.idSolicitud,
      );
      let estudiosCompleto = resultado.estudios;
      const estudiosConDetalles = await Promise.all(
        estudiosCompleto.map(async (estudio) => {
          const estudioPorId = await EstudiosService.getEstudioPorId(
            estudio.idEstudio,
          );
          const [muestras, estudiosInt] = await Promise.all([
            MuestrasService.getMuestrasPorEstudio(estudio.idEstudio),
            EstudiosIntService.getEstudiosPorEstudio(estudio.idEstudio),
          ]);

          return {
            ...estudio,
            cantidad: estudio?.cantidad ?? "1",
            costo: estudio?.costo ?? estudioPorId?.costo ?? "",
            codigo: estudioPorId?.codigo || "",
            nombre: estudioPorId?.nombre || "",
            descuento: estudio?.descuento ?? "",
            tiempoEntrega: estudioPorId?.tiempoEntrega || "",
            fechaEntrega: formatDateForBackend(estudio.fechaEntrega || ""),
            fechaMuestra: formatDateForInput(estudio.fechaMuestra || getFechaHoy()),
            muestraPendiente: estudio.muestraPendiente || false,
            muestras: muestras || [],
            estudiosInt: estudiosInt || [],
          };
        }),
      );
      setEstudios(estudiosConDetalles);
      setEstudiosOriginales(estudiosConDetalles);
      setNotas(solicitud.notas);
      setNumCuarto(solicitud.numCuarto || "");

      const subtotalEstudiosVer = calcularSubtotal(estudiosConDetalles);
      const tipoDescVer = solData?.tipoDescuento || solicitud.tipoDescuento || "ninguno";
      const descTotalValVer = solData?.descuentoTotal ?? solicitud.descuentoTotal;
      const motivoDescValVer = solData?.motivoDescuento || solicitud.motivoDescuento || "";
      let valorGenVer = "";

      if (tipoDescVer === "porcentaje") {
        const tieneDescEstudios = tieneDescuentoPorEstudio(estudiosConDetalles);
        const montoDesc = parseNumero(descTotalValVer);
        if (tieneDescEstudios) {
          const totalDesc = estudiosConDetalles.reduce((acc, est) => {
            const pct = parseNumero(est?.descuento || 0);
            const cant = parseNumero(est?.cantidad || 0);
            const cst = parseNumero(est?.costo || 0);
            return acc + cant * cst * (pct / 100);
          }, 0);
          valorGenVer = subtotalEstudiosVer > 0 ? ((totalDesc / subtotalEstudiosVer) * 100).toFixed(2) : "";
        } else if (subtotalEstudiosVer > 0 && montoDesc > 0) {
          const pctCalculado = Math.min(100, Math.max(0, (montoDesc / subtotalEstudiosVer) * 100));
          const pctRedondeado = Math.round(pctCalculado * 100) / 100;
          valorGenVer = pctRedondeado % 1 === 0 ? String(pctRedondeado) : String(pctRedondeado);
        }
      } else if (tipoDescVer === "cantidad") {
        valorGenVer = descTotalValVer !== undefined && descTotalValVer !== null && descTotalValVer !== "" ? String(descTotalValVer) : "";
      }

      setValorGeneral(valorGenVer);
      setOpcionDescuento(tipoDescVer);
      setMotivoDescuento(motivoDescValVer);
      setOpcionDescuentoOriginal(tipoDescVer);
      setValorGeneralOriginal(valorGenVer);
      setMotivoDescuentoOriginal(motivoDescValVer);
      setSelectedSolicitudId(solicitud.idSolicitud || null);
      setSolicitudCodigo(solicitud.codigo || "");
      setSolicitudFecha(solicitud.fecha || "");
      setSolicitudInserto(datosHeader.nombreInserto || solicitud.nombreInserto || "");
      setSucursalNombre(solicitud.nombreSucursal || "");
      await actualizarTotalesCaja(solicitud.idSolicitud);

      const reqFact = Boolean(
        solData?.requiereFactura === 1 ||
        solData?.requiereFactura === "1" ||
        solData?.requiereFactura === true ||
        solData?.requiereFactura === "si" ||
        solData?.factura === 1 ||
        solData?.factura === "1" ||
        solData?.factura === true ||
        solData?.factura === "si" ||
        parseNumero(solData?.iva) > 0 ||
        parseNumero(solData?.ivaN) > 0 ||
        parseNumero(totalesCaja?.iva) > 0 ||
        solicitud?.requiereFactura === 1 ||
        solicitud?.requiereFactura === "1" ||
        solicitud?.requiereFactura === true ||
        solicitud?.requiereFactura === "si" ||
        parseNumero(solicitud?.iva) > 0 ||
        parseNumero(solicitud?.ivaN) > 0
      );
      setRequiereFactura(reqFact);

      const estatusSolicitud = `${solicitud.estatus ?? "S"}`.trim().toUpperCase();
      setSolicitudEstatus(estatusSolicitud);
      try {
        const suc = await SucursalesService.getSucursalIndividual(solicitud.idSucursal);
        setSolicitudSucursalNombre(suc?.nombre || "");

      } catch (err) {
        console.error("Error fetching sucursal:", err);
      }
    } catch (error) {
      console.error(error);
    }

    const estatusSolicitud = `${solicitud?.estatus ?? "S"}`.trim().toUpperCase();
    if (esEstatusSoloLectura(estatusSolicitud)) {
      aplicarBloqueoPorEstatus(estatusSolicitud);
    } else {
      setEditMode(false);
      setViewOnlyE(true);
      setViewOnlyP(true);
      setViewOnlyM(true);
      setViewOnlyM2(true);
      setViewOnlyM3(true);
      setEditModeM(false);
      setEditModeM2(false);
      setEditModeM3(false);
      setEditModeG(false);
      setViewOnly(true);
    }
  };



  const editarSolicitud = async (solicitud) => {
    const isUserAdmin = esUsuarioAdmin(currentU);
    if (!isUserAdmin) {

      return verSolicitud(solicitud);
    }
    let solData = solicitud;
    if (solicitud?.idSolicitud) {
      try {
        const fullResp = await SolicitudesService.getSolicitudIndividual(solicitud.idSolicitud);
        if (fullResp) {
          const rawSol = fullResp.solicitud?.[0] || fullResp.solicitud || fullResp.data?.solicitud?.[0] || fullResp.data?.solicitud || fullResp;
          if (rawSol && typeof rawSol === "object") {
            solData = { ...solicitud, ...rawSol };
          }
        }
      } catch (err) {
        console.error("Error al obtener solicitud individual:", err);
      }
    }

    const datosHeader = {
      codigoSolicitud: solData?.codigo || null,
      fecha: solData?.fecha || "",
      nombreInserto: [
        solData?.nombreInserto || solicitud?.nombreInserto,
        solData?.apPaternoInserto || solicitud?.apPaternoInserto,
        solData?.apMaternoInserto || solicitud?.apMaternoInserto,
      ]
        .map((p) => (p || "").trim())
        .filter(Boolean)
        .join(" ") || solData?.inserto || solicitud?.inserto || "",
      nombreSucursal:
        solData?.nombreSucursal ||
        solData?.sucursalNombre ||
        solData?.sucursal ||
        "",
    };

    setSolicitudCodigo(datosHeader.codigoSolicitud || "");
    setSolicitudFecha(datosHeader.fecha);
    setSolicitudInserto(datosHeader.nombreInserto);
    setSucursalNombre(datosHeader.nombreSucursal);
    setFecha(datosHeader.fecha);
    setShowCotizacionPacienteHeader(true);

    try {
      let resultado;
      if (solData.idConvenio) {
        resultado = await ConveniosService.getConvenioPorId(
          solData.idConvenio,
        );
        let empresaCompleta = resultado.convenio[0];
        setEmpresa(empresaCompleta.nombre);
        setSelectedEmpresa(empresaCompleta);

      }
      resultado = await CajaService.getCajaPorSolicitud(solData.idSolicitud);

      if (solData.idPaciente) {
        resultado = await PacientesService.getPacientePorId(
          solData.idPaciente,
        );
        let pacienteCompleto = resultado.paciente;
        setSelectedPaciente(pacienteCompleto[0]);
        setNombre(pacienteCompleto[0].nombre);
        setApPaterno(pacienteCompleto[0].apPaterno);
        setApMaterno(pacienteCompleto[0].apMaterno);
        setSexo(pacienteCompleto[0].sexo);
        setFechaNac(pacienteCompleto[0].fechaNacimiento);
        setEdad(pacienteCompleto[0].edad);
        setEmail(pacienteCompleto[0].email);
        setTelefonoCelular(pacienteCompleto[0].telefonoCelular);
        setDireccion(pacienteCompleto[0].direccion);
        setColonia(pacienteCompleto[0].colonia);
        setCPostal(pacienteCompleto[0].cPostal);
        setEstado(pacienteCompleto[0].estado);
        setCiudad(pacienteCompleto[0].ciudad);
        setIne(pacienteCompleto[0].ine);
      }

      await cargarDoctoresDeSolicitud(solData);
      resultado = await SolicitudesEstudiosService.getEstudiosPorSolicitud(
        solicitud.idSolicitud,
      );
      let estudiosCompleto = resultado.estudios;
      const estudiosConDetalles = await Promise.all(
        estudiosCompleto.map(async (estudio) => {
          const estudioPorId = await EstudiosService.getEstudioPorId(
            estudio.idEstudio,
          );
          const [muestras, estudiosInt] = await Promise.all([
            MuestrasService.getMuestrasPorEstudio(estudio.idEstudio),
            EstudiosIntService.getEstudiosPorEstudio(estudio.idEstudio),
          ]);

          return {
            ...estudio,
            cantidad: estudio?.cantidad ?? "1",
            urgente: estudio.urgente,
            costo: estudio?.costo ?? estudioPorId?.costo ?? "",
            codigo: estudioPorId?.codigo || "",
            nombre: estudioPorId?.nombre || "",
            descuento: estudio?.descuento ?? "",
            tiempoEntrega: estudioPorId?.tiempoEntrega || "",
            fechaEntrega: formatDateForBackend(estudio.fechaEntrega || ""),
            fechaMuestra: formatDateForInput(estudio.fechaMuestra || getFechaHoy()),
            muestraPendiente: estudio.muestraPendiente || false,
            muestras: muestras || [],
            estudiosInt: estudiosInt || [],
          };
        }),
      );
      const estudiosBase = estudiosConDetalles;
      setEstudiosOriginales(estudiosBase);
      setEstudios([
        ...estudiosBase,
        {
          cantidad: "1",
          codigo: "",
          nombre: "",
          costo: "",
          tiempoEntrega: "",
          idEstudio: "",
          descuento: "",
          fechaEntrega: "",
          fechaMuestra: getFechaHoy(),
          muestraPendiente: false,
        },
      ]);
      setNotas(solicitud.notas);
      setNumCuarto(solicitud.numCuarto || "");

      const subtotalEstudiosEditar = calcularSubtotal(estudiosBase);
      const tipoDescEditar = solData?.tipoDescuento || solicitud.tipoDescuento || "ninguno";
      const descTotalValEditar = solData?.descuentoTotal ?? solicitud.descuentoTotal;
      const motivoDescValEditar = solData?.motivoDescuento || solicitud.motivoDescuento || "";
      let valorGenEditar = "";

      if (tipoDescEditar === "porcentaje") {
        const tieneDescEstudios = tieneDescuentoPorEstudio(estudiosBase);
        const montoDesc = parseNumero(descTotalValEditar);
        if (tieneDescEstudios) {
          const totalDesc = estudiosBase.reduce((acc, est) => {
            const pct = parseNumero(est?.descuento || 0);
            const cant = parseNumero(est?.cantidad || 0);
            const cst = parseNumero(est?.costo || 0);
            return acc + cant * cst * (pct / 100);
          }, 0);
          valorGenEditar = subtotalEstudiosEditar > 0 ? ((totalDesc / subtotalEstudiosEditar) * 100).toFixed(2) : "";
        } else if (subtotalEstudiosEditar > 0 && montoDesc > 0) {
          const pctCalculado = Math.min(100, Math.max(0, (montoDesc / subtotalEstudiosEditar) * 100));
          const pctRedondeado = Math.round(pctCalculado * 100) / 100;
          valorGenEditar = pctRedondeado % 1 === 0 ? String(pctRedondeado) : String(pctRedondeado);
        }
      } else if (tipoDescEditar === "cantidad") {
        valorGenEditar = descTotalValEditar !== undefined && descTotalValEditar !== null && descTotalValEditar !== "" ? String(descTotalValEditar) : "";
      }

      setValorGeneral(valorGenEditar);
      setOpcionDescuento(tipoDescEditar);
      setMotivoDescuento(motivoDescValEditar);
      setOpcionDescuentoOriginal(tipoDescEditar);
      setValorGeneralOriginal(valorGenEditar);
      setMotivoDescuentoOriginal(motivoDescValEditar);
      setSelectedSolicitudId(solicitud.idSolicitud || null);
      setSolicitudCodigo(solicitud.codigo || "");
      setSolicitudFecha(solicitud.fecha || "");
      setSolicitudInserto(datosHeader.nombreInserto || solicitud.nombreInserto || "");
      setSucursalNombre(solicitud.nombreSucursal || "");
      await actualizarTotalesCaja(solicitud.idSolicitud);

      const reqFact = Boolean(
        solData?.requiereFactura === 1 ||
        solData?.requiereFactura === "1" ||
        solData?.requiereFactura === true ||
        solData?.requiereFactura === "si" ||
        solData?.factura === 1 ||
        solData?.factura === "1" ||
        solData?.factura === true ||
        solData?.factura === "si" ||
        parseNumero(solData?.iva) > 0 ||
        parseNumero(solData?.ivaN) > 0 ||
        parseNumero(totalesCaja?.iva) > 0 ||
        solicitud?.requiereFactura === 1 ||
        solicitud?.requiereFactura === "1" ||
        solicitud?.requiereFactura === true ||
        solicitud?.requiereFactura === "si" ||
        parseNumero(solicitud?.iva) > 0 ||
        parseNumero(solicitud?.ivaN) > 0
      );
      setRequiereFactura(reqFact);

      const estatusSolicitudEditar = `${solicitud.estatus ?? "S"}`.trim().toUpperCase();
      setSolicitudEstatus(estatusSolicitudEditar);
      try {
        const suc = await SucursalesService.getSucursalIndividual(
          solicitud.idSucursal,
        );
        setSolicitudSucursalNombre(suc?.nombre || "");

      } catch (err) {
        console.error("Error fetching sucursal:", err);
      }
    } catch (error) {
      console.error(error);
    }

    const estatusSolicitud = `${solicitud?.estatus ?? "S"}`.trim().toUpperCase();
    if (esEstatusSoloLectura(estatusSolicitud)) {
      aplicarBloqueoPorEstatus(estatusSolicitud);
    } else {
      const tieneDoc2 = Boolean(solicitud.idDoctor2 || solicitud.id_doctor2 || (solicitud.doctor2 && (solicitud.doctor2.nombre || solicitud.doctor2.apPaterno)));
      const tieneDoc3 = Boolean(solicitud.idDoctor3 || solicitud.id_doctor3 || (solicitud.doctor3 && (solicitud.doctor3.nombre || solicitud.doctor3.apPaterno)));
      setViewOnlyM(true);
      setViewOnlyM2(tieneDoc2);
      setViewOnlyM3(tieneDoc3);
      setEditModeM(false);
      setEditModeM2(false);
      setEditModeM3(false);
      setEditModeG(true);
      setViewOnly(false);
    }
  };


  async function mostrarInfo(estudio) {
    Swal.fire({
      title: "DETALLE DEL ESTUDIO",
      width: "55%",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
        confirmButton: "btnConfirmBlueInfo",
      },
      html: `
      <div style="text-align:left; font-size:0.9rem;">
        <div class="tituloDegradado" style="font-size:0.8vw;padding:0.5vw 0.5vw;border-radius:8px;display:block;width:100%;text-align:center;">DATOS PRINCIPALES</div>
        <table border="1" style="width:50vw; margin-bottom:1em; border-collapse:collapse; text-align:left;">
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Nombre:</b></td><td>${estudio.nombre}</td></tr>
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Tiempo de entrega:</b></td><td>${estudio.tiempoEntrega || ""} Días</td></tr>
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Tiempo de entrega urgente:</b></td><td>${estudio.tiempoProceso || ""} ${estudio.tiempoProcesoDH || ""}</td></tr>
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Condiciones del paciente:</b></td><td>${estudio.condicionesPaciente || ""}</td></tr>
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Descripción científica:</b></td><td>${estudio.descripcionCien || ""}</td></tr>
        </table>

        <div class="tituloDegradado" style="font-size:0.8vw;padding:0.5vw 0.5vw;border-radius:8px;display:block;width:100%;text-align:center;">MUESTRAS DEL ESTUDIO</div>
        <table border="1" style="width:50vw; margin-bottom:1em; border-collapse:collapse; text-align:left;">
          ${estudio.muestras
          .map(
            (m) => `
            <tr><td style="background-color:#172149; color:white;><b>Tubo o Material:</b></td><td>${m.nombreMaterial}</td></tr>
            <tr><td style="background-color:#172149; color:white;><b>Tipo de muestra:</b></td><td>${m.tipoMuestra}</td></tr>
            <tr><td style="background-color:#172149; color:white;><b>Indicaciones para la toma:</b></td><td>${m.indicacionesToma}</td></tr>
            <tr><td style="background-color:#172149; color:white;><b>Indicaciones de estabilidad:</b></td><td>${m.indicacionesEstabilidad}</td></tr>
          `,
          )
          .join("")}
        </table>

        <div class="tituloDegradado" style="font-size:0.8vw;padding:0.5vw 0.5vw;border-radius:8px;display:block;width:100%;text-align:center;">ESTUDIOS QUE LO INTEGRAN</div>
        <ul style="margin-left:1em;">
          ${estudio.estudiosInt.map((i) => `<li><b>${i.nombre}</b></li>`).join("")}
        </ul>
      </div>
    `,
      confirmButtonText: `
    <span style="display:flex; align-items:center; gap:0.5vw;">
      Regresar
    </span>
  `,
    });
  }

  const actualizarListaPreciosParaConvenio = async (value) => {
    const empresaSeleccionada = value || null;
    setSelectedEmpresa(empresaSeleccionada);

    if (empresaSeleccionada) {
      setEmpresa(empresaSeleccionada.nombre || "");
      setViewOnlyE(true);
    } else {
      setEmpresa("");
      setViewOnlyE(false);
    }

    let nuevaListaId = "";
    if (empresaSeleccionada?.idListaPrecio) {
      nuevaListaId = empresaSeleccionada.idListaPrecio;
    } else {
      nuevaListaId = await obtenerListaPrecioVigente();
    }

    if (!nuevaListaId) {
      mostrarError(
        "No existe una lista de precios vigente para la sucursal actual",
      );
      return "";
    }

    const nombreL = preciosByLista?.[nuevaListaId]?.nombre ?? "Lista de la sucursal";
    setSelectedLista(nombreL);

    if (nuevaListaId) {
      setEstudios((prevEstudios) =>
        prevEstudios.map((estudio) => {
          if (!estudio.idEstudio) return estudio;
          const listaPreciosObj = preciosByLista[nuevaListaId];
          const nuevoCosto =
            listaPreciosObj &&
              listaPreciosObj.precios &&
              listaPreciosObj.precios[estudio.idEstudio] !== undefined
              ? listaPreciosObj.precios[estudio.idEstudio]
              : "";
          return {
            ...estudio,
            costo: nuevoCosto,
          };
        }),
      );
    }

    return nuevaListaId;
  };

  async function changeEmpresa() {
    if (esEstatusSoloLectura(solicitudEstatus)) return;
    setEmpresa("");
    setSelectedEmpresa(null);
    setViewOnlyE(false);
    await actualizarListaPreciosParaConvenio(null);
  }

  function changeEditMode() {
    if (esEstatusSoloLectura(solicitudEstatus)) return;
    setEditMode(true);
    setViewOnlyP(false);
  }

  const esDoctorVacioOSinNombre = (doc, nombre) => {
    const nom = (nombre || doc?.nombre || "").trim();
    return !nom;
  };

  function changeEditModeM() {
    if (esEstatusSoloLectura(solicitudEstatus)) return;
    if (esDoctorVacioOSinNombre(selectedDoctor, nombreDoctor)) {
      setEditModeM(false);
      setViewOnlyM(false);
      setSelectedDoctor(null);
      setNombreDoctor("");
      setApPaternoDoctor("");
      setApMaternoDoctor("");
      setEmailDoctor("");
      setTelefonoDoctor("");
      setTimeout(() => {
        const inputEl = document.querySelector(".txfNombreDoctor input");
        if (inputEl) {
          inputEl.focus();
        }
      }, 100);
    } else {
      setEditModeM(true);
      setViewOnlyM(false);
    }
  }

  function changePaciente() {
    if (esEstatusSoloLectura(solicitudEstatus)) return;
    setEditMode(false);
    setViewOnlyP(false);
    setShowCotizacionPacienteHeader(false);
    setNombre("");
    setApPaterno("");
    setApMaterno("");
    setSexo("");
    setFechaNac("");
    setEdad("");
    setTelefonoCelular("");
    setDireccion("");
    setColonia("");
    setCPostal("");
    setEstado("seleccione");
    setCiudad("");
    setIne("");
    setEmail("");
  }

  function changeDoctor() {
    if (esEstatusSoloLectura(solicitudEstatus)) return;
    setSelectedDoctor(null);
    setEditModeM(false);
    setViewOnlyM(false);
    setShowCotizacionPacienteHeader(false);
    setNombreDoctor("");
    setApPaternoDoctor("");
    setApMaternoDoctor("");
    setEmailDoctor("");
    setTelefonoDoctor("");
  }

  function changeDoctor2() {
    if (esEstatusSoloLectura(solicitudEstatus)) return;
    setSelectedDoctor2(null);
    setEditModeM2(false);
    setViewOnlyM2(false);
    setNombreDoctor2("");
    setApPaternoDoctor2("");
    setApMaternoDoctor2("");
    setEmailDoctor2("");
    setTelefonoDoctor2("");
  }

  function changeDoctor3() {
    if (esEstatusSoloLectura(solicitudEstatus)) return;
    setSelectedDoctor3(null);
    setEditModeM3(false);
    setViewOnlyM3(false);
    setNombreDoctor3("");
    setApPaternoDoctor3("");
    setApMaternoDoctor3("");
    setEmailDoctor3("");
    setTelefonoDoctor3("");
  }

  function changeEditModeM2() {
    if (esEstatusSoloLectura(solicitudEstatus)) return;
    if (esDoctorVacioOSinNombre(selectedDoctor2, nombreDoctor2)) {
      setEditModeM2(false);
      setViewOnlyM2(false);
      setSelectedDoctor2(null);
      setNombreDoctor2("");
      setApPaternoDoctor2("");
      setApMaternoDoctor2("");
      setEmailDoctor2("");
      setTelefonoDoctor2("");
      setTimeout(() => {
        const inputEl = document.querySelector(".txfNombreDoctor2 input");
        if (inputEl) {
          inputEl.focus();
        }
      }, 100);
    } else {
      setEditModeM2(true);
      setViewOnlyM2(false);
    }
  }

  function changeEditModeM3() {
    if (esEstatusSoloLectura(solicitudEstatus)) return;
    if (esDoctorVacioOSinNombre(selectedDoctor3, nombreDoctor3)) {
      setEditModeM3(false);
      setViewOnlyM3(false);
      setSelectedDoctor3(null);
      setNombreDoctor3("");
      setApPaternoDoctor3("");
      setApMaternoDoctor3("");
      setEmailDoctor3("");
      setTelefonoDoctor3("");
      setTimeout(() => {
        const inputEl = document.querySelector(".txfNombreDoctor3 input");
        if (inputEl) {
          inputEl.focus();
        }
      }, 100);
    } else {
      setEditModeM3(true);
      setViewOnlyM3(false);
    }
  }

  const obtenerListaPrecioVigente = async () => {
    const sucursalId = currentU?.sucursal;
    if (!sucursalId) return "";

    let configuraciones = Array.isArray(preciosSucursal) ? preciosSucursal : [];
    if (!configuraciones.length) {
      try {
        const response =
          await PreciosSucursalService.getPreciosSucursalPorSucursal(
            sucursalId,
          );
        const data = Array.isArray(response?.precios)
          ? response.precios
          : [];
        configuraciones = data;

        setPreciosSucursal(data);
      } catch (err) {
        console.error(err);
        return "";
      }
    }

    const configuracionesSucursal = configuraciones.filter((item) => {
      const idSucursal = item?.idSucursal ?? item?.sucursal;
      return String(idSucursal) === String(sucursalId);
    });

    if (!configuracionesSucursal.length) {
      return "";
    }

    const predeterminada = configuracionesSucursal.find((item) => {
      return normalizarBooleano(item?.predCotizacion);
    });
    if (predeterminada) {
      return predeterminada.idListaPrecio || "";
    }

    const diaActual = getDiaActual();
    const horaActual = parseHora(
      new Date().toLocaleTimeString("en-GB", { hour12: false }),
    );

    // Se valida aquí si la configuración coincide con el día actual y con el rango de hora actual.
    const vigente = configuracionesSucursal.find((item) => {
      const mismoDia = cumpleDia(item?.dias, diaActual);
      if (!mismoDia) return false;

      const desde = parseHora(item?.horaInicio);
      const hasta = parseHora(item?.horaFin);
      if (desde === null || hasta === null) return false;

      return horaActual !== null && horaActual >= desde && horaActual <= hasta;
    });

    if (vigente) {
      return vigente.idListaPrecio || "";
    }

    // Si no coincide con el rango horario, se intenta usar una configuración del mismo día aunque no tenga horario definido.
    const sinHorario = configuracionesSucursal.find((item) => {
      if (!cumpleDia(item?.dias, diaActual)) return false;
      const desde = parseHora(item?.horaInicio);
      const hasta = parseHora(item?.horaFin);
      return desde === null || hasta === null;
    });

    return sinHorario?.idListaPrecio || "";
  };

  async function saveField(fieldName, value) {
    if (!selectedPaciente?.idPaciente) {
      setSnackbar({
        open: true,
        message: "Selecciona un paciente antes de guardar.",
        severity: "warning",
      });
      return;
    }
    if (fieldName === "telefonoCelular" && tieneMasDe10Digitos(value)) {
      mostrarError("El número de teléfono no puede tener más de 10 dígitos.");
      return;
    }
    const fieldLabels = { nombre: "Nombre", apPaterno: "Apellido Paterno", apMaterno: "Apellido Materno", sexo: "Sexo", fechaNacimiento: "Fecha de nacimiento", edad: "Edad", telefonoCelular: "Teléfono", email: "Email", direccion: "Dirección", colonia: "Colonia", cPostal: "Código Postal", estado: "Estado", ciudad: "Ciudad", ine: "INE" };
    const valorAnterior = selectedPaciente?.[fieldName] || "";
    setSaving((prev) => ({ ...prev, [fieldName]: true }));
    try {
      const payload = { campoN: [fieldName], valorN: value };
      const res = await PacientesService.patchPaciente(
        payload,
        selectedPaciente.idPaciente,
      );
      if (res.data.estatus !== "OK") throw new Error("Error al guardar");
      const updated = res.data.paciente[0];
      setSelectedPaciente((prev) => ({ ...prev, ...updated }));
      setSnackbar({
        open: true,
        message: "Cambios guardados",
        severity: "success",
      });
      const label = fieldLabels[fieldName] || fieldName;
      registrarMovimientoSolicitud("EDP", `${label} anterior: ${valorAnterior || "(vacío)"} a ${label}: ${value}`);
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "No se pudo guardar. Intenta de nuevo.",
        severity: "error",
      });
    } finally {
      setSaving((prev) => ({ ...prev, [fieldName]: false }));
    }
  }

  async function saveFieldM(fieldName, value, docNum = 1) {
    let targetDoc = selectedDoctor;
    let setTargetDoc = setSelectedDoctor;
    if (docNum === 2) {
      targetDoc = selectedDoctor2;
      setTargetDoc = setSelectedDoctor2;
    } else if (docNum === 3) {
      targetDoc = selectedDoctor3;
      setTargetDoc = setSelectedDoctor3;
    }

    if (!targetDoc?.idDoctor) {
      return;
    }
    const fieldLabelsM = { nombre: "Nombre", apPaterno: "Apellido Paterno", apMaterno: "Apellido Materno", telefonoCelular: "Teléfono", email: "Email", conComision: "Doctor con comisión" };
    const valorAnteriorM = targetDoc?.[fieldName] ?? "";
    setSavingM((prev) => ({ ...prev, [fieldName]: true }));
    try {
      const payload = { campoN: [fieldName], valorN: value };
      const res = await DoctoresService.patchDoctor(
        payload,
        targetDoc.idDoctor,
      );

      if (res.data?.estatus === "OK" || res.status === 200) {
        const updated = res.data?.doctores?.[0] || res.data?.doctor?.[0];
        if (updated) {
          setTargetDoc((prev) => ({ ...prev, ...updated }));
        } else {
          setTargetDoc((prev) => ({ ...prev, [fieldName]: value, esComision: Boolean(value), conComision: Boolean(value) }));
        }
        setSnackbar({
          open: true,
          message: "Cambios guardados",
          severity: "success",
        });
        const docLabel = docNum === 1 ? "médico" : `médico ${docNum}`;
        const labelM = fieldLabelsM[fieldName] || fieldName;
        registrarMovimientoSolicitud("EDM", `${labelM} anterior del ${docLabel}: ${valorAnteriorM ?? "(vacío)"} a ${labelM}: ${value}`);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setSavingM((prev) => ({ ...prev, [fieldName]: false }));
    }
  }

  const isEstudioEmpty = (estudio) => {
    const codigo = estudio.codigo ?? "";
    const nombre = estudio.nombre ?? "";
    const idEstudio = estudio.idEstudio ?? "";
    return (
      codigo.toString().trim() === "" &&
      nombre.toString().trim() === "" &&
      idEstudio.toString().trim() === ""
    );
  };

  const removeAllEmpty = (arr) => arr.filter((s) => !isEstudioEmpty(s));
  const tieneUnoConDatos = (arr) => arr.some((s) => !isEstudioEmpty(s));
  function getFormattedNow() {
    const now = new Date();

    const dd = String(now.getDate()).padStart(2, "0");
    const mm = String(now.getMonth() + 1).padStart(2, "0"); // meses 0-11
    const yyyy = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, "0"); // 0-23
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd} ${hours}:${minutes}`;
  }

  function getFechaHoy() {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  }

  const formatDateForBackend = (value) => {
    if (value === null || value === undefined || value === "") return "";

    if (typeof value === "string") {
      const trimmedValue = value.trim();
      if (!trimmedValue) return "";
      if (trimmedValue.toUpperCase() === "PENDIENTE") return "PENDIENTE";
      if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedValue)) return trimmedValue;
      if (/^\d{4}-\d{2}-\d{2}[T ][0-9:.]+/.test(trimmedValue)) return trimmedValue.slice(0, 10);
      if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(trimmedValue)) return trimmedValue.slice(0, 10);

      const ddMmYyyyMatch = trimmedValue.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/);
      if (ddMmYyyyMatch) {
        const [, day, month, year] = ddMmYyyyMatch;
        return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
      }

      const parsedDate = new Date(trimmedValue);
      if (!Number.isNaN(parsedDate.getTime())) {
        const yyyy = parsedDate.getUTCFullYear();
        const mm = String(parsedDate.getUTCMonth() + 1).padStart(2, "0");
        const dd = String(parsedDate.getUTCDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      }

      return trimmedValue;
    }

    if (value instanceof Date) {
      const yyyy = value.getFullYear();
      const mm = String(value.getMonth() + 1).padStart(2, "0");
      const dd = String(value.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    }

    return `${value}`.trim();
  };

  const formatDateForInput = (value) => {
    const normalized = formatDateForBackend(value);
    if (!normalized || normalized === "PENDIENTE") return "";
    return normalized;
  };

  const toggleMuestraPendiente = (index) => {
    setEstudios((prev) => {
      const next = [...prev];
      const item = next[index] || {};
      const pendienteActual = Boolean(
        item.muestraPendiente || `${item.fechaMuestra || ""}`.trim().toUpperCase() === "PENDIENTE",
      );
      next[index] = {
        ...item,
        muestraPendiente: !pendienteActual,
        fechaMuestra: !pendienteActual
          ? "PENDIENTE"
          : item.fechaMuestra === "PENDIENTE"
            ? getFechaHoy()
            : item.fechaMuestra || getFechaHoy(),
      };
      return next;
    });
  };

  const isValidDateString = (value) => {
    if (!value || typeof value !== "string") return false;

    const trimmedValue = value.trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmedValue)) return false;

    const [year, month, day] = trimmedValue.split("-").map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));

    return (
      date.getUTCFullYear() === year &&
      date.getUTCMonth() === month - 1 &&
      date.getUTCDate() === day
    );
  };

  const handleFechaMuestraBlur = (index, value) => {
    const trimmedValue = `${value || ""}`.trim();
    const nuevaFecha = formatDateForBackend(
      trimmedValue === ""
        ? getFechaHoy()
        : isValidDateString(trimmedValue)
          ? trimmedValue
          : getFechaHoy(),
    );

    setEstudios((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], fechaMuestra: nuevaFecha };
      return next;
    });
  };

  const getAbreviaturaSucursal = () => {
    const sucursalActual = (sucursales || []).find(
      (s) => String(s.idSucursal) === String(currentU?.sucursal),
    );

    const candidatos = [
      sucursalActual?.abreviatura,
      sucursalActual?.abr,
      sucursalActual?.siglas,
      sucursalActual?.codigo,
      currentU?.abreviaturaSucursal,
      currentU?.abreviatura,
      currentU?.nombreSucursal,
    ];

    const valor = candidatos.find((item) => {
      if (!item && item !== 0) return false;
      return `${item}`.trim() !== "";
    });

    if (!valor) return "SUC";

    const limpio = `${valor}`
      .normalize("NFD")
      .replace(/[^a-zA-Z0-9]/g, "")
      .toUpperCase();

    if (!limpio) return "SUC";

    return limpio.slice(0, 3);
  };

  const generarCodigoSolicitud = async () => {
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, "0");
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const yy = String(now.getFullYear()).slice(-2);
    const fechaPrefix = `${dd}${mm}${yy}`;
    const abreviatura = getAbreviaturaSucursal();
    const prefix = `${fechaPrefix}${abreviatura}`;

    let dbSuccess = false;
    let maxSec = 0;
    try {
      const response = await SolicitudesService.getSolicitudes();
      const lista = response?.data?.solicitudes || [];
      if (response && response.data) {
        dbSuccess = true;
      }
      lista.forEach((sol) => {
        const codigo = sol.codigo || sol.orden || "";
        if (codigo.startsWith(prefix)) {
          const suffixStr = codigo.substring(prefix.length);
          const suffixNum = parseInt(suffixStr, 10);
          if (!isNaN(suffixNum) && suffixNum > maxSec) {
            maxSec = suffixNum;
          }
        }
      });
    } catch (error) {
      console.error("Error al obtener solicitudes para generar código:", error);
    }

    const storageKey = "solicitudCodigoContador";
    const sucursalKey = `${yy}${mm}${dd}_${abreviatura}`;
    let contadorPorDia = {};

    try {
      contadorPorDia = JSON.parse(localStorage.getItem(storageKey) || "{}") || {};
    } catch (error) {
      contadorPorDia = {};
    }

    // Si la base de datos respondió correctamente, el consecutivo real es maxSec + 1
    // Solo se utiliza el contador local como respaldo en caso de fallo de red
    let siguiente;
    if (dbSuccess) {
      siguiente = maxSec + 1;
    } else {
      const localSiguiente = Number(contadorPorDia[sucursalKey] || 0) + 1;
      siguiente = Math.max(maxSec + 1, localSiguiente);
    }

    contadorPorDia[sucursalKey] = siguiente;

    try {
      localStorage.setItem(storageKey, JSON.stringify(contadorPorDia));
    } catch (e) {
      console.error(e);
    }

    return `${prefix}${siguiente}`;
  };

  const agregarSolicitud = async () => {
    let solicitud;
    let solicitudUpd;
    const cleaned = removeAllEmpty(estudios).map((est) => {
      const esPendiente = Boolean(est.muestraPendiente || `${est.fechaMuestra || ""}`.trim().toUpperCase() === "PENDIENTE");
      const payloadEstudio = {
        ...est,
        fechaMuestra: esPendiente ? "PENDIENTE" : formatDateForBackend(est.fechaMuestra),
        muestraPendiente: esPendiente,
        fechaEntrega: formatDateForBackend(est.fechaEntrega),
      };

      if (est.urgente !== undefined) {
        payloadEstudio.urgente = est.urgente;
      } else {
        const originalEstudio = estudiosOriginales.find((orig) =>
          String(orig.idEstudio ?? "") === String(est.idEstudio ?? ""),
        );
        payloadEstudio.urgente = originalEstudio?.urgente !== undefined
          ? originalEstudio.urgente
          : false;
      }

      return payloadEstudio;
    });
    let estadoN = estado === "" || estado === "seleccione" ? null : estado;
    const edadNormalizada = normalizarEdad(edad) || null;

    const validacionDesc = validarDescuentosFormulario();
    if (!validacionDesc.esValido) {
      setErrorDescuentoGeneral(validacionDesc.errorGeneral);
      setErroresDescuentoEstudios(validacionDesc.erroresEstudios);
      const msgError = validacionDesc.errorGeneral || validacionDesc.erroresEstudios.find(Boolean) || "Revise los campos de descuento.";
      Swal.fire({
        title: "¡Error de validación!",
        text: msgError,
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    if (!tieneUnoConDatos(cleaned)) {
      mostrarError("Es necesario seleccionar al menos un estudio.");
      return;
    }
    if (!selectedPaciente && !nombre) {
      mostrarError(
        "Es necesario seleccionar un paciente para continuar.",
      );
      return;
    }

    if (!nombre || nombre.trim() === "") {
      mostrarError("¡El nombre del paciente es obligatorio!");
      setErrorNombre(true);
    } else if (tieneMasDe10Digitos(telefonoCelular)) {
      mostrarError("El número de teléfono no puede tener más de 10 dígitos.");
      return;
    } else {
      const faltanFechaEntrega = cleaned.some((est) => !isEstudioEmpty(est) && (!est.fechaEntrega || est.fechaEntrega === ""));
      if (faltanFechaEntrega) {
        Swal.fire({
          title: "Faltan fechas de entrega",
          text: "Todos los estudios deben tener fecha de entrega antes de continuar.",
          icon: "warning",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      // Validar presencia de doctores (si el Doctor 1 está vacío, se registrará con idDoctor = 1 por defecto)
      if (cantidadDoctores >= 2 && nombreDoctor2 && !selectedDoctor2) {
        if (!nombreDoctor2.trim()) {
          setErrorNombreDoctor2(true);
          mostrarError("El Doctor 2 no puede estar vacío si se agregó un segundo médico.");
          return;
        }
      }

      if (cantidadDoctores === 3) {
        const tieneDoctor3 = Boolean(selectedDoctor3?.idDoctor || (nombreDoctor3 && nombreDoctor3.trim() !== ""));
        if (!tieneDoctor3) {
          setErrorNombreDoctor3(true);
          setErrorApPaternoDoctor3(!selectedDoctor3 && !nombreDoctor3?.trim());
          mostrarError("El Doctor 3 no puede estar vacío si se agregó un tercer médico.");
          return;
        }
      }

      // Comprobación para evitar doctores duplicados
      const docKeys = [];
      if (selectedDoctor?.idDoctor) {
        docKeys.push(`id:${selectedDoctor.idDoctor}`);
      } else if (nombreDoctor) {
        const nameKey = `${nombreDoctor} ${apPaternoDoctor || ""} ${apMaternoDoctor || ""}`.trim().toLowerCase().replace(/\s+/g, " ");
        if (nameKey) docKeys.push(`name:${nameKey}`);
      }

      if (cantidadDoctores >= 2) {
        if (selectedDoctor2?.idDoctor) {
          docKeys.push(`id:${selectedDoctor2.idDoctor}`);
        } else if (nombreDoctor2) {
          const nameKey2 = `${nombreDoctor2} ${apPaternoDoctor2 || ""} ${apMaternoDoctor2 || ""}`.trim().toLowerCase().replace(/\s+/g, " ");
          if (nameKey2) docKeys.push(`name:${nameKey2}`);
        }
      }

      if (cantidadDoctores === 3) {
        if (selectedDoctor3?.idDoctor) {
          docKeys.push(`id:${selectedDoctor3.idDoctor}`);
        } else if (nombreDoctor3) {
          const nameKey3 = `${nombreDoctor3} ${apPaternoDoctor3 || ""} ${apMaternoDoctor3 || ""}`.trim().toLowerCase().replace(/\s+/g, " ");
          if (nameKey3) docKeys.push(`name:${nameKey3}`);
        }
      }

      if (new Set(docKeys).size !== docKeys.length) {
        mostrarError("No se puede seleccionar ni agregar el mismo doctor más de una vez.");
        return;
      }
      let enviarWhatsappC = enviarWhatsapp;
      let enviarEmailC = enviarEmail;
      if (enviarEmail === "seleccione") {
        enviarEmailC = "no";
      }
      if (enviarWhatsapp === "seleccione") {
        enviarWhatsappC = "no";
      }
      if (selectedPaciente) {
        if (selectedDoctor) {
          if (selectedEmpresa) {
            solicitud = {
              solicitud: {
                idPaciente: selectedPaciente.idPaciente,
                idConvenio: selectedEmpresa.idConvenio,
                idDoctor: selectedDoctor.idDoctor,
                enviarEmail: enviarEmailC,
                enviarWhatsapp: enviarWhatsappC,
                numCuarto: numCuarto,
                notas: notas,
                subtotal: subtotalSolicitud,
                descuentoTotal: descuentoTotal,
                motivoDescuento: motivoDescuento,
                tipoDescuento: opcionDescuento,
                totalPagar: totalSolicitud,
                requiereFactura: requiereFactura ? 1 : 0,
                iva: ivaSolicitud,
                idSucursal: currentU.sucursal,
                fecha: getFormattedNow(),
                estatus: "S",
                motivoCancelacion: "",
                inserto: currentU.id,
              },
              estudios: cleaned,

            };
          } else {
            solicitud = {
              solicitud: {
                idPaciente: selectedPaciente.idPaciente,
                idConvenio: null,
                idDoctor: selectedDoctor.idDoctor,
                enviarEmail: enviarEmailC,
                enviarWhatsapp: enviarWhatsappC,
                numCuarto: numCuarto,
                notas: notas,
                subtotal: subtotalSolicitud,
                descuentoTotal: descuentoTotal,
                motivoDescuento: motivoDescuento,
                tipoDescuento: opcionDescuento,
                totalPagar: totalSolicitud,
                requiereFactura: requiereFactura ? 1 : 0,
                iva: ivaSolicitud,
                idSucursal: currentU.sucursal,
                fecha: getFormattedNow(),
                estatus: "S",
                motivoCancelacion: "",
                inserto: currentU.id,
              },
              estudios: cleaned,

            };
          }
        } else {
          if (selectedEmpresa) {
            solicitud = {
              solicitud: {
                idPaciente: selectedPaciente.idPaciente,
                idConvenio: selectedEmpresa.idConvenio,
                enviarEmail: enviarEmailC,
                enviarWhatsapp: enviarWhatsappC,
                numCuarto: numCuarto,
                notas: notas,
                subtotal: subtotalSolicitud,
                descuentoTotal: descuentoTotal,
                motivoDescuento: motivoDescuento,
                tipoDescuento: opcionDescuento,
                totalPagar: totalSolicitud,
                requiereFactura: requiereFactura ? 1 : 0,
                iva: ivaSolicitud,
                idSucursal: currentU.sucursal,
                fecha: getFormattedNow(),
                estatus: "S",
                motivoCancelacion: "",
                inserto: currentU.id,
              },
              doctor: {
                nombre: nombreDoctor,
                apPaterno: apPaternoDoctor,
                apMaterno: apMaternoDoctor,
                telefonoCelular: telefonoDoctor,
                email: emailDoctor,
              },
              estudios: cleaned,

            };
          } else {
            solicitud = {
              solicitud: {
                idPaciente: selectedPaciente.idPaciente,
                idConvenio: null,
                enviarEmail: enviarEmailC,
                enviarWhatsapp: enviarWhatsappC,
                numCuarto: numCuarto,
                notas: notas,
                subtotal: subtotalSolicitud,
                descuentoTotal: descuentoTotal,
                motivoDescuento: motivoDescuento,
                tipoDescuento: opcionDescuento,
                totalPagar: totalSolicitud,
                requiereFactura: requiereFactura ? 1 : 0,
                iva: ivaSolicitud,
                idSucursal: currentU.sucursal,
                fecha: getFormattedNow(),
                estatus: "S",
                motivoCancelacion: "",
                inserto: currentU.id,
              },
              doctor: {
                nombre: nombreDoctor,
                apPaterno: apPaternoDoctor,
                apMaterno: apMaternoDoctor,
                telefonoCelular: telefonoDoctor,
                email: emailDoctor,
              },
              estudios: cleaned,

            };
          }
        }
      } else {
        if (selectedDoctor) {
          if (selectedEmpresa) {
            solicitud = {
              solicitud: {
                idConvenio: selectedEmpresa.idConvenio,
                idDoctor: selectedDoctor.idDoctor,
                enviarEmail: enviarEmailC,
                enviarWhatsapp: enviarWhatsappC,
                numCuarto: numCuarto,
                notas: notas,
                subtotal: subtotalSolicitud,
                descuentoTotal: descuentoTotal,
                motivoDescuento: motivoDescuento,
                tipoDescuento: opcionDescuento,
                totalPagar: totalSolicitud,
                requiereFactura: requiereFactura ? 1 : 0,
                iva: ivaSolicitud,
                idSucursal: currentU.sucursal,
                fecha: getFormattedNow(),
                estatus: "S",
                motivoCancelacion: "",
                inserto: currentU.id,
              },
              paciente: {
                nombre: nombre,
                apPaterno: apPaterno,
                apMaterno: apMaterno,
                fechaNacimiento: fechaNac,
                edad: edadNormalizada,
                sexo: sexo,
                email: email,
                telefonoCelular: telefonoCelular,
                direccion: direccion,
                colonia: colonia,
                cPostal: cPostal,
                estado: estadoN,
                ciudad: ciudad,
                ine: ine,
              },
              estudios: cleaned,

            };
          } else {
            solicitud = {
              solicitud: {
                idConvenio: null,
                idDoctor: selectedDoctor.idDoctor,
                enviarEmail: enviarEmailC,
                enviarWhatsapp: enviarWhatsappC,
                numCuarto: numCuarto,
                notas: notas,
                subtotal: subtotalSolicitud,
                descuentoTotal: descuentoTotal,
                motivoDescuento: motivoDescuento,
                tipoDescuento: opcionDescuento,
                totalPagar: totalSolicitud,
                requiereFactura: requiereFactura ? 1 : 0,
                iva: ivaSolicitud,
                idSucursal: currentU.sucursal,
                fecha: getFormattedNow(),
                estatus: "S",
                motivoCancelacion: "",
                inserto: currentU.id,
              },
              paciente: {
                nombre: nombre,
                apPaterno: apPaterno,
                apMaterno: apMaterno,
                fechaNacimiento: fechaNac,
                edad: edadNormalizada,
                sexo: sexo,
                email: email,
                telefonoCelular: telefonoCelular,
                direccion: direccion,
                colonia: colonia,
                cPostal: cPostal,
                estado: estadoN,
                ciudad: ciudad,
                ine: ine,
              },
              estudios: cleaned,

            };
          }
        } else {
          if (selectedEmpresa) {
            solicitud = {
              solicitud: {
                idConvenio: selectedEmpresa.idConvenio,
                enviarEmail: enviarEmailC,
                enviarWhatsapp: enviarWhatsappC,
                numCuarto: numCuarto,
                notas: notas,
                subtotal: subtotalSolicitud,
                descuentoTotal: descuentoTotal,
                motivoDescuento: motivoDescuento,
                tipoDescuento: opcionDescuento,
                totalPagar: totalSolicitud,
                requiereFactura: requiereFactura ? 1 : 0,
                iva: ivaSolicitud,
                idSucursal: currentU.sucursal,
                fecha: getFormattedNow(),
                estatus: "S",
                motivoCancelacion: "",
                inserto: currentU.id,
              },
              paciente: {
                nombre: nombre,
                apPaterno: apPaterno,
                apMaterno: apMaterno,
                fechaNacimiento: fechaNac,
                edad: edadNormalizada,
                sexo: sexo,
                email: email,
                telefonoCelular: telefonoCelular,
                direccion: direccion,
                colonia: colonia,
                cPostal: cPostal,
                estado: estadoN,
                ciudad: ciudad,
                ine: ine,
              },
              doctor: {
                nombre: nombreDoctor,
                apPaterno: apPaternoDoctor,
                apMaterno: apMaternoDoctor,
                telefonoCelular: telefonoDoctor,
                email: emailDoctor,
              },
              estudios: cleaned,

            };
          } else {
            solicitud = {
              solicitud: {
                idConvenio: null,
                enviarEmail: enviarEmailC,
                enviarWhatsapp: enviarWhatsappC,
                numCuarto: numCuarto,
                notas: notas,
                subtotal: subtotalSolicitud,
                descuentoTotal: descuentoTotal,
                motivoDescuento: motivoDescuento,
                tipoDescuento: opcionDescuento,
                totalPagar: totalSolicitud,
                requiereFactura: requiereFactura ? 1 : 0,
                iva: ivaSolicitud,
                idSucursal: currentU.sucursal,
                fecha: getFormattedNow(),
                estatus: "S",
                motivoCancelacion: "",
                inserto: currentU.id,
              },
              paciente: {
                nombre: nombre,
                apPaterno: apPaterno,
                apMaterno: apMaterno,
                fechaNacimiento: fechaNac,
                edad: edadNormalizada,
                sexo: sexo,
                email: email,
                telefonoCelular: telefonoCelular,
                direccion: direccion,
                colonia: colonia,
                cPostal: cPostal,
                estado: estadoN,
                ciudad: ciudad,
                ine: ine,
              },
              doctor: {
                nombre: nombreDoctor,
                apPaterno: apPaternoDoctor,
                apMaterno: apMaternoDoctor,
                telefonoCelular: telefonoDoctor,
                email: emailDoctor,
              },
              estudios: cleaned,

            };
          }
        }
      }

      if (solicitud && solicitud.solicitud) {
        const idDoctoresArr = [];

        if (selectedDoctor?.idDoctor) {
          solicitud.solicitud.idDoctor = selectedDoctor.idDoctor;
          delete solicitud.doctor;
          delete solicitud.solicitud.doctor;
          idDoctoresArr.push(selectedDoctor.idDoctor);
        } else if (nombreDoctor && nombreDoctor.trim() !== "") {
          solicitud.solicitud.idDoctor = null;
          const dObj1 = {
            nombre: nombreDoctor,
            apPaterno: apPaternoDoctor || "",
            apMaterno: apMaternoDoctor || "",
            telefonoCelular: telefonoDoctor || "",
            email: emailDoctor || "",
          };
          solicitud.doctor = dObj1;
          solicitud.solicitud.doctor = dObj1;
        } else {
          solicitud.solicitud.idDoctor = 1;
          delete solicitud.doctor;
          delete solicitud.solicitud.doctor;
          idDoctoresArr.push(1);
        }

        if (cantidadDoctores >= 2) {
          if (selectedDoctor2?.idDoctor) {
            solicitud.solicitud.idDoctor2 = selectedDoctor2.idDoctor;
            idDoctoresArr.push(selectedDoctor2.idDoctor);
          } else if (nombreDoctor2 && nombreDoctor2.trim() !== "") {
            solicitud.solicitud.idDoctor2 = null;
            const dObj2 = {
              nombre: nombreDoctor2,
              apPaterno: apPaternoDoctor2 || "",
              apMaterno: apMaternoDoctor2 || "",
              telefonoCelular: telefonoDoctor2 || "",
              email: emailDoctor2 || "",
            };
            solicitud.doctor2 = dObj2;
            solicitud.solicitud.doctor2 = dObj2;
          } else {
            solicitud.solicitud.idDoctor2 = null;
          }
        } else {
          solicitud.solicitud.idDoctor2 = null;
        }

        if (cantidadDoctores === 3) {
          if (selectedDoctor3?.idDoctor) {
            solicitud.solicitud.idDoctor3 = selectedDoctor3.idDoctor;
            idDoctoresArr.push(selectedDoctor3.idDoctor);
          } else if (nombreDoctor3 && nombreDoctor3.trim() !== "") {
            solicitud.solicitud.idDoctor3 = null;
            const dObj3 = {
              nombre: nombreDoctor3,
              apPaterno: apPaternoDoctor3 || "",
              apMaterno: apMaternoDoctor3 || "",
              telefonoCelular: telefonoDoctor3 || "",
              email: emailDoctor3 || "",
            };
            solicitud.doctor3 = dObj3;
            solicitud.solicitud.doctor3 = dObj3;
          } else {
            solicitud.solicitud.idDoctor3 = null;
          }
        } else {
          solicitud.solicitud.idDoctor3 = null;
        }

        solicitud.solicitud.idDoctores = idDoctoresArr;
      }

      const estatusActual = `${solicitudEstatus ?? ""}`.trim().toUpperCase();
      const estudiosConDatos = removeAllEmpty(cleaned);
      const idsOriginales = new Set(
        (estudiosOriginales || [])
          .map((estudioOriginal) => `${estudioOriginal.idEstudio ?? ""}`.trim())
          .filter(Boolean),
      );
      const tieneEstudioNuevo =
        editModeG &&
        Boolean(selectedSolicitudId) &&
        estudiosConDatos.some((estudio) => {
          const idEstudio = `${estudio.idEstudio ?? ""}`.trim();
          return idEstudio !== "" && !idsOriginales.has(idEstudio);
        });
      const estatusFinal =
        editModeG &&
          Boolean(selectedSolicitudId) &&
          tieneEstudioNuevo &&
          (["P", "PC"].includes(estatusActual) ||
            parseNumero(solicitudACuenta) > 0 ||
            parseNumero(totalesCaja.aCuenta) > 0)
          ? "PC"
          : estatusActual;

      const idDoctorVal = selectedDoctor?.idDoctor || null;
      const idDoctor2Val = cantidadDoctores >= 2 ? (selectedDoctor2?.idDoctor || null) : null;
      const idDoctor3Val = cantidadDoctores === 3 ? (selectedDoctor3?.idDoctor || null) : null;
      const idDoctoresArr = [idDoctorVal, idDoctor2Val, idDoctor3Val].filter(Boolean);

      solicitudUpd = {
        solicitud: {
          idDoctor: idDoctorVal,
          idDoctorN: idDoctorVal,
          idDoctor2: idDoctor2Val,
          idDoctor2N: idDoctor2Val,
          idDoctor3: idDoctor3Val,
          idDoctor3N: idDoctor3Val,
          idDoctores: idDoctoresArr,
          idDoctoresN: idDoctoresArr,
          notasN: notas,
          subtotalN: subtotalSolicitud,
          descuentoTotalN: descuentoTotal,
          tipoDescuentoN: opcionDescuento,
          totalPagarN: totalSolicitud,
          requiereFacturaN: requiereFactura ? 1 : 0,
          ivaN: ivaSolicitud,
          motivoDescuentoN: motivoDescuento,
          enviarEmailN: enviarEmailC,
          enviarWhatsappN: enviarWhatsappC,
          numCuartoN: numCuarto,
          estatusN: estatusFinal,
        },
        idDoctor: idDoctorVal,
        idDoctor2: idDoctor2Val,
        idDoctor3: idDoctor3Val,
        idDoctores: idDoctoresArr,
        estudios: cleaned,
      };

      if (!idDoctorVal && nombreDoctor) {
        const doc1Obj = {
          nombre: nombreDoctor,
          apPaterno: apPaternoDoctor || "",
          apMaterno: apMaternoDoctor || "",
          telefonoCelular: telefonoDoctor || "",
          email: emailDoctor || "",
        };
        solicitudUpd.doctor = doc1Obj;
        solicitudUpd.doctorN = doc1Obj;
        solicitudUpd.solicitud.doctor = doc1Obj;
        solicitudUpd.solicitud.doctorN = doc1Obj;
      }

      if (cantidadDoctores >= 2 && !idDoctor2Val && nombreDoctor2) {
        const doc2Obj = {
          nombre: nombreDoctor2,
          apPaterno: apPaternoDoctor2 || "",
          apMaterno: apMaternoDoctor2 || "",
          telefonoCelular: telefonoDoctor2 || "",
          email: emailDoctor2 || "",
        };
        solicitudUpd.doctor2 = doc2Obj;
        solicitudUpd.doctor2N = doc2Obj;
        solicitudUpd.solicitud.doctor2 = doc2Obj;
        solicitudUpd.solicitud.doctor2N = doc2Obj;
      }

      if (cantidadDoctores === 3 && !idDoctor3Val && nombreDoctor3) {
        const doc3Obj = {
          nombre: nombreDoctor3,
          apPaterno: apPaternoDoctor3 || "",
          apMaterno: apMaternoDoctor3 || "",
          telefonoCelular: telefonoDoctor3 || "",
          email: emailDoctor3 || "",
        };
        solicitudUpd.doctor3 = doc3Obj;
        solicitudUpd.doctor3N = doc3Obj;
        solicitudUpd.solicitud.doctor3 = doc3Obj;
        solicitudUpd.solicitud.doctor3N = doc3Obj;
      }

      let codigoSolicitud = "";
      if (!editModeG && solicitud?.solicitud) {
        codigoSolicitud = await generarCodigoSolicitud();
        solicitud.solicitud.codigo = codigoSolicitud;
        setSolicitudCodigo(codigoSolicitud);
      }

      try {
        let resultado;

        if (editModeG) {
          resultado = await SolicitudesService.updateSolicitud(
            solicitudUpd,
            selectedSolicitudId,
          );
          if (resultado.data.estatus === "OK") {
            setSolicitudEstatus(estatusFinal);
            if (selectedSolicitudId) {
              await actualizarTotalesCaja(selectedSolicitudId);
            }

            const targetId = selectedSolicitudId;

            // 1. Registro de Descuento Global (solo si cambió de valor/tipo/motivo)
            const descuentoCambio =
              opcionDescuento !== opcionDescuentoOriginal ||
              String(valorGeneral || "") !== String(valorGeneralOriginal || "") ||
              String(motivoDescuento || "") !== String(motivoDescuentoOriginal || "");

            if (descuentoCambio && opcionDescuento !== "ninguno" && valorGeneral) {
              if (opcionDescuento === "porcentaje") {
                registrarMovimientoSolicitud("DSC", `Se agregó descuento del ${valorGeneral}% (Motivo: ${motivoDescuento || "General"})`, targetId);
              } else if (opcionDescuento === "cantidad") {
                registrarMovimientoSolicitud("DSC", `Se agregó descuento de $${valorGeneral} (Motivo: ${motivoDescuento || "General"})`, targetId);
              }
            }

            // 2. Registro de Adición de Estudios Nuevos
            (cleaned || []).forEach((est) => {
              const idEst = String(est.idEstudio ?? "").trim();
              const orig = (estudiosOriginales || []).find((o) => String(o.idEstudio ?? "").trim() === idEst);
              if (idEst && !orig) {
                registrarMovimientoSolicitud("ADD", `Se agregó el estudio: ${est.nombre || est.codigo}`, targetId);
              }
            });

            // 3. Registro de Descuentos Individuales por Estudio
            (cleaned || []).forEach((est) => {
              const idEst = String(est.idEstudio ?? "").trim();
              const orig = (estudiosOriginales || []).find((o) => String(o.idEstudio ?? "").trim() === idEst);
              if (orig && String(est.descuento || "") !== String(orig.descuento || "") && est.descuento !== "" && est.descuento !== null) {
                const descFmt = opcionDescuento === "porcentaje" ? `${est.descuento}%` : `$${est.descuento}`;
                registrarMovimientoSolicitud("DSC_I", `Se agregó descuento individual de ${descFmt} al estudio ${est.nombre || est.codigo}`, targetId);
              }
            });

            // 4. Registro de Cambios en Fechas de Entrega
            (cleaned || []).forEach((est) => {
              const idEst = String(est.idEstudio ?? "").trim();
              const orig = (estudiosOriginales || []).find((o) => String(o.idEstudio ?? "").trim() === idEst);
              const fechaOrig = orig ? formatDateForBackend(orig.fechaEntrega) : "";
              const fechaNueva = formatDateForBackend(est.fechaEntrega);
              if (orig && fechaNueva && fechaOrig !== fechaNueva) {
                registrarMovimientoSolicitud("FEC", `Se cambió la fecha de entrega del estudio ${est.nombre || est.codigo} de '${fechaOrig || "sin fecha"}' a '${fechaNueva}'`, targetId);
              }
            });

            // 5. Registro de Muestra Pendiente
            (cleaned || []).forEach((est) => {
              const idEst = String(est.idEstudio ?? "").trim();
              const orig = (estudiosOriginales || []).find((o) => String(o.idEstudio ?? "").trim() === idEst);
              const pendOrig = orig ? Boolean(orig.muestraPendiente || `${orig.fechaMuestra || ""}`.trim().toUpperCase() === "PENDIENTE") : false;
              const pendNuevo = Boolean(est.muestraPendiente || `${est.fechaMuestra || ""}`.trim().toUpperCase() === "PENDIENTE");
              if (orig && pendOrig !== pendNuevo) {
                const estAnt = pendOrig ? "Pendiente" : "Registrada";
                registrarMovimientoSolicitud("PEN", `Se marcó como ${pendNuevo ? "pendiente" : "registrada"} la muestra del estudio ${est.nombre || est.codigo} (Estado anterior: ${estAnt})`, targetId);
              }
            });

            mostrarMensajeSolicitud("Solicitud modificada con éxito!");
          } else {
            mostrarError(
              "No se pudo modificar la solicitud: " + resultado.data.mensaje,
            );
          }
        } else {
          resultado = await SolicitudesService.agregarSolicitud(solicitud);
          if (resultado.data.estatus === "OK") {
            if (codigoSolicitud && cotizacionHeader?.idCotizacion) {
              try {
                let cotizacion = {
                  conversionSol: codigoSolicitud,
                }
                const respuestaCotizacion = await CotizacionesService.updateCodigoCotizacion(
                  cotizacion,
                  cotizacionHeader.idCotizacion,
                );
                if (respuestaCotizacion?.data?.estatus !== "OK") {
                  mostrarError(
                    "La solicitud se registró, pero no se pudo actualizar la cotización con el código generado.",
                  );
                  return;
                }
              } catch (error) {
                console.error(error);
                mostrarError(
                  "La solicitud se registró, pero no se pudo actualizar la cotización con el código generado.",
                );
                return;
              }
            }

            let nuevoId = null;
            try {
              const respuestaSolicitudes = await SolicitudesService.getSolicitudes();
              const solicitudesList = respuestaSolicitudes?.data?.solicitudes || [];
              const solicitudReciente = solicitudesList.find(
                (item) => String(item?.codigo || "") === String(codigoSolicitud),
              );

              if (solicitudReciente?.idSolicitud) {
                nuevoId = solicitudReciente.idSolicitud;
                if (esUsuarioAdmin(currentU)) {
                  await editarSolicitud(solicitudReciente);
                } else {
                  await verSolicitud(solicitudReciente);
                }
              }
            } catch (error) {
              console.error("Error al cargar la solicitud recién creada:", error);
            }

            mostrarMensajeSolicitud("Solicitud agregada con éxito!");
            registrarMovimientoSolicitud("CRE", `Creación de la solicitud ${codigoSolicitud || ""}`, nuevoId);
          } else {
            mostrarError(
              "No se pudo agregar la solicitud: " + resultado.data.mensaje,
            );
          }
        }
      } catch (error) {
        mostrarError("Error al actualizar solicitud:", error);
      }
    }
  };


  return (
    <Layout>
      <Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "50%",
            paddingTop: "2vh",
            paddingBottom: "2vh",
          }}
        >
          <Stack spacing={2} sx={{ width: "95vw", maxWidth: "96vw" }}>
            <Snackbar
              open={snackbar.open}
              autoHideDuration={3000}
              onClose={() =>
                setSnackbar((prev) => ({ ...prev, open: false }))
              }
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
              <Alert
                onClose={() =>
                  setSnackbar((prev) => ({ ...prev, open: false }))
                }
                severity={snackbar.severity}
                sx={{ width: "100%" }}
              >
                {snackbar.message}
              </Alert>
            </Snackbar>

            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperCot"
            >
              {showCotizacionPacienteHeader ? (
                <Grid container spacing={"24vw"} sx={{ display: "flex", justifyContent: "center" }} justifyContent="center">
                  <Stack spacing={2} alignItems="center">
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 1.5,

                      }}
                    >
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        gutterBottom
                        sx={{
                          fontWeight: "bold",
                          background:
                            "linear-gradient(90deg, #006787, #014e65)",
                          color: "white",
                          padding: "0.5vw 0.5vw",
                          borderRadius: "8px",
                          display: "inline-block",
                        }}
                      >
                        Orden #: {solicitudCodigo ?? "-"}
                      </Typography>
                      <Typography
                        variant="h7"
                        fontWeight="bold"
                        gutterBottom
                        sx={{
                          fontWeight: "bold",
                          background:
                            "linear-gradient(90deg, #006787, #014e65)",
                          color: "white",
                          padding: "0.5vw 0.5vw",
                          borderRadius: "8px",
                          display: "inline-block",
                        }}
                      >
                        Sucursal: {sucursalNombre || "-"}
                      </Typography>
                    </Box>
                  </Stack>
                  <Grid item xs={4}>
                    <Stack spacing={1} sx={{ height: "100%" }}>
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Box
                          sx={{

                            color: "white",
                            px: 1.5,
                            py: 1,
                            borderRadius: 0.5,
                            minWidth: "45%",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="h7"
                            fontWeight="bold"
                            gutterBottom
                            sx={{
                              fontWeight: "bold",
                              background:
                                "linear-gradient(90deg, #006787, #014e65)",
                              color: "white",
                              padding: "0.5vw 0.5vw",
                              borderRadius: "8px",
                              display: "inline-block",
                            }}
                          >
                            Fecha de solicitud:
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            background: "#e7eef1",
                            px: 1.5,
                            py: 1,
                            borderRadius: "8px",
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography variant="body2">
                            {fecha || "-"}
                          </Typography>
                        </Box>
                      </Box>

                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Box
                          sx={{
                            color: "white",
                            px: 1.5,
                            py: 1,
                            borderRadius: 0.5,
                            minWidth: "45%",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="h7"
                            fontWeight="bold"
                            gutterBottom
                            sx={{
                              fontWeight: "bold",
                              background:
                                "linear-gradient(90deg, #006787, #014e65)",
                              color: "white",
                              padding: "0.5vw 0.5vw",
                              borderRadius: "8px",
                              display: "inline-block",
                            }}
                          >
                            Insertó:
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            background: "#e7eef1",
                            px: 1.5,
                            py: 1,
                            borderRadius: "8px",
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography variant="body2">
                            {solicitudInserto || "-"}
                          </Typography>
                        </Box>
                      </Box>
                    </Stack>
                  </Grid>

                </Grid>
              ) : (
                <Grid item xs={2}>
                  <InputLabel
                    htmlFor="txfNoCotizacion"
                    sx={{
                      color: "black",
                      fontSize: "1vw",
                      fontWeight: "bold"
                    }}
                  >
                    No. de cotizacion:
                  </InputLabel>
                  <TextField
                    disabled={viewOnly}
                    value={cotizacionNumero}
                    onChange={(event) => setCotizacionNumero(event.target.value)}
                    onBlur={(event) => cargarCotizacionEnFormulario(event.target.value)}
                    type="number"
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "5vh",
                      },
                      "& .MuiInputBase-input": {
                        fontSize: "1vw",
                        padding: "0.5vw",
                      },
                    }}
                    className="txfNoCotizacion"
                  />
                </Grid>)}
            </Paper>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperSol"
            >
              <Grid item xs={12}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    mb: 1,
                  }}
                >
                  <Typography
                    variant="h7"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                      fontWeight: "bold",
                      background: "linear-gradient(90deg, #006787, #014e65)",
                      color: "white",
                      padding: "0.5vw 1vw",
                      borderRadius: "8px",
                      display: "inline-block",
                      m: 0,
                    }}
                  >
                    Ficha de datos del paciente:
                  </Typography>

                  {!esEstatusSoloLectura(solicitudEstatus) && (
                    <Box
                      sx={{
                        position: "absolute",
                        right: 0,
                        display: "flex",
                        gap: "0.5vw",
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={changePaciente}
                        sx={{
                          fontSize: "0.75vw",
                          fontWeight: "bold",
                          backgroundColor: "#9f7003",
                          color: "white",
                          borderRadius: "8px",
                          padding: "0.4vw 0.8vw",
                          "&:hover": {
                            backgroundColor: "#7e9405",
                            transform: "scale(1.05)",
                          },
                        }}
                        startIcon={<CachedIcon sx={{ fontSize: "1.4vw" }} />}
                      >
                        Cambiar paciente
                      </Button>
                      <Button
                        onClick={changeEditMode}
                        variant="contained"
                        sx={{
                          fontSize: "0.75vw",
                          fontWeight: "bold",
                          backgroundColor: "#9f7003",
                          color: "white",
                          borderRadius: "8px",
                          padding: "0.4vw 0.8vw",
                          "&:hover": {
                            backgroundColor: "#7e9405",
                            transform: "scale(1.05)",
                          },
                        }}
                        startIcon={<EditIcon sx={{ fontSize: "1.4vw" }} />}
                      >
                        Editar paciente
                      </Button>
                    </Box>
                  )}
                </Box>
              </Grid>

              {/* Contenedor principal */}
              <Grid container spacing={"0.3vw"}>
                <Grid
                  item
                  xs={12}
                  container
                  spacing={"1vw"}
                  sx={{ paddingTop: "0.6vw" }}
                >
                  <Stack direction="row" spacing={"3vw"}>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfNombre"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Nombre: <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      {editMode ? (
                        <TextField
                          value={nombre}
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          onChange={(e) => setNombre(e.target.value)}
                          onBlur={(e) => saveField("nombre", e.target.value)}
                          fullWidth
                          sx={{
                            "& .MuiInputBase-root": {
                              width: "13vw",
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfNombre"
                          InputProps={{
                            endAdornment: saving.nombre ? (
                              <CircularProgress size={16} />
                            ) : null,
                          }}
                        />
                      ) : (
                        <Autocomplete
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          options={pacientes}
                          value={selectedPaciente}
                          popupIcon={null}
                          getOptionLabel={(option) =>
                            option
                              ? option.nombre +
                              " " +
                              option.apPaterno +
                              " " +
                              option.apMaterno
                              : ""
                          }
                          onChange={(event, value) => {
                            setSelectedPaciente(value);


                            if (value) {
                              setNombre(value.nombre || "");
                              setApPaterno(value.apPaterno || "");
                              setApMaterno(value.apMaterno || "");
                            }
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.idPaciente ===
                            (value ? value.idPaciente : null)
                          }
                          inputValue={nombre} // controla lo que se ve en el input
                          onInputChange={(event, newInputValue, reason) => {
                            // si el usuario escribe, desvinculamos la selección para que no reemplace el texto
                            if (reason === "input") {
                              setSelectedPaciente(null);
                              setNombre(newInputValue);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                              value={nombre}
                              onChange={(e) => setNombre(e.target.value)}
                              error={errorNombre}
                              helperText={
                                errorNombre ? "Nombre obligatorio" : ""
                              }
                              sx={{
                                "& .MuiInputBase-root": {
                                  width: "13vw",
                                  height: "5vh",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "1vw",
                                  padding: "0.5vw",
                                },
                              }}
                              className="txfNombre"
                            />
                          )}
                          filterOptions={(options, state) => {
                            const input = (state.inputValue || "")
                              .trim()
                              .toLowerCase();
                            if (!input) return options;
                            return options.filter((opt) => {
                              const combined =
                                `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase();
                              return combined.includes(input);
                            });
                          }}
                        />
                      )}
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfApPaterno"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Apellido Paterno:{" "}
                        <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      {editMode ? (
                        <TextField
                          value={apPaterno}
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          onChange={(e) => setApPaterno(e.target.value)}
                          onBlur={(e) => saveField("apPaterno", e.target.value)}
                          fullWidth
                          sx={{
                            "& .MuiInputBase-root": {
                              width: "13vw",
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfApPaterno"
                          InputProps={{
                            endAdornment: saving.apPaterno ? (
                              <CircularProgress size={16} />
                            ) : null,
                          }}
                        />
                      ) : (
                        <Autocomplete
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          options={pacientes}
                          value={selectedPaciente}
                          popupIcon={null}
                          getOptionLabel={(option) =>
                            option
                              ? option.nombre +
                              " " +
                              option.apPaterno +
                              " " +
                              option.apMaterno
                              : ""
                          }
                          onChange={(event, value) => {
                            setSelectedPaciente(value);
                            setViewOnlyP(true);
                            if (value) {
                              setNombre(value.nombre || "");
                              setApPaterno(value.apPaterno || "");
                              setApMaterno(value.apMaterno || "");
                            }
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.idPaciente ===
                            (value ? value.idPaciente : null)
                          }
                          inputValue={apPaterno}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input") {
                              setSelectedPaciente(null);
                              setApPaterno(newInputValue);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              value={apPaterno}
                              disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                              error={errorApPaterno}
                              helperText={
                                errorApPaterno
                                  ? "Apellido paterno obligatorio"
                                  : ""
                              }
                              onChange={(e) => setApPaterno(e.target.value)}
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "5vh",
                                  width: "13vw",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "1vw",
                                  padding: "0.5vw",
                                },
                              }}
                              className="txfApPaterno"
                            />
                          )}
                          filterOptions={(options, state) => {
                            const input = (state.inputValue || "")
                              .trim()
                              .toLowerCase();
                            if (!input) return options;
                            return options.filter((opt) => {
                              const combined =
                                `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase();
                              return combined.includes(input);
                            });
                          }}
                        />
                      )}
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfApMaterno"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Apellido Materno:
                      </InputLabel>
                      {editMode ? (
                        <TextField
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          value={apMaterno}
                          onChange={(e) => setApMaterno(e.target.value)}
                          onBlur={(e) => saveField("apMaterno", e.target.value)}
                          InputProps={{
                            endAdornment: saving.apMaterno ? (
                              <CircularProgress size={16} />
                            ) : null,
                          }}
                          fullWidth
                          sx={{
                            "& .MuiInputBase-root": {
                              width: "13vw",
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfApMaterno"
                        />
                      ) : (
                        <Autocomplete
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          options={pacientes}
                          value={selectedPaciente}
                          popupIcon={null}
                          getOptionLabel={(option) =>
                            option
                              ? option.nombre +
                              " " +
                              option.apPaterno +
                              " " +
                              option.apMaterno
                              : ""
                          }
                          onChange={(event, value) => {
                            setSelectedPaciente(value);
                            setViewOnlyP(true);
                            if (value) {
                              setNombre(value.nombre || "");
                              setApPaterno(value.apPaterno || "");
                              setApMaterno(value.apMaterno || "");
                            }
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.idPaciente ===
                            (value ? value.idPaciente : null)
                          }
                          inputValue={apMaterno}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input") {
                              setSelectedPaciente(null);
                              setApMaterno(newInputValue);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                              value={apMaterno}
                              onChange={(e) => setApMaterno(e.target.value)}
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "5vh",
                                  width: "13vw",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "1vw",
                                  padding: "0.5vw",
                                },
                              }}
                              className="txfApMaterno"
                            />
                          )}
                          filterOptions={(options, state) => {
                            const input = (state.inputValue || "")
                              .trim()
                              .toLowerCase();
                            if (!input) return options;
                            return options.filter((opt) => {
                              const combined =
                                `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase();
                              return combined.includes(input);
                            });
                          }}
                        />
                      )}
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfFechaNacimiento"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Fecha de Nacimiento:
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={fechaNac}
                        disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                        onChange={(e) => {
                          const val = e.target.value;
                          setFechaNac(val);
                          const edadCalc = calcularEdadDesdeFechaNacimiento(val);
                          if (edadCalc) {
                            setEdad(edadCalc);
                            if (errorEdad) setErrorEdad(false);
                          }
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          if (editMode && val) {
                            saveField("fechaNacimiento", val);
                            const edadCalc = calcularEdadDesdeFechaNacimiento(val);
                            if (edadCalc) saveField("edad", edadCalc);
                          }
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            width: "13vw",
                            height: "5vh",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfFechaNacimiento"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfEdad"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Edad:<span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={edad}
                        disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                        error={errorEdad}
                        helperText={errorEdad ? "Obligatorio" : ""}
                        onChange={(e) => {
                          const nuevaEdad = e.target.value;
                          setEdad(nuevaEdad);
                          if (errorEdad && e.target.value.trim() !== "") {
                            setErrorEdad(false);
                          }
                        }}
                        onBlur={(e) => {
                          const normal = normalizarEdad(e.target.value);
                          setEdad(normal);
                          if (editMode) saveField("edad", normal);
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                            width: "13vw",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfEdad"

                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                  </Stack>
                  {/* Sexo y estado civil */}

                  <Grid
                    item
                    xs={12}
                    container
                    spacing={"1vw"}
                    sx={{ paddingTop: "0.4vw" }}
                  >
                    <Stack direction="row" spacing={"2vw"}>
                      <Grid item xs={2}>
                        <FormControl>
                          <FormLabel
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Sexo:<span style={{ color: "red" }}>*</span>
                          </FormLabel>
                          <RadioGroup
                            row
                            value={sexo}
                            error={errorSexo}
                            helperText={errorSexo ? "Obligatorio" : ""}
                            onChange={(e) => {
                              const nuevoSexo = e.target.value;
                              setSexo(nuevoSexo);
                              if (errorSexo && e.target.value.trim() !== "") {
                                setErrorSexo(false);
                              }
                              if (editMode) saveField("sexo", nuevoSexo);
                            }}
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          >
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                },
                              }}
                              value="M"
                              control={
                                <Radio
                                  disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="Masculino"
                            />
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                },
                              }}
                              value="F"
                              control={
                                <Radio
                                  disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="Femenino"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={2}>
                        <InputLabel
                          htmlFor="txfEmail"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Email:
                        </InputLabel>
                        <TextField
                          fullWidth
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          onBlur={(e) => {
                            if (editMode) saveField("email", e.target.value);
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                              width: "13vw",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfEmail"
                          type="email"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="selectEnviarEmail"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                            ml: "1.2vw",
                          }}
                        >
                          ¿Enviar email?
                        </InputLabel>
                        <Select
                          disabled={viewOnly}
                          value={enviarEmail}
                          onChange={(e) => {
                            const nuevoEmail = e.target.value;
                            setEnviarEmail(nuevoEmail);
                          }}
                          input={<OutlinedInput />}
                          sx={{
                            flex: "0 0 8vw",
                            width: "13vw",
                            height: "5vh",
                            maxWidth: "100%",
                            minHeight: "0px !important",
                            overflow: "hidden",
                            ml: "1.2vw",

                            "&.MuiInputBase-root": {
                              height: "5vh",
                              minHeight: "0px !important",
                            },

                            "& .MuiSelect-select": {
                              height: "100% !important",
                              minHeight: "0px !important",
                              padding: "0 0.5vw !important",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "1vw",
                              lineHeight: "1",
                            },

                            "& .MuiOutlinedInput-notchedOutline": {

                              top: 0,
                              "& legend": { display: "none" },
                            },

                            "& .MuiSvgIcon-root": {
                              display: "inline-block !important",
                              position: "absolute",
                              right: "0.5vw",
                              top: "50%",
                              transform: "translateY(-50%)",
                              fontSize: "1.2vw !important",
                              width: "1.2vw !important",
                              height: "1.2vw !important",
                              pointerEvents: "none",

                            },
                            minWidth: "0px !important",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                          }}
                          className="selectEnviarEmail"
                        >
                          <MenuItem
                            sx={{
                              fontSize: "1vw",
                              padding: "0.5vw",
                            }}
                            value="seleccione"
                            disabled
                          >
                            Seleccione
                          </MenuItem>
                          <MenuItem
                            sx={{ fontSize: "1vw", padding: "0.5vw" }}
                            value="si"
                          >
                            Si
                          </MenuItem>
                          <MenuItem
                            sx={{ fontSize: "1vw", padding: "0.5vw" }}
                            value="no"
                          >
                            No
                          </MenuItem>
                        </Select>
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="txfTelefono"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                            ml: "1vw",
                          }}
                        >
                          Teléfono:
                        </InputLabel>
                        <TextField
                          fullWidth
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          value={telefonoCelular}
                          error={tieneMasDe10Digitos(telefonoCelular)}
                          helperText={tieneMasDe10Digitos(telefonoCelular) ? "Máximo 10 dígitos" : ""}
                          onChange={(e) => setTelefonoCelular(e.target.value)}
                          onBlur={(e) => {
                            if (editMode)
                              saveField("telefonoCelular", e.target.value);
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                              width: "13vw",
                              ml: "1vw",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfTelefono"
                        />
                      </Grid>
                      <Grid item xs={6} >
                        <InputLabel
                          htmlFor="selectEnviarWhats"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                            ml: "1vw",
                          }}
                        >
                          ¿Enviar por WhatsApp?
                        </InputLabel>
                        <Select
                          disabled={viewOnly}
                          value={enviarWhatsapp}
                          onChange={(e) => {
                            const nuevoWhatsapp = e.target.value;
                            setEnviarWhatsapp(nuevoWhatsapp);
                          }}
                          input={<OutlinedInput />}

                          sx={{
                            flex: "0 0 8vw",
                            width: "13vw",
                            maxWidth: "100%",
                            ml: "1vw",
                            minHeight: "0px !important",
                            overflow: "hidden",
                            marginRight: "0.5vw",

                            "&.MuiInputBase-root": {
                              height: "5vh",
                              minHeight: "0px !important",
                            },

                            "& .MuiSelect-select": {
                              minHeight: "0px !important",
                              padding: "0 0.5vw !important",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "1vw",
                              lineHeight: "1",
                            },

                            "& .MuiOutlinedInput-notchedOutline": {

                              top: 0,
                              "& legend": { display: "none" },
                            },

                            "& .MuiSvgIcon-root": {
                              display: "inline-block !important",
                              position: "absolute",
                              right: "0.5vw",
                              top: "50%",
                              transform: "translateY(-50%)",
                              fontSize: "1.2vw !important",
                              width: "1.2vw !important",
                              height: "1.2vw !important",
                              pointerEvents: "none",

                            },
                            minWidth: "0px !important",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                          }}
                          className="selectEnviarWhats"
                        >
                          <MenuItem
                            sx={{
                              fontSize: "1vw",
                              padding: "0.5vw",
                            }}
                            value="seleccione"
                            disabled
                          >
                            Seleccione
                          </MenuItem>
                          <MenuItem
                            sx={{ fontSize: "1vw", padding: "0.5vw" }}
                            value="si"
                          >
                            Si
                          </MenuItem>
                          <MenuItem
                            sx={{ fontSize: "1vw", padding: "0.5vw" }}
                            value="no"
                          >
                            No
                          </MenuItem>
                        </Select>
                      </Grid>
                    </Stack>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"1vw"}
                      sx={{ paddingTop: "0.4vw" }}
                    >
                      <Stack direction="row" spacing={"3vw"}>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="txfDireccion"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Dirección:
                          </InputLabel>
                          <TextField
                            fullWidth
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                            value={direccion}
                            onChange={(e) => setDireccion(e.target.value)}
                            onBlur={(e) => {
                              if (editMode) saveField("direccion", e.target.value);
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                                width: "13vw",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfDireccion"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="txfColonia"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Colonia:
                          </InputLabel>
                          <TextField
                            fullWidth
                            value={colonia}
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                            onChange={(e) => setColonia(e.target.value)}
                            onBlur={(e) => {
                              if (editMode) saveField("colonia", e.target.value);
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                                width: "13vw",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfColonia"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="txfCPostal"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Código Postal:
                          </InputLabel>
                          <TextField
                            fullWidth
                            value={cPostal}
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                            onChange={(e) => setCPostal(e.target.value)}
                            onBlur={(e) => {
                              if (editMode) saveField("cPostal", e.target.value);
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                                width: "13vw",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfPostal"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="selectEstado"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Estado:
                          </InputLabel>
                          <Select
                            input={<OutlinedInput />}
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                            value={estado}
                            onChange={(e) => {
                              const nuevoEstado = e.target.value;
                              setEstado(nuevoEstado);
                              if (editMode) saveField("estado", nuevoEstado);
                            }}
                            sx={{
                              flex: "0 0 8vw",
                              height: "5vh",
                              width: "13vw",
                              maxWidth: "100%",

                              minHeight: "0px !important",
                              overflow: "hidden",

                              "&.MuiInputBase-root": {
                                minHeight: "0px !important",
                              },

                              "& .MuiSelect-select": {
                                minHeight: "0px !important",
                                padding: "0 0.5vw !important",
                                display: "flex",
                                alignItems: "center",
                                fontSize: "1vw",
                                lineHeight: "1",
                              },

                              "& .MuiOutlinedInput-notchedOutline": {
                                top: 0,
                                "& legend": { display: "none" },
                              },

                              "& .MuiSvgIcon-root": {
                                display: "inline-block !important",
                                position: "absolute",
                                right: "0.5vw",
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: "1.2vw !important",
                                width: "1.2vw !important",
                                height: "1.2vw !important",
                                pointerEvents: "none",
                              },
                              minWidth: "0px !important",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                            className="selectEstado"
                          >
                            <MenuItem
                              sx={{
                                fontSize: "1vw",
                                padding: "0.5vw",
                              }}
                              value="seleccione"
                              disabled
                            >
                              Seleccione
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Aguascalientes"
                            >
                              Aguascalientes
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Baja California"
                            >
                              Baja California
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Baja California Sur"
                            >
                              Baja California Sur
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Campeche"
                            >
                              Campeche
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Chiapas"
                            >
                              Chiapas
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Chihuahua"
                            >
                              Chihuahua
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Ciudad de México"
                            >
                              Ciudad de México
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Coahuila"
                            >
                              Coahuila
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Colima"
                            >
                              Colima
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Durango"
                            >
                              Durango
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Estado de México"
                            >
                              Estado de México
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Guanajuato"
                            >
                              Guanajuato
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Guerrero"
                            >
                              Guerrero
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Hidalgo"
                            >
                              Hidalgo
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Jalisco"
                            >
                              Jalisco
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Michoacán"
                            >
                              Michoacán
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Morelos"
                            >
                              Morelos
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Nayarit"
                            >
                              Nayarit
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Nuevo León"
                            >
                              Nuevo León
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Oaxaca"
                            >
                              Oaxaca
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Puebla"
                            >
                              Puebla
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Querétaro"
                            >
                              Querétaro
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Quintana Roo"
                            >
                              Quintana Roo
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="San Luis Potosí"
                            >
                              San Luis Potosí
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Sinaloa"
                            >
                              Sinaloa
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Sonora"
                            >
                              Sonora
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Tabasco"
                            >
                              Tabasco
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Tamaulipas"
                            >
                              Tamaulipas
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Tlaxcala"
                            >
                              Tlaxcala
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Veracruz"
                            >
                              Veracruz
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Yucatán"
                            >
                              Yucatán
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Zacatecas"
                            >
                              Zacatecas
                            </MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="txfCiudad"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Ciudad:
                          </InputLabel>
                          <TextField
                            fullWidth
                            value={ciudad}
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                            onChange={(e) => setCiudad(e.target.value)}
                            onBlur={(e) => {
                              if (editMode) saveField("ciudad", e.target.value);
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                                width: "13vw",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfCiudad"
                          />
                        </Grid>
                      </Stack>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"1vw"}
                      sx={{ paddingTop: "0.4vw" }}
                    >
                      <Stack direction="row" spacing={"3vw"}>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="txfNoCuarto"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Numero de cuarto:
                          </InputLabel>
                          <TextField
                            fullWidth
                            value={numCuarto}
                            disabled={viewOnly}
                            onChange={(e) => setNumCuarto(e.target.value)}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                                width: "13vw",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfNoCuarto"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="txfIne"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            INE/Pasaporte:
                          </InputLabel>
                          <TextField
                            fullWidth
                            value={ine}
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                            onChange={(e) => setIne(e.target.value)}
                            onBlur={(e) => {
                              if (editMode) saveField("ine", e.target.value);
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                                width: "13vw",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfIne"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="txfPacienteReferido"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            ¿El paciente es referido de alguna
                            Empresa/Institucion?
                          </InputLabel>
                          <Autocomplete
                            disabled={viewOnly || viewOnlyE || editModeG}
                            options={empresas}
                            value={empresa}
                            popupIcon={null}
                            getOptionLabel={(option) => (option ? option.nombre : "")}
                            onChange={async (event, value) => {
                              await actualizarListaPreciosParaConvenio(value);
                            }}
                            isOptionEqualToValue={(option, value) =>
                              option.idConvenio === (value ? value.idConvenio : null)
                            }
                            inputValue={empresa}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                disabled={viewOnlyE || editModeG || viewOnly}
                                value={empresa}
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                    width: "28vw",
                                  },
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  },
                                }}
                                className="txfNombreEmpresa"
                              />
                            )}
                            filterOptions={(options, state) => {
                              const input = (state.inputValue || "")
                                .trim()
                                .toLowerCase();
                              if (!input) return options;
                              return options.filter((opt) => {
                                const combined = `${opt.nombre || ""}`.toLowerCase();
                                return combined.includes(input);
                              });
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          {!viewOnly && !editModeG ? (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "0.5vw",
                              }}
                            >
                              <Button
                                variant="contained"
                                onClick={changeEmpresa}
                                sx={{
                                  fontSize: "0.7vw",
                                  fontWeight: "bold",
                                  backgroundColor: "#9f7003",
                                  color: "white",
                                  borderRadius: "8px",
                                  padding: "0.5vw 1vw",
                                  "&:hover": {
                                    backgroundColor: "#7e9405",
                                    transform: "scale(1.05)",
                                  },
                                }}
                                startIcon={<CachedIcon sx={{ fontSize: "1.8vw" }} />}
                              >
                                Cambiar empresa
                              </Button>
                            </Box>
                          ) : null}
                        </Grid>
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
            {(() => {
              const isDoctor1Disabled = viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== "")));
              const isDoctor2Disabled = viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== "")));
              const isDoctor3Disabled = viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== "")));
              return null;
            })()}
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperLugar"
            >
              {/* Lugar de atencion */}
              <Grid item xs={12}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    mb: 1,
                  }}
                >
                  <Typography
                    variant="h7"
                    fontWeight="bold"
                    gutterBottom
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      background: "linear-gradient(90deg, #006787, #014e65)",
                      color: "white",
                      padding: "0.5vw 1vw",
                      borderRadius: "8px",
                      display: "inline-block",
                      m: 0,
                    }}
                  >
                    Ficha de datos del doctor:
                  </Typography>

                  {!esEstatusSoloLectura(solicitudEstatus) && (
                    <Box
                      sx={{
                        position: "absolute",
                        right: 0,
                        display: "flex",
                        gap: "0.5vw",
                      }}
                    >
                      <Button
                        onClick={changeDoctor}
                        variant="contained"
                        sx={{
                          fontSize: "0.75vw",
                          fontWeight: "bold",
                          backgroundColor: "#9f7003",
                          color: "white",
                          borderRadius: "8px",
                          padding: "0.4vw 0.8vw",
                          whiteSpace: "nowrap",
                          "&:hover": {
                            backgroundColor: "#7e9405",
                            transform: "scale(1.05)",
                          },
                        }}
                        startIcon={<CachedIcon sx={{ fontSize: "1.4vw" }} />}
                      >
                        Cambiar doctor
                      </Button>
                      <Button
                        variant="contained"
                        onClick={changeEditModeM}
                        sx={{
                          fontSize: "0.75vw",
                          fontWeight: "bold",
                          backgroundColor: "#9f7003",
                          color: "white",
                          borderRadius: "8px",
                          padding: "0.4vw 0.8vw",
                          whiteSpace: "nowrap",
                          "&:hover": {
                            backgroundColor: "#7e9405",
                            transform: "scale(1.05)",
                          },
                        }}
                        startIcon={<EditIcon sx={{ fontSize: "1.4vw" }} />}
                      >
                        Editar doctor
                      </Button>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"2vw"}
                sx={{ paddingTop: "0.4vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="txfNombreDoctor"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Nombre:
                    </InputLabel>
                    {editModeM ? (
                      <TextField
                        value={nombreDoctor}
                        disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                        onChange={(e) => setNombreDoctor(e.target.value)}
                        onBlur={(e) => saveFieldM("nombre", e.target.value, 1)}
                        fullWidth
                        sx={{
                          "& .MuiInputBase-root": {
                            width: "13vw",
                            height: "5vh",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfNombreDoctor"
                        InputProps={{
                          endAdornment: saving.nombreDoctor ? (
                            <CircularProgress size={16} />
                          ) : null,
                        }}
                      />
                    ) : (
                      <Autocomplete
                        openOnFocus
                        disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                        options={doctores}
                        value={selectedDoctor}
                        popupIcon={null}
                        getOptionLabel={(option) =>
                          option
                            ? option.nombre +
                            " " +
                            option.apPaterno +
                            " " +
                            option.apMaterno
                            : ""
                        }
                        onChange={(event, value) => {
                          setSelectedDoctor(value);
                          if (value) {
                            setNombreDoctor(value.nombre || "");
                            setApPaternoDoctor(value.apPaterno || "");
                            setApMaternoDoctor(value.apMaterno || "");
                          }
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.idDoctor ===
                          (value ? value.idDoctor : null)
                        }
                        inputValue={nombreDoctor} // controla lo que se ve en el input
                        onInputChange={(event, newInputValue, reason) => {
                          // si el usuario escribe, desvinculamos la selección para que no reemplace el texto
                          if (reason === "input") {
                            setSelectedDoctor(null);
                            setNombreDoctor(newInputValue);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                            value={nombreDoctor}
                            onChange={(e) => setNombreDoctor(e.target.value)}
                            error={errorNombreDoctor}
                            helperText={
                              errorNombreDoctor ? "Nombre obligatorio" : ""
                            }
                            sx={{
                              "& .MuiInputBase-root": {
                                width: "13vw",
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfNombreDoctor"
                          />
                        )}
                        filterOptions={(options, state) => {
                          const input = (state.inputValue || "")
                            .trim()
                            .toLowerCase();
                          if (!input) return options;
                          return options.filter((opt) => {
                            const combined =
                              `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase();
                            return combined.includes(input);
                          });
                        }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="txfApPaternoDoctor"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Apellido Paterno:
                    </InputLabel>
                    {editModeM ? (
                      <TextField
                        value={apPaternoDoctor}
                        disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                        onChange={(e) => setApPaternoDoctor(e.target.value)}
                        onBlur={(e) => saveFieldM("apPaterno", e.target.value, 1)}
                        fullWidth
                        sx={{
                          "& .MuiInputBase-root": {
                            width: "13vw",
                            height: "5vh",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfApPaterno"
                        InputProps={{
                          endAdornment: saving.apPaternoDoctor ? (
                            <CircularProgress size={16} />
                          ) : null,
                        }}
                      />
                    ) : (
                      <Autocomplete
                        disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                        options={doctores}
                        value={selectedDoctor}
                        popupIcon={null}
                        getOptionLabel={(option) =>
                          option
                            ? option.nombre +
                            " " +
                            option.apPaterno +
                            " " +
                            option.apMaterno
                            : ""
                        }
                        onChange={(event, value) => {
                          setSelectedDoctor(value);
                          setViewOnlyM(true);
                          if (value) {
                            setNombreDoctor(value.nombre || "");
                            setApPaternoDoctor(value.apPaterno || "");
                            setApMaternoDoctor(value.apMaterno || "");
                          }
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.idDoctor ===
                          (value ? value.idDoctor : null)
                        }
                        inputValue={apPaternoDoctor}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === "input") {
                            setSelectedDoctor(null);
                            setApPaternoDoctor(newInputValue);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            value={apPaternoDoctor}
                            disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                            error={errorApPaternoDoctor}
                            helperText={
                              errorApPaternoDoctor
                                ? "Apellido paterno obligatorio"
                                : ""
                            }
                            onChange={(e) => setApPaternoDoctor(e.target.value)}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                                width: "13vw",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfApPaternoDoctor"
                          />
                        )}
                        filterOptions={(options, state) => {
                          const input = (state.inputValue || "")
                            .trim()
                            .toLowerCase();
                          if (!input) return options;
                          return options.filter((opt) => {
                            const combined =
                              `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase();
                            return combined.includes(input);
                          });
                        }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="txfApMaternoDoctor"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Apellido Materno:
                    </InputLabel>
                    {editModeM ? (
                      <TextField
                        disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                        value={apMaternoDoctor}
                        onChange={(e) => setApMaternoDoctor(e.target.value)}
                        onBlur={(e) => saveFieldM("apMaterno", e.target.value, 1)}
                        InputProps={{
                          endAdornment: saving.apMaternoDoctor ? (
                            <CircularProgress size={16} />
                          ) : null,
                        }}
                        fullWidth
                        sx={{
                          "& .MuiInputBase-root": {
                            width: "13vw",
                            height: "5vh",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfApMaternoDoctor"
                      />
                    ) : (
                      <Autocomplete
                        disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                        options={doctores}
                        value={selectedDoctor}
                        popupIcon={null}
                        getOptionLabel={(option) =>
                          option
                            ? option.nombre +
                            " " +
                            option.apPaterno +
                            " " +
                            option.apMaterno
                            : ""
                        }
                        onChange={(event, value) => {
                          setSelectedDoctor(value);
                          setViewOnlyM(true);
                          if (value) {
                            setNombreDoctor(value.nombre || "");
                            setApPaternoDoctor(value.apPaterno || "");
                            setApMaternoDoctor(value.apMaterno || "");
                          }
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.idDoctor ===
                          (value ? value.idDoctor : null)
                        }
                        inputValue={apMaternoDoctor}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === "input") {
                            setSelectedDoctor(null);
                            setApMaternoDoctor(newInputValue);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                            value={apMaternoDoctor}
                            onChange={(e) => setApMaternoDoctor(e.target.value)}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                                width: "13vw",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfApMaternoDoctor"
                          />
                        )}
                        filterOptions={(options, state) => {
                          const input = (state.inputValue || "")
                            .trim()
                            .toLowerCase();
                          if (!input) return options;
                          return options.filter((opt) => {
                            const combined =
                              `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase();
                            return combined.includes(input);
                          });
                        }}
                      />
                    )}
                  </Grid>
                </Stack>
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0.5vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={esComisionD}
                          onChange={(e) => {
                            const val = e.target.checked;
                            setEsComisionD(val);
                            if (selectedDoctor) {
                              setSelectedDoctor((prev) => ({ ...prev, esComision: val, conComision: val }));
                            }
                            if (editModeM && selectedDoctor?.idDoctor) {
                              saveFieldM("conComision", val ? 1 : 0, 1);
                            }
                          }}
                          disabled={!editModeM && (viewOnly || (viewOnlyM && (Boolean(selectedDoctor) || Boolean(nombreDoctor && nombreDoctor.trim() !== ""))))}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              height: "1.2vw",
                              width: "1.2vw",
                            },
                          }}
                        />
                      }
                      label="Doctor con comisión"
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontSize: "1vw",
                          fontWeight: "bold",
                        },
                      }}
                    />
                  </Grid>
                </Stack>
              </Grid>

              {/* Doctor 2 Form */}
              {cantidadDoctores >= 2 && (
                <>
                  <Box sx={{ mt: 3, mb: 1, borderTop: "1px solid #ccc", pt: 2, display: "flex", justifyContent: "flex-end" }}>
                    {!esEstatusSoloLectura(solicitudEstatus) && (
                      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "0.5vw" }}>
                        <Box sx={{ display: "flex", gap: "0.5vw" }}>
                          <Button
                            onClick={changeDoctor2}
                            variant="contained"
                            sx={{
                              fontSize: "0.7vw",
                              backgroundColor: "#9f7003",
                              color: "white",
                              borderRadius: "8px",
                              fontWeight: "bold",
                              padding: "0.5vw 1vw",
                              "&:hover": { backgroundColor: "#7e9405", transform: "scale(1.05)" },
                            }}
                            startIcon={<CachedIcon sx={{ fontSize: "1.8vw" }} />}
                          >
                            Cambiar doctor
                          </Button>
                          <Button
                            variant="contained"
                            onClick={changeEditModeM2}
                            sx={{
                              fontSize: "0.7vw",
                              backgroundColor: "#9f7003",
                              color: "white",
                              borderRadius: "8px",
                              fontWeight: "bold",
                              padding: "0.5vw 1vw",
                              "&:hover": { backgroundColor: "#7e9405", transform: "scale(1.05)" },
                            }}
                            startIcon={<EditIcon sx={{ fontSize: "1.8vw" }} />}
                          >
                            Editar doctor
                          </Button>
                        </Box>
                        {!viewOnly && (
                          <Button
                            variant="outlined"
                            color="error"
                            onClick={() => {
                              if (cantidadDoctores === 3) {
                                setSelectedDoctor2(selectedDoctor3);
                                setNombreDoctor2(nombreDoctor3);
                                setApPaternoDoctor2(apPaternoDoctor3);
                                setApMaternoDoctor2(apMaternoDoctor3);

                                setSelectedDoctor3(null);
                                setNombreDoctor3("");
                                setApPaternoDoctor3("");
                                setApMaternoDoctor3("");

                              } else {
                                setSelectedDoctor2(null);
                                setNombreDoctor2("");
                                setApPaternoDoctor2("");
                                setApMaternoDoctor2("");

                              }
                              setCantidadDoctores((prev) => prev - 1);
                            }}
                            startIcon={<DeleteIcon />}
                            sx={{
                              fontSize: "0.7vw",
                              fontWeight: "bold",
                              borderRadius: "8px",
                              padding: "0.5vw 1vw",
                            }}
                          >
                            Quitar doctor
                          </Button>
                        )}
                      </Box>
                    )}
                  </Box>

                  <Grid item xs={12} container spacing={"2vw"} sx={{ paddingTop: "0.4vw" }}>
                    <Stack direction="row" spacing={"3vw"}>
                      <Grid item xs={6}>
                        <InputLabel sx={{ color: "black", fontSize: "1vw", fontWeight: "bold" }}>Nombre:</InputLabel>
                        {editModeM2 ? (
                          <TextField
                            value={nombreDoctor2}
                            disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                            onChange={(e) => setNombreDoctor2(e.target.value)}
                            onBlur={(e) => saveFieldM("nombre", e.target.value, 2)}
                            fullWidth
                            sx={{
                              "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                              "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                            }}
                          />
                        ) : (
                          <Autocomplete
                            openOnFocus
                            disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                            options={doctores}
                            value={selectedDoctor2}
                            popupIcon={null}
                            getOptionLabel={(option) => option ? `${option.nombre} ${option.apPaterno} ${option.apMaterno}` : ""}
                            onChange={(event, value) => {
                              setSelectedDoctor2(value);
                              if (value) {
                                setNombreDoctor2(value.nombre || "");
                                setApPaternoDoctor2(value.apPaterno || "");
                                setApMaternoDoctor2(value.apMaterno || "");
                              }
                            }}
                            isOptionEqualToValue={(option, value) => option.idDoctor === (value ? value.idDoctor : null)}
                            inputValue={nombreDoctor2}
                            onInputChange={(event, newInputValue, reason) => {
                              if (reason === "input") {
                                setSelectedDoctor2(null);
                                setNombreDoctor2(newInputValue);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                                error={errorNombreDoctor2}
                                helperText={errorNombreDoctor2 ? "Nombre obligatorio" : ""}
                                onChange={(e) => setNombreDoctor2(e.target.value)}
                                className="txfNombreDoctor2"
                                sx={{
                                  "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                  "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                }}
                              />
                            )}
                            filterOptions={(options, state) => {
                              const input = (state.inputValue || "").trim().toLowerCase();
                              if (!input) return options;
                              return options.filter((opt) => `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase().includes(input));
                            }}
                          />
                        )}
                      </Grid>

                      <Grid item xs={6}>
                        <InputLabel sx={{ color: "black", fontSize: "1vw", fontWeight: "bold" }}>Apellido Paterno:</InputLabel>
                        {editModeM2 ? (
                          <TextField
                            value={apPaternoDoctor2}
                            disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                            onChange={(e) => setApPaternoDoctor2(e.target.value)}
                            onBlur={(e) => saveFieldM("apPaterno", e.target.value, 2)}
                            fullWidth
                            sx={{
                              "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                              "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                            }}
                          />
                        ) : (
                          <Autocomplete
                            disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                            options={doctores}
                            value={selectedDoctor2}
                            popupIcon={null}
                            getOptionLabel={(option) => option ? `${option.nombre} ${option.apPaterno} ${option.apMaterno}` : ""}
                            onChange={(event, value) => {
                              setSelectedDoctor2(value);
                              if (value) {
                                setNombreDoctor2(value.nombre || "");
                                setApPaternoDoctor2(value.apPaterno || "");
                                setApMaternoDoctor2(value.apMaterno || "");
                              }
                            }}
                            isOptionEqualToValue={(option, value) => option.idDoctor === (value ? value.idDoctor : null)}
                            inputValue={apPaternoDoctor2}
                            onInputChange={(event, newInputValue, reason) => {
                              if (reason === "input") {
                                setSelectedDoctor2(null);
                                setApPaternoDoctor2(newInputValue);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                                error={errorApPaternoDoctor2}
                                helperText={errorApPaternoDoctor2 ? "Apellido obligatorio" : ""}
                                onChange={(e) => setApPaternoDoctor2(e.target.value)}
                                sx={{
                                  "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                  "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                }}
                              />
                            )}
                            filterOptions={(options, state) => {
                              const input = (state.inputValue || "").trim().toLowerCase();
                              if (!input) return options;
                              return options.filter((opt) => `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase().includes(input));
                            }}
                          />
                        )}
                      </Grid>

                      <Grid item xs={6}>
                        <InputLabel sx={{ color: "black", fontSize: "1vw", fontWeight: "bold" }}>Apellido Materno:</InputLabel>
                        {editModeM2 ? (
                          <TextField
                            value={apMaternoDoctor2}
                            disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                            onChange={(e) => setApMaternoDoctor2(e.target.value)}
                            onBlur={(e) => saveFieldM("apMaterno", e.target.value, 2)}
                            fullWidth
                            sx={{
                              "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                              "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                            }}
                          />
                        ) : (
                          <Autocomplete
                            disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                            options={doctores}
                            value={selectedDoctor2}
                            popupIcon={null}
                            getOptionLabel={(option) => option ? `${option.nombre} ${option.apPaterno} ${option.apMaterno}` : ""}
                            onChange={(event, value) => {
                              setSelectedDoctor2(value);
                              if (value) {
                                setNombreDoctor2(value.nombre || "");
                                setApPaternoDoctor2(value.apPaterno || "");
                                setApMaternoDoctor2(value.apMaterno || "");
                              }
                            }}
                            isOptionEqualToValue={(option, value) => option.idDoctor === (value ? value.idDoctor : null)}
                            inputValue={apMaternoDoctor2}
                            onInputChange={(event, newInputValue, reason) => {
                              if (reason === "input") {
                                setSelectedDoctor2(null);
                                setApMaternoDoctor2(newInputValue);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                                onChange={(e) => setApMaternoDoctor2(e.target.value)}
                                sx={{
                                  "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                  "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                }}
                              />
                            )}
                            filterOptions={(options, state) => {
                              const input = (state.inputValue || "").trim().toLowerCase();
                              if (!input) return options;
                              return options.filter((opt) => `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase().includes(input));
                            }}
                          />
                        )}
                      </Grid>
                    </Stack>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    container
                    spacing={"1vw"}
                    sx={{ paddingTop: "0.5vw" }}
                  >
                    <Stack direction="row" spacing={"3vw"}>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={esComisionD2}
                              onChange={(e) => {
                                const val = e.target.checked;
                                setEsComisionD2(val);
                                if (selectedDoctor2) {
                                  setSelectedDoctor2((prev) => ({ ...prev, esComision: val, conComision: val }));
                                }
                                if (editModeM2 && selectedDoctor2?.idDoctor) {
                                  saveFieldM("conComision", val ? 1 : 0, 2);
                                }
                              }}
                              disabled={!editModeM2 && (viewOnly || (viewOnlyM2 && (Boolean(selectedDoctor2) || Boolean(nombreDoctor2 && nombreDoctor2.trim() !== ""))))}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  height: "1.2vw",
                                  width: "1.2vw",
                                },
                              }}
                            />
                          }
                          label="Doctor con comisión"
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "1vw",
                              fontWeight: "bold",
                            },
                          }}
                        />
                      </Grid>
                    </Stack>
                  </Grid>
                </>
              )}

              {/* Doctor 3 Form */}
              {cantidadDoctores === 3 && (
                <>
                  <Box sx={{ mt: 3, mb: 1, borderTop: "1px solid #ccc", pt: 2, display: "flex", justifyContent: "flex-end" }}>
                    {!esEstatusSoloLectura(solicitudEstatus) && (
                      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "0.5vw" }}>
                        <Box sx={{ display: "flex", gap: "0.5vw" }}>
                          <Button
                            onClick={changeDoctor3}
                            variant="contained"
                            sx={{
                              fontSize: "0.7vw",
                              backgroundColor: "#9f7003",
                              color: "white",
                              borderRadius: "8px",
                              fontWeight: "bold",
                              padding: "0.5vw 1vw",
                              "&:hover": { backgroundColor: "#7e9405", transform: "scale(1.05)" },
                            }}
                            startIcon={<CachedIcon sx={{ fontSize: "1.8vw" }} />}
                          >
                            Cambiar doctor
                          </Button>
                          <Button
                            variant="contained"
                            onClick={changeEditModeM3}
                            sx={{
                              fontSize: "0.7vw",
                              backgroundColor: "#9f7003",
                              color: "white",
                              borderRadius: "8px",
                              fontWeight: "bold",
                              padding: "0.5vw 1vw",
                              "&:hover": { backgroundColor: "#7e9405", transform: "scale(1.05)" },
                            }}
                            startIcon={<EditIcon sx={{ fontSize: "1.8vw" }} />}
                          >
                            Editar doctor
                          </Button>
                        </Box>
                        {!viewOnly && (
                          <Button
                            variant="outlined"
                            color="error"
                            onClick={() => {
                              setSelectedDoctor3(null);
                              setNombreDoctor3("");
                              setApPaternoDoctor3("");
                              setApMaternoDoctor3("");
                              setCantidadDoctores((prev) => prev - 1);
                            }}
                            startIcon={<DeleteIcon />}
                            sx={{
                              fontSize: "0.7vw",
                              fontWeight: "bold",
                              borderRadius: "8px",
                              padding: "0.5vw 1vw",
                            }}
                          >
                            Quitar doctor
                          </Button>
                        )}
                      </Box>
                    )}
                  </Box>

                  <Grid item xs={12} container spacing={"2vw"} sx={{ paddingTop: "0.4vw" }}>
                    <Stack direction="row" spacing={"3vw"}>
                      <Grid item xs={6}>
                        <InputLabel sx={{ color: "black", fontSize: "1vw", fontWeight: "bold" }}>Nombre:</InputLabel>
                        {editModeM3 ? (
                          <TextField
                            value={nombreDoctor3}
                            disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                            onChange={(e) => setNombreDoctor3(e.target.value)}
                            onBlur={(e) => saveFieldM("nombre", e.target.value, 3)}
                            fullWidth
                            sx={{
                              "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                              "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                            }}
                          />
                        ) : (
                          <Autocomplete
                            openOnFocus
                            disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                            options={doctores}
                            value={selectedDoctor3}
                            popupIcon={null}
                            getOptionLabel={(option) => option ? `${option.nombre} ${option.apPaterno} ${option.apMaterno}` : ""}
                            onChange={(event, value) => {
                              setSelectedDoctor3(value);
                              if (value) {
                                setNombreDoctor3(value.nombre || "");
                                setApPaternoDoctor3(value.apPaterno || "");
                                setApMaternoDoctor3(value.apMaterno || "");
                              }
                            }}
                            isOptionEqualToValue={(option, value) => option.idDoctor === (value ? value.idDoctor : null)}
                            inputValue={nombreDoctor3}
                            onInputChange={(event, newInputValue, reason) => {
                              if (reason === "input") {
                                setSelectedDoctor3(null);
                                setNombreDoctor3(newInputValue);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                                error={errorNombreDoctor3}
                                helperText={errorNombreDoctor3 ? "Nombre obligatorio" : ""}
                                onChange={(e) => setNombreDoctor3(e.target.value)}
                                className="txfNombreDoctor3"
                                sx={{
                                  "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                  "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                }}
                              />
                            )}
                            filterOptions={(options, state) => {
                              const input = (state.inputValue || "").trim().toLowerCase();
                              if (!input) return options;
                              return options.filter((opt) => `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase().includes(input));
                            }}
                          />
                        )}
                      </Grid>

                      <Grid item xs={6}>
                        <InputLabel sx={{ color: "black", fontSize: "1vw", fontWeight: "bold" }}>Apellido Paterno:</InputLabel>
                        {editModeM3 ? (
                          <TextField
                            value={apPaternoDoctor3}
                            disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                            onChange={(e) => setApPaternoDoctor3(e.target.value)}
                            onBlur={(e) => saveFieldM("apPaterno", e.target.value, 3)}
                            fullWidth
                            sx={{
                              "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                              "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                            }}
                          />
                        ) : (
                          <Autocomplete
                            disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                            options={doctores}
                            value={selectedDoctor3}
                            popupIcon={null}
                            getOptionLabel={(option) => option ? `${option.nombre} ${option.apPaterno} ${option.apMaterno}` : ""}
                            onChange={(event, value) => {
                              setSelectedDoctor3(value);
                              if (value) {
                                setNombreDoctor3(value.nombre || "");
                                setApPaternoDoctor3(value.apPaterno || "");
                                setApMaternoDoctor3(value.apMaterno || "");
                              }
                            }}
                            isOptionEqualToValue={(option, value) => option.idDoctor === (value ? value.idDoctor : null)}
                            inputValue={apPaternoDoctor3}
                            onInputChange={(event, newInputValue, reason) => {
                              if (reason === "input") {
                                setSelectedDoctor3(null);
                                setApPaternoDoctor3(newInputValue);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                                error={errorApPaternoDoctor3}
                                helperText={errorApPaternoDoctor3 ? "Apellido obligatorio" : ""}
                                onChange={(e) => setApPaternoDoctor3(e.target.value)}
                                sx={{
                                  "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                  "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                }}
                              />
                            )}
                            filterOptions={(options, state) => {
                              const input = (state.inputValue || "").trim().toLowerCase();
                              if (!input) return options;
                              return options.filter((opt) => `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase().includes(input));
                            }}
                          />
                        )}
                      </Grid>

                      <Grid item xs={6}>
                        <InputLabel sx={{ color: "black", fontSize: "1vw", fontWeight: "bold" }}>Apellido Materno:</InputLabel>
                        {editModeM3 ? (
                          <TextField
                            value={apMaternoDoctor3}
                            disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                            onChange={(e) => setApMaternoDoctor3(e.target.value)}
                            onBlur={(e) => saveFieldM("apMaterno", e.target.value, 3)}
                            fullWidth
                            sx={{
                              "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                              "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                            }}
                          />
                        ) : (
                          <Autocomplete
                            disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                            options={doctores}
                            value={selectedDoctor3}
                            popupIcon={null}
                            getOptionLabel={(option) => option ? `${option.nombre} ${option.apPaterno} ${option.apMaterno}` : ""}
                            onChange={(event, value) => {
                              setSelectedDoctor3(value);
                              if (value) {
                                setNombreDoctor3(value.nombre || "");
                                setApPaternoDoctor3(value.apPaterno || "");
                                setApMaternoDoctor3(value.apMaterno || "");
                              }
                            }}
                            isOptionEqualToValue={(option, value) => option.idDoctor === (value ? value.idDoctor : null)}
                            inputValue={apMaternoDoctor3}
                            onInputChange={(event, newInputValue, reason) => {
                              if (reason === "input") {
                                setSelectedDoctor3(null);
                                setApMaternoDoctor3(newInputValue);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                                onChange={(e) => setApMaternoDoctor3(e.target.value)}
                                sx={{
                                  "& .MuiInputBase-root": { width: "13vw", height: "5vh" },
                                  "& .MuiInputBase-input": { fontSize: "1vw", padding: "0.5vw" },
                                }}
                              />
                            )}
                            filterOptions={(options, state) => {
                              const input = (state.inputValue || "").trim().toLowerCase();
                              if (!input) return options;
                              return options.filter((opt) => `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase().includes(input));
                            }}
                          />
                        )}
                      </Grid>
                    </Stack>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    container
                    spacing={"1vw"}
                    sx={{ paddingTop: "0.5vw" }}
                  >
                    <Stack direction="row" spacing={"3vw"}>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={esComisionD3}
                              onChange={(e) => {
                                const val = e.target.checked;
                                setEsComisionD3(val);
                                if (selectedDoctor3) {
                                  setSelectedDoctor3((prev) => ({ ...prev, esComision: val, conComision: val }));
                                }
                                if (editModeM3 && selectedDoctor3?.idDoctor) {
                                  saveFieldM("conComision", val ? 1 : 0, 3);
                                }
                              }}
                              disabled={!editModeM3 && (viewOnly || (viewOnlyM3 && (Boolean(selectedDoctor3) || Boolean(nombreDoctor3 && nombreDoctor3.trim() !== ""))))}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  height: "1.2vw",
                                  width: "1.2vw",
                                },
                              }}
                            />
                          }
                          label="Doctor con comisión"
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "1vw",
                              fontWeight: "bold",
                            },
                          }}
                        />
                      </Grid>
                    </Stack>
                  </Grid>
                </>
              )}

              {/* Botones de Agregar Doctor */}
              {!viewOnly && cantidadDoctores < 3 && (
                <Box sx={{ display: "flex", gap: "1vw", mt: 3, justifyContent: "center" }}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setCantidadDoctores((prev) => {
                        const next = prev + 1;
                        if (next === 2) {
                          setViewOnlyM2(false);
                          setEditModeM2(false);
                          setSelectedDoctor2(null);
                          setNombreDoctor2("");
                          setApPaternoDoctor2("");
                          setApMaternoDoctor2("");
                          setTelefonoDoctor2("");
                          setEmailDoctor2("");
                        }
                        if (next === 3) {
                          setViewOnlyM3(false);
                          setEditModeM3(false);
                          setSelectedDoctor3(null);
                          setNombreDoctor3("");
                          setApPaternoDoctor3("");
                          setApMaternoDoctor3("");
                          setTelefonoDoctor3("");
                          setEmailDoctor3("");
                        }
                        return next;
                      });
                    }}
                    startIcon={<AddIcon />}
                    sx={{
                      fontSize: "0.8vw",
                      fontWeight: "bold",
                      borderRadius: "8px",
                      padding: "0.4vw 0.8vw",
                    }}
                  >
                    Agregar doctor
                  </Button>
                </Box>
              )}
            </Paper>

            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperSelEstudios"
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="h9"
                  gutterBottom
                  sx={{
                    background: "linear-gradient(90deg, #006787, #014e65)",
                    color: "white",
                    padding: "0.5vw 1vw",
                    borderRadius: "8px",
                    display: "inline-block",
                  }}
                >
                  <Box component="span" sx={{ fontWeight: "bold" }}>
                    Seleccionar Estudios
                  </Box>{" "}
                  <Box component="span" sx={{ fontWeight: "normal" }}>
                    (Esta utilizando la lista de precios: {selectedLista ? (<Chip label={selectedLista} sx={{ backgroundColor: "#e08505", color: "white", fontWeight: "bold" }} />) : (null)})
                  </Box>
                </Typography>
              </Box>

              <Table sx={{ backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                {" "}
                <TableHead sx={{ backgroundColor: "#18234f" }}>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        borderBottom: "none",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      Info.
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        borderBottom: "none",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      Codigo
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        borderBottom: "none",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      Nombre del estudio
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        borderBottom: "none",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      Costo
                    </TableCell>
                    {opcionDescuento !== "ninguno" && (
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Descuento
                      </TableCell>
                    )}
                    {showFechaMuestraColumn && (
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Fecha de muestra
                      </TableCell>
                    )}
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        borderBottom: "none",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      Entrega
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        borderBottom: "none",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      Eliminar
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {estudios.length > 0 ? (
                    estudios.map((estudio, index) => (
                      <React.Fragment key={index}>
                        <TableRow>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <IconButton
                                onClick={() => mostrarInfo(estudio)}
                                sx={{
                                  color: "#006787",
                                  padding: 0,
                                  transition:
                                    "transform 0.2s ease, color 0.2s ease",
                                  "&:hover": {
                                    color: "#014e65",
                                    transform: "scale(1.5)",
                                  },
                                }}
                              >
                                <InfoIcon sx={{ fontSize: "1.8vw" }} />
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Autocomplete
                                options={estudiosOptions}
                                disabled={viewOnly}
                                popupIcon={null}
                                getOptionKey={(option) => option.idEstudio}
                                getOptionLabel={(option) =>
                                  (option && option.codigo) || ""
                                }
                                value={
                                  estudiosOptions.find(
                                    (o) => o.idEstudio === estudio.idEstudio,
                                  ) || null
                                }
                                onChange={(e, value) => {
                                  enrichEstudioSelection(index, value);
                                }}
                                isOptionEqualToValue={(option, value) =>
                                  option.idEstudio ===
                                  (value ? value.idEstudio : null)
                                }
                                filterOptions={(options, state) =>
                                  filterAndRankEstudios(options, state.inputValue)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    fullWidth
                                    disabled={viewOnly}
                                    sx={{
                                      width: "12vw",
                                      height: "5vh",
                                      "& .MuiInputBase-root": {
                                        height: "5vh",
                                        paddingRight: "8px !important",
                                      },
                                      "& .MuiInputBase-input": {
                                        fontSize: "1vw",
                                        paddingRight: "4px !important",
                                      },
                                      "& .MuiAutocomplete-inputRoot": {
                                        paddingRight: "8px !important",
                                      },
                                    }}
                                  />
                                )}
                              />
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Autocomplete
                                options={estudiosOptions}
                                disabled={viewOnly}
                                popupIcon={null}
                                getOptionKey={(option) => option.idEstudio}
                                getOptionLabel={(option) => {
                                  if (!option) return "";
                                  if (typeof option === "string") return option;
                                  return `${option.nombre || ""}${option.codigo ? ` (${option.codigo})` : ""}`;
                                }}
                                renderOption={(props, option) => {
                                  const { key, ...otherProps } = props;
                                  const label = option
                                    ? `${option.nombre || ""}${option.codigo ? ` (${option.codigo})` : ""}`
                                    : "";
                                  return (
                                    <li
                                      key={key || option.idEstudio}
                                      {...otherProps}
                                      style={{ fontSize: "0.9vw" }}
                                    >
                                      {label}
                                    </li>
                                  );
                                }}
                                value={
                                  estudiosOptions.find(
                                    (o) => o.idEstudio === estudio.idEstudio,
                                  ) || null
                                }
                                onChange={(e, value) => {
                                  enrichEstudioSelection(index, value);
                                }}
                                isOptionEqualToValue={(option, value) =>
                                  option.idEstudio ===
                                  (value ? value.idEstudio : null)
                                }
                                filterOptions={(options, state) =>
                                  filterAndRankEstudios(options, state.inputValue)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    fullWidth
                                    disabled={viewOnly}
                                    sx={{
                                      width: "24vw",
                                      minWidth: "24vw",
                                      height: "5vh",
                                      "& .MuiInputBase-root": {
                                        height: "5vh",
                                        paddingRight: "8px !important",
                                      },
                                      "& .MuiInputBase-input": {
                                        fontSize: "1vw",
                                        paddingRight: "4px !important",
                                      },
                                      "& .MuiAutocomplete-inputRoot": {
                                        paddingRight: "8px !important",
                                      },
                                    }}
                                    className="txfNombreEstudioInt"
                                  />
                                )}
                              />
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <span style={{ fontSize: "1.8vw", fontWeight: "bold", color: "#18234f" }}>$</span>
                              <TextField
                                value={estudio.costo}
                                disabled={viewOnly}

                                sx={{
                                  width: "5vw",
                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                  },
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",

                                  },
                                }}
                              />
                            </Box>
                          </TableCell>
                          {opcionDescuento !== "ninguno" && (
                            <TableCell>
                              <span style={{ fontSize: "1.8vw", fontWeight: "bold", color: "#18234f" }}>
                                {opcionDescuento === "porcentaje" ? "%" : "$"}
                              </span>
                              <TextField

                                sx={{

                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                    width: "4vw",
                                  },
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",
                                  },
                                }}
                                value={estudio.descuento || ""}
                                disabled={viewOnly}
                                onChange={(e) =>
                                  handleChangeEstudio(
                                    index,
                                    "descuento",
                                    e.target.value,
                                  )
                                }
                              />
                              {erroresDescuentoEstudios[index] && (
                                <Typography
                                  sx={{
                                    color: "#d32f2f",
                                    fontSize: "0.65vw",
                                    fontWeight: "bold",
                                    mt: "0.2vw",
                                    textAlign: "center",
                                  }}
                                >
                                  {erroresDescuentoEstudios[index]}
                                </Typography>
                              )}
                            </TableCell>
                          )}
                          {showFechaMuestraColumn && (
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5vw",
                                  justifyContent: "center",
                                }}
                              >
                                {Boolean(
                                  estudio.muestraPendiente ||
                                  `${estudio.fechaMuestra || ""}`.trim().toUpperCase() === "PENDIENTE",
                                ) ? (
                                  <Typography
                                    sx={{
                                      fontSize: "1vw",
                                      fontWeight: 700,
                                      textTransform: "uppercase",
                                      color: "#b8860b",
                                    }}
                                  >
                                    PENDIENTE
                                  </Typography>
                                ) : (
                                  <TextField
                                    type="date"
                                    size="small"
                                    value={formatDateForInput(estudio.fechaMuestra) || getFechaHoy()}
                                    disabled={viewOnly || !estudio.idEstudio}
                                    onChange={(e) =>
                                      handleChangeEstudio(
                                        index,
                                        "fechaMuestra",
                                        e.target.value,
                                      )
                                    }
                                    onBlur={(e) =>
                                      handleFechaMuestraBlur(index, e.target.value)
                                    }
                                    sx={{
                                      width: "10vw",
                                      height: "5vh",
                                      "& .MuiInputBase-root": { height: "5vh" },
                                      "& .MuiInputBase-input": {
                                        fontSize: "1vw",
                                      },
                                    }}
                                  />
                                )}

                              </Box>
                            </TableCell>
                          )}
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "0.2vw",
                              }}
                            >
                              {asignarFecha ? (
                                <TextField
                                  type="date"
                                  size="small"
                                  value={formatDateForInput(estudio.fechaEntrega) || ""}
                                  disabled={viewOnly || !estudio.idEstudio}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    handleChangeEstudio(index, "fechaEntrega", val);
                                  }}
                                  sx={{
                                    width: "10vw",
                                    "& .MuiInputBase-root": { height: "5vh" },
                                    "& .MuiInputBase-input": { fontSize: "1vw" },
                                  }}
                                />
                              ) : (
                                <Typography
                                  sx={{
                                    color: "#18234f",
                                    fontSize: "1vw",
                                    fontWeight: "600",
                                    textAlign: "center",
                                  }}
                                >
                                  {estudio.fechaEntrega || "—"}
                                </Typography>
                              )}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Button
                              size="large"
                              sx={{ color: "red" }}
                              disabled={
                                viewOnly ||
                                ((editMode || editModeG || selectedSolicitudId) && !esUsuarioAdmin(currentU))
                              }
                              onClick={() => handleRemoveEstudio(index)}
                            >
                              <DeleteIcon sx={{ fontSize: "1.8vw" }} />
                            </Button>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6 + (opcionDescuento !== "ninguno" ? 1 : 0) + (showFechaMuestraColumn ? 1 : 0)} align="center" sx={{ py: 4 }}>
                        No hay registros
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "0.5vw",
                }}
              >
                <IconButton sx={{ color: "#006787" }} disabled={viewOnly} onClick={addEstudio}>
                  Añadir estudio
                  <AddIcon />
                </IconButton>
              </Box>
              <Stack
                direction="row"
                spacing={"10vw"}
                sx={{ paddingTop: "4vw" }}
              >
                <Table sx={{ backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                  {" "}
                  <TableHead sx={{ backgroundColor: "#18234f" }}>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Entrega de resultados
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <FormControl>
                          <RadioGroup
                            column
                            name="entregaResultados"
                            value={modoEntrega}
                            onChange={(e) => {
                              const val = e.target.value;
                              setModoEntrega(val);
                              setAsignarFecha(val === "asignarFecha");
                              if (val === "normal") {
                                setFechaGlobal("");
                                setEstudios((prev) =>
                                  prev.map((est) => ({
                                    ...est,
                                    fechaEntrega: est.idEstudio ? calcularFechaEntrega(est.tiempoEntrega) : "",
                                    urgente: false,
                                  }))
                                );
                              }
                            }}
                            disabled={viewOnly}
                          >
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                },
                              }}
                              value="asignarFecha"
                              control={
                                <Radio
                                  disabled={viewOnly}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="Asignar Fecha"
                            />
                            {modoEntrega === "asignarFecha" && (
                              <TextField
                                type="date"
                                size="small"
                                disabled={viewOnly}
                                value={fechaGlobal}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  setFechaGlobal(val);
                                  setEstudios((prev) =>
                                    prev.map((est) => ({
                                      ...est,
                                      fechaEntrega: est.idEstudio ? val : "",
                                      urgente: est.idEstudio ? true : false,
                                    }))
                                  );
                                }}
                                sx={{
                                  mt: "0.3vw",
                                  mb: "0.5vw",
                                  "& .MuiInputBase-root": { height: "2vw" },
                                  "& .MuiInputBase-input": { fontSize: "0.75vw" },
                                }}
                              />
                            )}
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                },
                              }}
                              value="normal"
                              control={
                                <Radio
                                  disabled={viewOnly}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="Normal"
                            />
                          </RadioGroup>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                <Table sx={{ backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                  {" "}
                  <TableHead sx={{ backgroundColor: "#18234f" }}>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Descuento general solicitud
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ backgroundColor: "#f8f9fa", borderBottom: "1px solid #ddd" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={requiereFactura}
                              disabled={viewOnly}
                              onChange={(e) => setRequiereFactura(e.target.checked)}
                              sx={{
                                color: "#18234f",
                                "&.Mui-checked": { color: "#006787" },
                              }}
                            />
                          }
                          label={
                            <Typography sx={{ fontWeight: "bold", fontSize: "1vw", color: "#18234f" }}>
                              ¿Requiere factura? (IVA 16%)
                            </Typography>
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <FormControl>
                          <RadioGroup row
                            disabled={viewOnly}
                            value={opcionDescuento}
                            onChange={(e) =>
                              handleChangeOpcionDescuento(e.target.value)
                            }
                          >
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                },
                              }}
                              value="porcentaje"
                              control={
                                <Radio
                                  disabled={viewOnly}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="Porcentaje"
                            />
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                },
                              }}
                              value="cantidad"
                              control={
                                <Radio
                                  disabled={viewOnly}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="Cantidad"
                            />
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                },
                              }}
                              value="ninguno"
                              control={
                                <Radio
                                  disabled={viewOnly}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="Ninguno"
                            />
                          </RadioGroup>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      {opcionDescuento !== "ninguno" && (
                        <TableCell>
                          <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                              <Typography
                                sx={{
                                  backgroundColor: "#172149",
                                  width: "10vw",
                                  color: "white",
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                  padding: "0.3vw 0.5vw",
                                  borderRadius: "6px",
                                  textAlign: "center",
                                  marginBottom: "0.5vw",
                                }}
                              >
                                {opcionDescuento === "cantidad"
                                  ? "Coloque cantidad a descontar:"
                                  : "Coloque porcentaje general:"}
                              </Typography>
                              <TextField
                                value={valorGeneralMostrado}
                                disabled={viewOnly}
                                onChange={(e) =>
                                  handleChangeValorGeneral(e.target.value)
                                }
                                InputProps={{
                                  [opcionDescuento === "porcentaje" ? "endAdornment" : "startAdornment"]: (
                                    <InputAdornment position={opcionDescuento === "porcentaje" ? "end" : "start"}>
                                      {opcionDescuento === "porcentaje" ? "%" : "$"}
                                    </InputAdornment>
                                  ),
                                }}
                                sx={{
                                  width: "11vw",
                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                  },
                                  "& .MuiInputBase-input": {
                                    textAlign: "center",
                                    fontSize: "1vw",
                                  },
                                }}
                              />
                              {errorDescuentoGeneral && (
                                <Typography
                                  sx={{
                                    color: "#d32f2f",
                                    fontSize: "0.75vw",
                                    fontWeight: "bold",
                                    mt: "0.3vw",
                                    textAlign: "center",
                                    maxWidth: "11vw",
                                  }}
                                >
                                  {errorDescuentoGeneral}
                                </Typography>
                              )}
                            </Box>
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                              <Typography
                                sx={{
                                  backgroundColor: "#172149",
                                  width: "10vw",
                                  color: "white",
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                  padding: "0.3vw 0.5vw",
                                  borderRadius: "6px",
                                  textAlign: "center",
                                  marginBottom: "0.5vw",

                                }}
                              >
                                Motivo del descuento:
                              </Typography>
                              <TextField
                                value={motivoDescuento}
                                disabled={viewOnly}
                                onChange={(e) => setMotivoDescuento(e.target.value)}
                                sx={{
                                  width: "11vw",
                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                  },
                                  "& .MuiInputBase-input": {
                                    textAlign: "center",
                                    fontSize: "1vw",
                                  },
                                }}
                              />
                            </Box>
                          </Box>
                        </TableCell>
                      )}
                    </TableRow>
                  </TableBody>
                </Table>
                <Table sx={{ backgroundColor: "white", tableLayout: "fixed", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                  <TableBody>
                    <>
                      {showEstadoRow && (
                        <TableRow>
                          <TableCell
                            sx={{
                              backgroundColor: "#18234f",
                              color: "white",
                              fontWeight: "bold",
                            }}
                          >
                            Estado
                          </TableCell>
                          <TableCell>{solicitudEstatusLabel}</TableCell>
                        </TableRow>
                      )}
                      <TableRow>
                        <TableCell
                          sx={{
                            backgroundColor: "#18234f",
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          Subtotal
                        </TableCell>
                        <TableCell>$ {subtotalResumen.toFixed(2)}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            backgroundColor: "#18234f",
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          Descuento
                        </TableCell>
                        <TableCell>$ {descuentoResumen.toFixed(2)}</TableCell>
                      </TableRow>
                      {requiereFactura && (
                        <TableRow>
                          <TableCell
                            sx={{
                              backgroundColor: "#18234f",
                              color: "white",
                              fontWeight: "bold",
                            }}
                          >
                            IVA (16%)
                          </TableCell>
                          <TableCell>$ {ivaResumen.toFixed(2)}</TableCell>
                        </TableRow>
                      )}
                      <TableRow>
                        <TableCell
                          sx={{
                            backgroundColor: "#18234f",
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          Total
                        </TableCell>
                        <TableCell>$ {totalResumen.toFixed(2)}</TableCell>
                      </TableRow>
                      {showExtendedTotals && (
                        <>
                          <TableRow>
                            <TableCell
                              sx={{
                                backgroundColor: "#18234f",
                                color: "white",
                                fontWeight: "bold",
                              }}
                            >
                              Pagado
                            </TableCell>
                            <TableCell>$ {aCuentaMonto.toFixed(2)}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              sx={{
                                backgroundColor: "#18234f",
                                color: "white",
                                fontWeight: "bold",
                              }}
                            >
                              Adeudo
                            </TableCell>
                            <TableCell>$ {restanteMonto.toFixed(2)}</TableCell>
                          </TableRow>
                        </>
                      )}
                    </>
                  </TableBody>
                </Table>
              </Stack>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "3vw",
                }}
              >
                <Typography
                  variant="h9"
                  gutterBottom
                  sx={{
                    background: "linear-gradient(90deg, #006787, #014e65)",
                    color: "white",
                    padding: "0.5vw 1vw",
                    borderRadius: "8px",
                    display: "inline-block",
                    whiteSpace: "pre-line",
                    textAlign: "center",
                  }}
                >
                  <Box
                    component="span"
                    sx={{ fontWeight: "bold", justifyContent: "center" }}
                  >
                    Notas adicionales que desee agregar a la solicitud
                  </Box>
                  <br />
                  <Box component="span" sx={{ fontWeight: "normal" }}>
                    (Se mostrarán en la Orden de Trabajo y en el modulo de
                    reporte de resultados)
                  </Box>
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "3vw",
                }}
              >
                <TextField
                  fullWidth
                  onChange={(e) =>
                    setNotas(e.target.value)}
                  disabled={viewOnly}
                  value={notas}
                  multiline
                  minRows={1}
                  maxRows={4}
                  sx={{

                    "& .MuiInputBase-root": {},
                    "& .MuiInputBase-input": {
                      fontSize: "1vw",
                    },
                  }}
                />
              </Box>
            </Paper>
          </Stack>
        </Box>
        <Box
          sx={{
            position: "fixed",
            right: "6vw",
            top: "30%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {!viewOnly && (
            <Tooltip
              title={"Guardar solicitud"}
              arrow
              placement="right"
              slotProps={{
                popper: {
                  sx: {
                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                    {
                      marginTop: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                    {
                      marginBottom: "0.2vw",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                    {
                      marginLeft: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                    {
                      marginRight: "0px",
                    },
                  },
                },
                tooltip: {
                  sx: {
                    fontSize: "0.7vw",
                    padding: "0.5vw 0.5vw",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    fontWeight: "bold",
                    color: "#000000",
                    marginBottom: "-5px",
                  },
                },
                arrow: {
                  sx: {
                    color: "rgba(255,255,255,0.9)",
                  },
                },
              }}
            >
              <IconButton
                disabled={Boolean(errorDescuentoGeneral || erroresDescuentoEstudios.some(Boolean))}
                onClick={agregarSolicitud}
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#18234f",
                  "&:hover": { backgroundColor: "#d1d1d1" },
                  "&.Mui-disabled": { backgroundColor: "#e0e0e0", color: "#9e9e9e" },
                  width: "4vw",
                  height: "4vw",
                }}
              >
                <SaveIcon sx={{ fontSize: "1.8vw" }} />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip
            title={"Nueva solicitud"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
              onClick={reloadPage}
            >
              <AddIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
          <Tooltip
            title={"Buscar solicitud"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              onClick={mostrarBuscarSolicitudes}
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
            >
              <SearchIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>

          {/* Menú deslizante de Imprimir hacia la izquierda */}
          {((editModeG || viewOnly) && selectedSolicitudId) && (
            <Box
              onMouseEnter={() => setHoverImprimirMenu(true)}
              onMouseLeave={() => setHoverImprimirMenu(false)}
              sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              {/* Sub-botones horizontales desplegables hacia la izquierda */}
              <Box
                sx={{
                  position: "absolute",
                  right: "100%",
                  paddingRight: "0.8vw",
                  display: "flex",
                  flexDirection: "row",
                  gap: 1.5,
                  alignItems: "center",
                  opacity: hoverImprimirMenu ? 1 : 0,
                  visibility: hoverImprimirMenu ? "visible" : "hidden",
                  transform: hoverImprimirMenu ? "translateX(0)" : "translateX(15px)",
                  transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                  pointerEvents: hoverImprimirMenu ? "auto" : "none",
                  zIndex: 1300,
                }}
              >

                {/* 3. Generar etiquetas (Icono Código de Barras / QR) */}
                <Tooltip
                  title={"Generar etiquetas"}
                  arrow
                  placement="top"
                  slotProps={{
                    popper: {
                      sx: {
                        [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]: {
                          marginBottom: "0.2vw",
                        },
                      },
                    },
                    tooltip: {
                      sx: {
                        fontSize: "0.7vw",
                        padding: "0.5vw 0.5vw",
                        borderRadius: "8px",
                        backgroundColor: "rgba(255,255,255,0.9)",
                        fontWeight: "bold",
                        color: "#000000",
                        marginBottom: "-5px",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "rgba(255,255,255,0.9)",
                      },
                    },
                  }}
                >
                  <IconButton
                    onClick={handleGenerarEtiquetas}
                    sx={{
                      backgroundColor: "#ffffff",
                      color: "#18234f",
                      "&:hover": { backgroundColor: "#d1d1d1" },
                      width: "4vw",
                      height: "4vw",
                      boxShadow: "0px 3px 6px rgba(0,0,0,0.16)",
                    }}
                  >
                    <BarcodeIcon sx={{ fontSize: "1.8vw" }} />
                  </IconButton>
                </Tooltip>

                {/* 2. Enviar ticket (Icono WhatsApp) */}
                <Tooltip
                  title={"Enviar ticket"}
                  arrow
                  placement="top"
                  slotProps={{
                    popper: {
                      sx: {
                        [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]: {
                          marginBottom: "0.2vw",
                        },
                      },
                    },
                    tooltip: {
                      sx: {
                        fontSize: "0.7vw",
                        padding: "0.5vw 0.5vw",
                        borderRadius: "8px",
                        backgroundColor: "rgba(255,255,255,0.9)",
                        fontWeight: "bold",
                        color: "#000000",
                        marginBottom: "-5px",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "rgba(255,255,255,0.9)",
                      },
                    },
                  }}
                >
                  <IconButton
                    onClick={handleEnviarTicketWhatsApp}
                    sx={{
                      backgroundColor: "#ffffff",
                      color: "#25D366",
                      "&:hover": { backgroundColor: "#d1d1d1" },
                      width: "4vw",
                      height: "4vw",
                      boxShadow: "0px 3px 6px rgba(0,0,0,0.16)",
                    }}
                  >
                    <WhatsAppIcon sx={{ fontSize: "1.8vw" }} />
                  </IconButton>
                </Tooltip>

                {/* 1. Imprimir solicitud (Mismo icono de Imprimir) */}
                <Tooltip
                  title={"Imprimir solicitud"}
                  arrow
                  placement="top"
                  slotProps={{
                    popper: {
                      sx: {
                        [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]: {
                          marginBottom: "0.2vw",
                        },
                      },
                    },
                    tooltip: {
                      sx: {
                        fontSize: "0.7vw",
                        padding: "0.5vw 0.5vw",
                        borderRadius: "8px",
                        backgroundColor: "rgba(255,255,255,0.9)",
                        fontWeight: "bold",
                        color: "#000000",
                        marginBottom: "-5px",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "rgba(255,255,255,0.9)",
                      },
                    },
                  }}
                >
                  <IconButton
                    onClick={handleImprimirSolicitud}
                    sx={{
                      backgroundColor: "#ffffff",
                      color: "#18234f",
                      "&:hover": { backgroundColor: "#d1d1d1" },
                      width: "4vw",
                      height: "4vw",
                      boxShadow: "0px 3px 6px rgba(0,0,0,0.16)",
                    }}
                  >
                    <PrintIcon sx={{ fontSize: "1.8vw" }} />
                  </IconButton>
                </Tooltip>
              </Box>

              {/* Botón Principal de Imprimir */}

              <IconButton
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#18234f",
                  "&:hover": { backgroundColor: "#d1d1d1" },
                  width: "4vw",
                  height: "4vw",
                }}
              >
                <PrintIcon sx={{ fontSize: "1.8vw" }} />
              </IconButton>

            </Box>
          )}
          {(!esSolicitudPagada) && !esEstatusSoloLectura(solicitudEstatus) && (viewOnly || editModeG) ? (
            <Tooltip
              title={"Pagar solicitud"}
              arrow
              placement="right"
              slotProps={{
                popper: {
                  sx: {
                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                    {
                      marginTop: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                    {
                      marginBottom: "0.2vw",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                    {
                      marginLeft: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                    {
                      marginRight: "0px",
                    },
                  },
                },
                tooltip: {
                  sx: {
                    fontSize: "0.7vw",
                    padding: "0.5vw 0.5vw",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    fontWeight: "bold",
                    color: "#000000",
                    marginBottom: "-5px",
                  },
                },
                arrow: {
                  sx: {
                    color: "rgba(255,255,255,0.9)",
                  },
                },
              }}
            >
              <IconButton
                onClick={handlePagarSolicitud}
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#18234f",
                  "&:hover": { backgroundColor: "#d1d1d1" },
                  width: "4vw",
                  height: "4vw",
                }}
              >
                <AttachMoneyIcon sx={{ fontSize: "1.8vw" }} />
              </IconButton>
            </Tooltip>
          ) : null}
          {cancelMode && !esEstatusSoloLectura(solicitudEstatus) ? (
            <Tooltip
              title={"Cancelar solicitud"}
              arrow
              placement="right"
              slotProps={{
                popper: {
                  sx: {
                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                    {
                      marginTop: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                    {
                      marginBottom: "0.2vw",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                    {
                      marginLeft: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                    {
                      marginRight: "0px",
                    },
                  },
                },
                tooltip: {
                  sx: {
                    fontSize: "0.7vw",
                    padding: "0.5vw 0.5vw",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    fontWeight: "bold",
                    color: "#000000",
                    marginBottom: "-5px",
                  },
                },
                arrow: {
                  sx: {
                    color: "rgba(255,255,255,0.9)",
                  },
                },
              }}
            >
              <IconButton
                onClick={handleCancelarSolicitud}
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#18234f",
                  "&:hover": { backgroundColor: "#d1d1d1" },
                  width: "4vw",
                  height: "4vw",
                }}
              >
                <DoDisturbAltIcon sx={{ fontSize: "1.8vw" }} />
              </IconButton>
            </Tooltip>
          ) : null}

          {(editMode || viewOnly) && selectedSolicitudId ? (
            <Tooltip
              title={"Historial"}
              arrow
              placement="right"
              slotProps={{
                popper: {
                  sx: {
                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                    {
                      marginTop: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                    {
                      marginBottom: "0.2vw",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                    {
                      marginLeft: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                    {
                      marginRight: "0px",
                    },
                  },
                },
                tooltip: {
                  sx: {
                    fontSize: "0.7vw",
                    padding: "0.5vw 0.5vw",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    fontWeight: "bold",
                    color: "#000000",
                    marginBottom: "-5px",
                  },
                },
                arrow: {
                  sx: {
                    color: "rgba(255,255,255,0.9)",
                  },
                },
              }}
            >
              <IconButton
                onClick={abrirModalSeleccionHistorial}
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#18234f",
                  "&:hover": { backgroundColor: "#d1d1d1" },
                  width: "4vw",
                  height: "4vw",
                }}
              >
                <HistoryIcon sx={{ fontSize: "1.8vw" }} />
              </IconButton>
            </Tooltip>
          ) : null}

        </Box>
      </Content>
    </Layout>
  );
};
export default Solicitudes;